import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Action = {
  created_at: Scalars['Int'];
  id: Scalars['ID'];
  user_id?: Maybe<Scalars['ID']>;
  group_id?: Maybe<Scalars['ID']>;
  display: ActionDisplay;
};

export type ActionDisplay = {
  message: Scalars['String'];
  substitutions: ActionDisplayParams;
  urls: ActionDisplayParams;
};

export type ActionDisplayParams = {
  actor: Scalars['String'];
  adjective: Scalars['String'];
};

export type Actions = {
  results?: Maybe<Array<Maybe<Action>>>;
  id_lt?: Maybe<Scalars['String']>;
};

export type AdminUpdateClientInput = {
  id: Scalars['ID'];
  email_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  content_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  email_address?: Maybe<Scalars['String']>;
  client_url?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  client_state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type AllowedCounts = {
  twitter?: Maybe<Scalars['Int']>;
  facebook?: Maybe<Scalars['Int']>;
  linkedin?: Maybe<Scalars['Int']>;
  xing?: Maybe<Scalars['Int']>;
};

export enum AuthenticationType {
  Auth = 'auth',
  Sso = 'sso',
}

export type Client = {
  id: Scalars['ID'];
  title: Scalars['String'];
  subdomain?: Maybe<Scalars['String']>;
  email_sending_domain?: Maybe<Scalars['String']>;
  email_from_address?: Maybe<Scalars['String']>;
  email_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  content_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  email_address?: Maybe<Scalars['String']>;
  client_status: ClientStatus;
  authentication_type: AuthenticationType;
  sso_configuration?: Maybe<SsoConfiguration>;
  sso_provider?: Maybe<Scalars['String']>;
  allow_user_invites: Scalars['Boolean'];
  allow_user_signup: Scalars['Boolean'];
  allow_group_creation: Scalars['Boolean'];
  allow_group_discovery: Scalars['Boolean'];
  departments_in_signup: Scalars['Boolean'];
  departments_in_signup_required: Scalars['Boolean'];
  locations_in_signup: Scalars['Boolean'];
  locations_in_signup_required: Scalars['Boolean'];
  support_multiple_languages: Scalars['Boolean'];
  allow_user_share_commentary: Scalars['Boolean'];
  disable_timeline: Scalars['Boolean'];
  disable_comments: Scalars['Boolean'];
  client_url?: Maybe<Scalars['String']>;
  default_timezone?: Maybe<Scalars['String']>;
  default_language?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  client_state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  image?: Maybe<S3Object>;
  salesforce_enabled?: Maybe<Scalars['Boolean']>;
  salesforce_bcc_email?: Maybe<Scalars['String']>;
  adobe_integration_code?: Maybe<Scalars['String']>;
  adobe_api_url?: Maybe<Scalars['String']>;
  url_tracking_force_defaults?: Maybe<Scalars['Boolean']>;
  url_tracking_feature?: Maybe<Scalars['Boolean']>;
  url_tracking_enabled?: Maybe<Scalars['Boolean']>;
  utm_source_override?: Maybe<Scalars['String']>;
  utm_medium_override?: Maybe<Scalars['String']>;
  terms_and_conditions_enabled?: Maybe<Scalars['Boolean']>;
  terms_and_conditions?: Maybe<Scalars['String']>;
  terms_and_conditions_url?: Maybe<Scalars['String']>;
  privacy_policy_enabled?: Maybe<Scalars['Boolean']>;
  privacy_policy?: Maybe<Scalars['String']>;
  privacy_policy_url?: Maybe<Scalars['String']>;
  social_media_policy_enabled?: Maybe<Scalars['Boolean']>;
  social_media_policy?: Maybe<Scalars['String']>;
  social_media_policy_url?: Maybe<Scalars['String']>;
  created_at: Scalars['Int'];
  updated_at: Scalars['Int'];
  added_by_user_id: Scalars['ID'];
};

export type ClientDepartment = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  title: Scalars['String'];
  department_status: ClientDepartmentStatus;
  groups_total?: Maybe<Scalars['Int']>;
  profiles_total?: Maybe<Scalars['Int']>;
};

export type ClientDepartmentList = {
  client_departments?: Maybe<Array<Maybe<ClientDepartment>>>;
  count: Scalars['Int'];
  paginate: Scalars['Boolean'];
  title_lower?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type ClientDepartmentListInput = {
  title_lower?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Boolean']>;
};

/** Client departments */
export enum ClientDepartmentStatus {
  Active = 'active',
  Disabled = 'disabled',
}

export type ClientDepartmentStatusList = {
  client_departments?: Maybe<Array<Maybe<ClientDepartment>>>;
  count: Scalars['Int'];
  paginate: Scalars['Boolean'];
  department_status?: Maybe<ClientDepartmentStatus>;
  title?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type ClientDepartmentStatusListInput = {
  department_status: ClientDepartmentStatus;
  title?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Boolean']>;
};

export type ClientDisclosure = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  title: Scalars['String'];
  disclosure: Scalars['String'];
  disclosure_status: ClientDisclosureStatus;
};

export enum ClientDisclosureStatus {
  Active = 'active',
  Disabled = 'disabled',
}

export type ClientEngagementStat = {
  comments: Scalars['Int'];
  reactions: Scalars['Int'];
  posts: Scalars['Int'];
  groups: Scalars['Int'];
  users: Scalars['Int'];
};

export type ClientFollowMapping = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  title: Scalars['String'];
  mapping_status: ClientFollowMappingStatus;
  follow_conditions?: Maybe<FollowConditions>;
  all_users?: Maybe<Scalars['Boolean']>;
  required_groups?: Maybe<Array<Maybe<Group>>>;
  suggested_groups?: Maybe<Array<Maybe<Group>>>;
  required_users?: Maybe<Array<Maybe<PublicUserProfile>>>;
  suggested_users?: Maybe<Array<Maybe<PublicUserProfile>>>;
  created_at: Scalars['Int'];
  updated_at: Scalars['Int'];
};

export type ClientFollowMappingList = {
  client_follow_mappings?: Maybe<Array<Maybe<ClientFollowMapping>>>;
  count: Scalars['Int'];
  paginate: Scalars['Boolean'];
  title_lower?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type ClientFollowMappingListInput = {
  title_lower?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Boolean']>;
};

/** Client follow mappings */
export enum ClientFollowMappingStatus {
  Active = 'active',
  Disabled = 'disabled',
}

export type ClientFollowMappingStatusList = {
  client_follow_mappings?: Maybe<Array<Maybe<ClientFollowMapping>>>;
  count: Scalars['Int'];
  paginate: Scalars['Boolean'];
  mapping_status?: Maybe<ClientDepartmentStatus>;
  title?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type ClientFollowMappingStatusListInput = {
  mapping_status: ClientFollowMappingStatus;
  title?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Boolean']>;
};

export type ClientGroupSource = {
  id: Scalars['ID'];
  parent_id?: Maybe<Scalars['ID']>;
  client_id: Scalars['ID'];
  user_id: Scalars['ID'];
  group_id: Scalars['ID'];
  source_type: GroupSourceType;
  source_status: SourceStatus;
  source_value: Scalars['String'];
  created_at: Scalars['Int'];
  last_processed_at?: Maybe<Scalars['Int']>;
  processing_started_at?: Maybe<Scalars['Int']>;
  approval?: Maybe<ContentApproval>;
  disclosures?: Maybe<Array<Maybe<ContentDisclosures>>>;
};

export type ClientGroupSourceUpdate = {
  id: Scalars['ID'];
  source_status?: Maybe<SourceStatus>;
  approval?: Maybe<ContentApproval>;
};

export type ClientInvitation = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  email_address: Scalars['String'];
  invitation_status: ClientInvitationStatus;
  subject?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  email_from_address?: Maybe<Scalars['String']>;
  created_at: Scalars['Int'];
  updated_at: Scalars['Int'];
  added_by_user_id?: Maybe<Scalars['ID']>;
  added_by_user?: Maybe<PublicUserProfile>;
  last_sent_at?: Maybe<Scalars['Int']>;
  retries?: Maybe<Scalars['Int']>;
  accepted_at?: Maybe<Scalars['Int']>;
  accepted_by_user_id?: Maybe<Scalars['ID']>;
  accepted_by_user?: Maybe<PublicUserProfile>;
};

export type ClientInvitationsClientList = {
  client_invitations?: Maybe<Array<Maybe<ClientInvitation>>>;
  count: Scalars['Int'];
  paginate: Scalars['Boolean'];
  invitation_status: ClientInvitationStatus;
  client_id: Scalars['ID'];
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
};

export type ClientInvitationsClientListInput = {
  count?: Maybe<Scalars['Boolean']>;
  invitation_status: ClientInvitationStatus;
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
};

/** Client invitations */
export enum ClientInvitationStatus {
  Active = 'active',
  Accepted = 'accepted',
}

export type ClientLocation = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  title: Scalars['String'];
  location_status: ClientLocationStatus;
  groups_total?: Maybe<Scalars['Int']>;
  profiles_total?: Maybe<Scalars['Int']>;
};

export type ClientLocationList = {
  client_locations?: Maybe<Array<Maybe<ClientLocation>>>;
  count: Scalars['Int'];
  paginate: Scalars['Boolean'];
  title_lower?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type ClientLocationListInput = {
  title_lower?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Boolean']>;
};

/** Client locations */
export enum ClientLocationStatus {
  Active = 'active',
  Disabled = 'disabled',
}

export type ClientLocationStatusList = {
  client_locations?: Maybe<Array<Maybe<ClientLocation>>>;
  count: Scalars['Int'];
  paginate: Scalars['Boolean'];
  location_status?: Maybe<ClientLocationStatus>;
  title?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type ClientLocationStatusListInput = {
  location_status: ClientLocationStatus;
  title?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Boolean']>;
};

export enum ClientStatus {
  Active = 'active',
  Disabled = 'disabled',
}

export type ClientTrendingData = {
  posts: Scalars['Int'];
  clicks: Scalars['Int'];
  shares: Scalars['Int'];
  users: Scalars['Int'];
  calendar_day: Scalars['String'];
};

export type ClientTrendingEngagementStat = {
  total_posts: Scalars['Int'];
  total_shares: Scalars['Int'];
  total_clicks: Scalars['Int'];
  total_users: Scalars['Int'];
  data: Array<Maybe<ClientTrendingData>>;
};

export type ClientUrlParams = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  params_status: ParamsStatus;
  content_domain: Scalars['String'];
  configuration?: Maybe<Array<Maybe<ClientUrlParamsConfiguration>>>;
};

export type ClientUrlParamsConfiguration = {
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  dynamic_value?: Maybe<ClientUrlParamsDynamicValues>;
  value_options?: Maybe<Array<Maybe<Scalars['String']>>>;
  default_option_value?: Maybe<Scalars['String']>;
};

export type ClientUrlParamsConfigurationInput = {
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  dynamic_value?: Maybe<ClientUrlParamsDynamicValues>;
  value_options?: Maybe<Array<Maybe<Scalars['String']>>>;
  default_option_value?: Maybe<Scalars['String']>;
};

export enum ClientUrlParamsDynamicValues {
  User = 'user',
  Network = 'network',
  ShareId = 'share_id',
}

export type ClientUrlParamsUpdateInput = {
  id: Scalars['ID'];
  params_status?: Maybe<ParamsStatus>;
  configuration?: Maybe<Array<Maybe<ClientUrlParamsConfigurationInput>>>;
};

export type Comment = {
  id: Scalars['ID'];
  parent_id?: Maybe<Scalars['ID']>;
  object_type: ObjectType;
  object_id: Scalars['ID'];
  user_id: Scalars['ID'];
  user?: Maybe<PublicUserProfile>;
  comment_text: Scalars['String'];
  depth: Scalars['Int'];
  comment_status: CommentStatus;
  has_substitutions: Scalars['Boolean'];
  created_at: Scalars['Int'];
  updated_at: Scalars['Int'];
  user_mentions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users_mentioned?: Maybe<Array<Maybe<PublicUserProfile>>>;
};

export type CommentInput = {
  parent_id?: Maybe<Scalars['ID']>;
  object_type: ObjectType;
  object_id: Scalars['ID'];
  comment_text: Scalars['String'];
};

export type CommentsList = {
  count: Scalars['Int'];
  comments?: Maybe<Array<Maybe<Comment>>>;
  object_type: ObjectType;
  object_id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  paginate: Scalars['Boolean'];
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
};

/** Comments fields */
export enum CommentStatus {
  Active = 'active',
  Removed = 'removed',
  Deleted = 'deleted',
}

export type CommentStatusInput = {
  object_type: ObjectType;
  object_id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Boolean']>;
};

export type CommentUpdateInput = {
  id: Scalars['ID'];
  comment_text: Scalars['String'];
};

export type CommentUserInput = {
  user_id: Scalars['ID'];
  comment_status: CommentStatus;
  limit?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Boolean']>;
};

export type Content = {
  user_id?: Maybe<Scalars['ID']>;
  client_id: Scalars['ID'];
  group_ids: Array<Maybe<Scalars['ID']>>;
  group_id_approvals: Array<Maybe<GroupIdApproval>>;
  approval?: Maybe<ContentApproval>;
  content_id: Scalars['ID'];
  content_source_id?: Maybe<Scalars['ID']>;
  created_at: Scalars['Int'];
  publish_at: Scalars['Int'];
  content_object: ContentObject;
  audit?: Maybe<Array<Maybe<ContentAudit>>>;
  user?: Maybe<PublicUserProfile>;
  reactions?: Maybe<ContentReactions>;
  comments?: Maybe<CommentsList>;
  groups?: Maybe<Array<Maybe<Group>>>;
  is_pinned?: Maybe<Scalars['Boolean']>;
  pinned_end_at?: Maybe<Scalars['Int']>;
  is_engage?: Maybe<Scalars['Boolean']>;
  is_important?: Maybe<Scalars['Boolean']>;
  is_branded?: Maybe<Scalars['Boolean']>;
  is_shareable?: Maybe<Scalars['Boolean']>;
  important_to_share?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  sharing_count?: Maybe<Scalars['Int']>;
  share_count?: Maybe<Scalars['Int']>;
  has_requesting_user_shared?: Maybe<Scalars['Boolean']>;
  engagement_count?: Maybe<Scalars['Int']>;
  click_count?: Maybe<Scalars['Int']>;
  disclosures?: Maybe<Array<Maybe<ContentDisclosures>>>;
  commentary?: Maybe<Array<Maybe<ContentCommentary>>>;
  network_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_param_options?: Maybe<Array<Maybe<ContentUrlParamOptions>>>;
  url_param_values?: Maybe<Array<Maybe<ContentUrlParamValues>>>;
};

export enum ContentApproval {
  Approved = 'approved',
  Autoapproved = 'autoapproved',
  Deleted = 'deleted',
  Removed = 'removed',
  Submitted = 'submitted',
  Pending = 'pending',
}

export type ContentApprovalsInput = {
  group_id_approvals: Array<Maybe<GroupIdApprovalInput>>;
  message?: Maybe<Scalars['String']>;
};

export type ContentAudit = {
  ACTION: Scalars['String'];
  time?: Maybe<Scalars['Int']>;
};

export type ContentCommentary = {
  network: Network;
  commentary: Scalars['String'];
};

export type ContentCommentaryInput = {
  network: Network;
  commentary: Scalars['String'];
};

export type ContentDisclosures = {
  network: Network;
  disclosure_id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  disclosure?: Maybe<Scalars['String']>;
  disclosure_status?: Maybe<ClientDisclosureStatus>;
};

export type ContentDisclosuresInput = {
  network: Network;
  disclosure_id: Scalars['ID'];
};

export type ContentInput = {
  group_ids: Array<Maybe<Scalars['ID']>>;
  content_object?: Maybe<ContentObjectInput>;
  content_id?: Maybe<Scalars['ID']>;
  content_source_id: Scalars['ID'];
  created_at?: Maybe<Scalars['Int']>;
  publish_at?: Maybe<Scalars['Int']>;
  is_pinned?: Maybe<Scalars['Boolean']>;
  pinned_end_at?: Maybe<Scalars['Int']>;
  is_important?: Maybe<Scalars['Boolean']>;
  is_shareable?: Maybe<Scalars['Boolean']>;
  disclosures?: Maybe<Array<Maybe<ContentDisclosuresInput>>>;
  commentary?: Maybe<Array<Maybe<ContentCommentaryInput>>>;
  network_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_param_values?: Maybe<Array<Maybe<ContentUrlParamValuesInput>>>;
};

export type ContentObject = {
  post_type: PostType;
  content_hash?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  photos?: Maybe<Array<Maybe<S3Object>>>;
  media?: Maybe<MediaObject>;
  media_type?: Maybe<Scalars['String']>;
  video_url?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  metadata_keys?: Maybe<Array<Maybe<MetadataKey>>>;
  url_metadata?: Maybe<UrlMetadata>;
  tweet_metadata?: Maybe<TweetMetadata>;
  youtube_metadata?: Maybe<YoutubeMetadata>;
  instagram_metadata?: Maybe<InstagramMetadata>;
  reddit_metadata?: Maybe<RedditMetadata>;
};

export type ContentObjectInput = {
  post_type: PostType;
  content_hash?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  photos?: Maybe<Array<Maybe<S3ObjectInput>>>;
  media?: Maybe<MediaObjectInput>;
  video_url?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  metadata_keys?: Maybe<Array<Maybe<MetadataKey>>>;
  url_metadata?: Maybe<UrlMetadataInput>;
  tweet_metadata?: Maybe<TweetMetadataInput>;
  youtube_metadata?: Maybe<YoutubeMetadataInput>;
  instagram_metadata?: Maybe<InstagramMetadataInput>;
  reddit_metadata?: Maybe<RedditMetadataInput>;
};

export type ContentReactions = {
  reaction_count?: Maybe<ReactionCount>;
  user_reactions?: Maybe<Array<Maybe<ReactionType>>>;
  reaction_user_details?: Maybe<Array<Maybe<PublicUserProfile>>>;
};

export type ContentSharePreview = {
  disclosures: Array<ContentDisclosures>;
  networks: Array<SocialAccount>;
  commentary: Array<ContentCommentary>;
  previous_shares: Array<PreviousShareItem>;
  photos: Array<Maybe<S3Object>>;
  urlMetadata?: Maybe<UrlMetadata>;
  allowed_counts?: Maybe<AllowedCounts>;
  suggested_commentary: Array<ContentCommentary>;
  scheduled_shares: Array<ScheduledShareItem>;
  suggested_share_time?: Maybe<Scalars['Int']>;
  shortened_urls?: Maybe<ShortenedUrLs>;
};

export type ContentUrlParamOptions = {
  key: Scalars['String'];
  options: Array<Maybe<Scalars['String']>>;
  default_option_value?: Maybe<Scalars['String']>;
};

export type ContentUrlParamValues = {
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ContentUrlParamValuesInput = {
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type CreateClientDepartmentInput = {
  title: Scalars['String'];
  department_status: ClientDepartmentStatus;
};

export type CreateClientFollowMappingInput = {
  title: Scalars['String'];
  mapping_status: ClientFollowMappingStatus;
  follow_conditions?: Maybe<FollowConditionsInput>;
  all_users: Scalars['Boolean'];
  required_group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  suggested_group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  required_user_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  suggested_user_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type CreateClientInput = {
  title: Scalars['String'];
  subdomain: Scalars['String'];
  email_sending_domain?: Maybe<Scalars['String']>;
  email_from_address?: Maybe<Scalars['String']>;
  email_domains: Array<Maybe<Scalars['String']>>;
  content_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  email_address: Scalars['String'];
  client_status: ClientStatus;
  authentication_type: AuthenticationType;
  sso_configuration?: Maybe<SsoConfigurationInput>;
  sso_provider?: Maybe<Scalars['String']>;
  allow_user_invites: Scalars['Boolean'];
  allow_user_signup: Scalars['Boolean'];
  allow_group_creation: Scalars['Boolean'];
  allow_group_discovery: Scalars['Boolean'];
  departments_in_signup: Scalars['Boolean'];
  departments_in_signup_required: Scalars['Boolean'];
  locations_in_signup: Scalars['Boolean'];
  locations_in_signup_required: Scalars['Boolean'];
  support_multiple_languages: Scalars['Boolean'];
  allow_user_share_commentary: Scalars['Boolean'];
  disable_timeline: Scalars['Boolean'];
  disable_comments: Scalars['Boolean'];
  image: S3ObjectInput;
};

export type CreateClientInvitationInput = {
  uploadfile?: Maybe<S3ObjectInput>;
  email_addresses?: Maybe<Array<Maybe<Scalars['String']>>>;
  subject?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  email_from_address?: Maybe<Scalars['String']>;
};

export type CreateClientLocationInput = {
  title: Scalars['String'];
  location_status: ClientLocationStatus;
};

export type CreateGroupInput = {
  title: Scalars['String'];
  content_approval_type: GroupContentApprovalType;
  description?: Maybe<Scalars['String']>;
  allow_user_posts: Scalars['Boolean'];
  color: GroupColor;
  icon_color: GroupIconColor;
  icon: GroupIcon;
  image?: Maybe<S3ObjectInput>;
  department_id?: Maybe<Scalars['ID']>;
  location_id?: Maybe<Scalars['ID']>;
};

export type CreateUserSegmentInput = {
  title: Scalars['String'];
  segment_status: SegmentStatus;
  department_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  location_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  user_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  email_addresses?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CsUpdateClientInput = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  email_sending_domain?: Maybe<Scalars['String']>;
  email_from_address?: Maybe<Scalars['String']>;
  email_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  content_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  email_address?: Maybe<Scalars['String']>;
  client_status?: Maybe<ClientStatus>;
  authentication_type?: Maybe<AuthenticationType>;
  sso_configuration?: Maybe<SsoConfigurationInput>;
  sso_provider?: Maybe<Scalars['String']>;
  allow_user_invites?: Maybe<Scalars['Boolean']>;
  allow_user_signup?: Maybe<Scalars['Boolean']>;
  allow_group_creation?: Maybe<Scalars['Boolean']>;
  allow_group_discovery?: Maybe<Scalars['Boolean']>;
  departments_in_signup?: Maybe<Scalars['Boolean']>;
  departments_in_signup_required?: Maybe<Scalars['Boolean']>;
  locations_in_signup?: Maybe<Scalars['Boolean']>;
  locations_in_signup_required?: Maybe<Scalars['Boolean']>;
  support_multiple_languages?: Maybe<Scalars['Boolean']>;
  allow_user_share_commentary?: Maybe<Scalars['Boolean']>;
  disable_timeline?: Maybe<Scalars['Boolean']>;
  disable_comments?: Maybe<Scalars['Boolean']>;
  image?: Maybe<S3ObjectInput>;
};

export enum DateGrouping {
  Month = 'month',
  Day = 'day',
  Year = 'year',
  Week = 'week',
}

export type ExternalOverviewStat = {
  summary: ExternalSummary;
  data?: Maybe<Array<Maybe<ExternalStat>>>;
};

export type ExternalStat = {
  branded_shares: Scalars['Int'];
  non_branded_shares: Scalars['Int'];
  branded_clicks: Scalars['Int'];
  non_branded_clicks: Scalars['Int'];
  branded_engagements: Scalars['Int'];
  non_branded_engagements: Scalars['Int'];
  calendar_day: Scalars['String'];
};

export type ExternalSummary = {
  shares: IndividualStat;
  clicks: IndividualStat;
  engagements: IndividualStat;
};

export type Feed = {
  results?: Maybe<Array<Maybe<Content>>>;
  id_lt?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
};

export type FeedByUser = {
  feed_follows?: Maybe<Array<Maybe<UserFeedFollow>>>;
  followed_by_users?: Maybe<Array<Maybe<PublicUserProfile>>>;
  user: ProfileContext;
  client: Client;
  user_id: Scalars['ID'];
};

export type FeedByUserInput = {
  feed?: Maybe<FeedKey>;
  user_id?: Maybe<Scalars['ID']>;
};

export type FeedFollow = {
  key: FeedKey;
  id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type FeedFollowing = {
  feed_follows?: Maybe<Array<Maybe<UserFeedFollow>>>;
  count?: Maybe<Scalars['Int']>;
  paginate: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['ID']>;
  user: UserProfile;
  id: Scalars['ID'];
  feed: FeedKey;
};

export type FeedFollowingInput = {
  count?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  feed: FeedKey;
  user_id?: Maybe<Scalars['ID']>;
};

export type FeedFollowList = {
  key: FeedKey;
  id: Scalars['ID'];
  user_id: Scalars['ID'];
  user?: Maybe<PublicUserProfile>;
};

/** Feed fields */
export enum FeedKey {
  Alluser = 'alluser',
  User = 'user',
  Privateuser = 'privateuser',
  Removeduser = 'removeduser',
  Group = 'group',
  Submittedgroup = 'submittedgroup',
  Removedgroup = 'removedgroup',
  Timeline = 'timeline',
  Firehose = 'firehose',
}

export type FollowConditions = {
  department_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  location_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  departments?: Maybe<Array<Maybe<ClientDepartment>>>;
  locations?: Maybe<Array<Maybe<ClientLocation>>>;
  language?: Maybe<Array<Maybe<Scalars['String']>>>;
  email_domain?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FollowConditionsInput = {
  department_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  location_id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  language?: Maybe<Array<Maybe<Scalars['String']>>>;
  email_domain?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum GenericStatus {
  Active = 'active',
  Disabled = 'disabled',
}

export type Group = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  user_id: Scalars['ID'];
  user?: Maybe<PublicUserProfile>;
  title: Scalars['String'];
  group_status: GroupStatus;
  content_approval_type: GroupContentApprovalType;
  description?: Maybe<Scalars['String']>;
  allow_user_posts: Scalars['Boolean'];
  color: GroupColor;
  icon_color: GroupIconColor;
  icon: GroupIcon;
  color_map: GroupColorMap;
  icon_color_map: GroupIconColorMap;
  icon_map: GroupIconMap;
  created_at: Scalars['Int'];
  updated_at?: Maybe<Scalars['Int']>;
  image?: Maybe<S3Object>;
  department_id?: Maybe<Scalars['ID']>;
  department_title?: Maybe<Scalars['String']>;
  location_id?: Maybe<Scalars['ID']>;
  location_title?: Maybe<Scalars['String']>;
  follower_count?: Maybe<Scalars['Int']>;
};

/** Activites fields */
export type GroupActionUrls = {
  actor: Scalars['String'];
  Group: Scalars['String'];
};

export enum GroupColor {
  Crimson = 'crimson',
  Magenta = 'magenta',
  Violet = 'violet',
  Midnight = 'midnight',
  Navy = 'navy',
  SkyBlue = 'sky_blue',
  Aquamarine = 'aquamarine',
  Forrest = 'forrest',
  LimeGreen = 'lime_green',
  Sunset = 'sunset',
  Terracota = 'terracota',
  Slate = 'slate',
}

export type GroupColorMap = {
  label: Scalars['String'];
  hex: Scalars['String'];
  group_color?: Maybe<GroupColor>;
};

export enum GroupContentApprovalType {
  Auto = 'auto',
  Review = 'review',
}

export enum GroupIcon {
  Es = 'es',
  Alert = 'alert',
  Asterisk = 'asterisk',
  Barchart = 'barchart',
  Beaker = 'beaker',
  Bin = 'bin',
  Bookmark = 'bookmark',
  Box = 'box',
  Buld = 'buld',
  Calendar = 'calendar',
  Cloud = 'cloud',
  Code = 'code',
  Compass = 'compass',
  Eye = 'eye',
  Flag = 'flag',
  Folder = 'folder',
  Globe = 'globe',
  Heart = 'heart',
  Image = 'image',
  Info = 'info',
  Knot = 'knot',
  Lightening = 'lightening',
  Mail = 'mail',
  Mustache = 'mustache',
  Network = 'network',
  Paths = 'paths',
  Saturn = 'saturn',
  Search = 'search',
  Star = 'star',
  Time = 'time',
  Volume = 'volume',
  Windows = 'windows',
  Wrench = 'wrench',
}

export enum GroupIconColor {
  Crimson = 'crimson',
  Magenta = 'magenta',
  Violet = 'violet',
  Midnight = 'midnight',
  Navy = 'navy',
  SkyBlue = 'sky_blue',
  Aquamarine = 'aquamarine',
  Forrest = 'forrest',
  LimeGreen = 'lime_green',
  Sunset = 'sunset',
  Terracota = 'terracota',
  Slate = 'slate',
}

export type GroupIconColorMap = {
  label: Scalars['String'];
  hex: Scalars['String'];
  group_icon_color?: Maybe<GroupIconColor>;
};

export type GroupIconMap = {
  label: Scalars['String'];
  bucket: Scalars['String'];
  file_key: Scalars['String'];
  group_icon?: Maybe<GroupIcon>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
};

export type GroupIdApproval = {
  group_id?: Maybe<Scalars['ID']>;
  approval?: Maybe<ContentApproval>;
};

export type GroupIdApprovalInput = {
  group_id: Scalars['ID'];
  approval: ContentApproval;
};

export type GroupList = {
  groups?: Maybe<Array<Maybe<Group>>>;
  count: Scalars['Int'];
  paginate: Scalars['Boolean'];
  title_lower?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type GroupListInput = {
  limit?: Maybe<Scalars['Int']>;
  title_lower?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Boolean']>;
};

/** Group Moderator */
export type GroupModerator = {
  client_id: Scalars['ID'];
  group_id: Scalars['ID'];
  user_id: Scalars['ID'];
  created_at: Scalars['Int'];
  added_by_user_id: Scalars['ID'];
  user?: Maybe<PublicUserProfile>;
};

export enum GroupSourceType {
  Rss = 'rss',
  Keyword = 'keyword',
  TwitterHandle = 'twitter_handle',
}

/** Groups fields */
export enum GroupStatus {
  Active = 'active',
  Deleted = 'deleted',
}

export type GroupSuggestion = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  title: Scalars['String'];
  color: GroupColor;
  icon_color: GroupIconColor;
  icon: GroupIcon;
  color_map: GroupColorMap;
  icon_color_map: GroupIconColorMap;
  icon_map: GroupIconMap;
  image?: Maybe<S3Object>;
};

export type Inbox = {
  id: Scalars['ID'];
  item_read: Scalars['Boolean'];
  created_at: Scalars['Int'];
  updated_at: Scalars['Int'];
  to_user_id: Scalars['ID'];
  message: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type InboxList = {
  count: Scalars['Int'];
  inbox?: Maybe<Array<Maybe<Inbox>>>;
  limit?: Maybe<Scalars['Int']>;
  paginate: Scalars['Boolean'];
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
};

export type InboxStatusInput = {
  limit?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Boolean']>;
  item_read?: Maybe<Scalars['Boolean']>;
};

export type IndividualStat = {
  count: Scalars['Int'];
  change: Scalars['Float'];
};

export type InstagramLocation = {
  id?: Maybe<Scalars['String']>;
  has_public_page: Scalars['Boolean'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type InstagramLocationInput = {
  id?: Maybe<Scalars['String']>;
  has_public_page: Scalars['Boolean'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type InstagramMedia = {
  id: Scalars['String'];
  shortcode: Scalars['String'];
  is_video: Scalars['Boolean'];
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  display_url?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  file_key?: Maybe<Scalars['String']>;
  tagged_users?: Maybe<Array<Maybe<InstagramTaggedUser>>>;
};

export type InstagramMediaInput = {
  id: Scalars['String'];
  shortcode: Scalars['String'];
  is_video: Scalars['Boolean'];
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  display_url?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  file_key?: Maybe<Scalars['String']>;
  tagged_users?: Maybe<Array<Maybe<InstagramTaggedUserInput>>>;
};

export type InstagramMetadata = {
  taken_at_timestamp: Scalars['Int'];
  shortcode: Scalars['String'];
  id: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  is_video: Scalars['Boolean'];
  is_ad: Scalars['Boolean'];
  owner: InstagramOwner;
  location?: Maybe<InstagramLocation>;
  tagged_users?: Maybe<Array<Maybe<InstagramTaggedUser>>>;
  media: Array<Maybe<InstagramMedia>>;
};

export type InstagramMetadataInput = {
  taken_at_timestamp: Scalars['Int'];
  shortcode: Scalars['String'];
  id: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  is_video: Scalars['Boolean'];
  is_ad: Scalars['Boolean'];
  owner: InstagramOwnerInput;
  location?: Maybe<InstagramLocationInput>;
  tagged_users?: Maybe<Array<Maybe<InstagramTaggedUserInput>>>;
  media: Array<Maybe<InstagramMediaInput>>;
};

/** Instagram content metadata */
export type InstagramOwner = {
  id: Scalars['String'];
  full_name?: Maybe<Scalars['String']>;
  is_private: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  profile_pic_url?: Maybe<Scalars['String']>;
  profile_pic_bucket?: Maybe<Scalars['String']>;
  profile_pic_file_key?: Maybe<Scalars['String']>;
  profile_pic_width?: Maybe<Scalars['Int']>;
  profile_pic_height?: Maybe<Scalars['Int']>;
  username: Scalars['String'];
  url: Scalars['String'];
};

export type InstagramOwnerInput = {
  id: Scalars['String'];
  full_name?: Maybe<Scalars['String']>;
  is_private: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  profile_pic_url?: Maybe<Scalars['String']>;
  profile_pic_bucket?: Maybe<Scalars['String']>;
  profile_pic_file_key?: Maybe<Scalars['String']>;
  profile_pic_width?: Maybe<Scalars['Int']>;
  profile_pic_height?: Maybe<Scalars['Int']>;
  username: Scalars['String'];
  url: Scalars['String'];
};

export type InstagramTaggedUser = {
  id: Scalars['String'];
  username: Scalars['String'];
  url: Scalars['String'];
};

export type InstagramTaggedUserInput = {
  id: Scalars['String'];
  username: Scalars['String'];
  url: Scalars['String'];
};

export type InternalEngagementStat = {
  comments: Scalars['Int'];
  reactions: Scalars['Int'];
  posts: Scalars['Int'];
  shares: Scalars['Int'];
  engagements: Scalars['Int'];
  groups: Scalars['Int'];
  clicks: Scalars['Int'];
};

export type InternalOverviewStat = {
  summary: InternalSummary;
  data?: Maybe<Array<Maybe<InternalStat>>>;
};

export type InternalStat = {
  daily_active_users: Scalars['Int'];
  daily_inactive_users: Scalars['Int'];
  branded_posts: Scalars['Int'];
  non_branded_posts: Scalars['Int'];
  active_groups_count: Scalars['Int'];
  inactive_groups_count: Scalars['Int'];
  branded_comments_count: Scalars['Int'];
  non_branded_comments_count: Scalars['Int'];
  branded_reactions_count: Scalars['Int'];
  non_branded_reactions_count: Scalars['Int'];
  calendar_day: Scalars['String'];
};

export type InternalSummary = {
  users: IndividualStat;
  groups: IndividualStat;
  posts: IndividualStat;
  comments: IndividualStat;
  reactions: IndividualStat;
};

export type ItemsListInput = {
  limit?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Boolean']>;
};

export type IUrls = {
  original_url: Scalars['String'];
  shortened_url: Scalars['String'];
  shared_url: Scalars['String'];
};

export type LeaderboardConfig = {
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  leaderboard_status: GenericStatus;
  created_at: Scalars['Int'];
  start_at?: Maybe<Scalars['Int']>;
  end_at?: Maybe<Scalars['Int']>;
  all_users: Scalars['Boolean'];
  segment_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  segments?: Maybe<Array<Maybe<UserSegment>>>;
};

export type LeaderboardConfigInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  leaderboard_status?: Maybe<GenericStatus>;
  start_at?: Maybe<Scalars['Int']>;
  end_at?: Maybe<Scalars['Int']>;
  segment_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type LeaderboardEventScores = {
  event: LeaderboardEventType;
  score: Scalars['String'];
};

export enum LeaderboardEventType {
  ShareableBrandedPost = 'shareable_branded_post',
  ShareablePhotoPost = 'shareable_photo_post',
  ShareablePost = 'shareable_post',
  PhotoPost = 'photo_post',
  Post = 'post',
  Comment = 'comment',
  UserMention = 'user_mention',
  Reaction = 'reaction',
  FollowUser = 'follow_user',
  FollowGroup = 'follow_group',
  Followed = 'followed',
  BrandedTwitterShare = 'branded_twitter_share',
  TwitterShare = 'twitter_share',
  BrandedLinkedinShare = 'branded_linkedin_share',
  LinkedinShare = 'linkedin_share',
  BrandedFacebookShare = 'branded_facebook_share',
  FacebookShare = 'facebook_share',
  BrandedTwitterClick = 'branded_twitter_click',
  TwitterClick = 'twitter_click',
  BrandedLinkedinClick = 'branded_linkedin_click',
  LinkedinClick = 'linkedin_click',
  BrandedFacebookClick = 'branded_facebook_click',
  FacebookClick = 'facebook_click',
  BrandedTwitterEngagement = 'branded_twitter_engagement',
  TwitterEngagement = 'twitter_engagement',
  BrandedLinkedinEngagement = 'branded_linkedin_engagement',
  LinkedinEngagement = 'linkedin_engagement',
  BrandedFacebookEngagement = 'branded_facebook_engagement',
  FacebookEngagement = 'facebook_engagement',
  InvitationSent = 'invitation_sent',
  InvitationAccepted = 'invitation_accepted',
  ProfilePhoto = 'profile_photo',
  TwitterConnected = 'twitter_connected',
  LinkedinConnected = 'linkedin_connected',
  FacebookConnected = 'facebook_connected',
  NetworkConnected = 'network_connected',
  GroupCreated = 'group_created',
  ReceivedReaction = 'received_reaction',
  ReceivedComment = 'received_comment',
  ReceivedShare = 'received_share',
}

export type LeaderboardForUser = {
  leaderboard_configs?: Maybe<Array<Maybe<LeaderboardConfig>>>;
  leaderboard_config?: Maybe<LeaderboardConfig>;
  leaderboard_scores?: Maybe<LeaderboardScores>;
  user_score?: Maybe<LeaderboardScore>;
};

export type LeaderboardScore = {
  leaderboard_config_id: Scalars['ID'];
  user_id: Scalars['ID'];
  user: PublicUserProfile;
  score: Scalars['String'];
  position_change?: Maybe<Scalars['Int']>;
  ranking: Scalars['Int'];
  events: Array<Maybe<LeaderboardEventScores>>;
};

export type LeaderboardScores = {
  items?: Maybe<Array<Maybe<LeaderboardScore>>>;
  paginate: Scalars['Boolean'];
  leaderboard_config_id?: Maybe<Scalars['ID']>;
  ranking?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type ManualNotificationEmail = {
  subject: Scalars['String'];
  body: Scalars['String'];
  format?: Maybe<ManualNotificationEmailFormat>;
  body_formats?: Maybe<ManualNotificationEmailBodyFormats>;
};

export type ManualNotificationEmailBodyFormats = {
  html?: Maybe<Scalars['String']>;
  markdown?: Maybe<Scalars['String']>;
};

export enum ManualNotificationEmailFormat {
  Html = 'html',
  Markdown = 'markdown',
  Text = 'text',
}

export type ManualNotificationEmailInput = {
  subject: Scalars['String'];
  body: Scalars['String'];
  format?: Maybe<ManualNotificationEmailFormat>;
};

export type ManualNotificationMessage = {
  body: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type ManualNotificationMessageInput = {
  body: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type ManualNotificationsItem = {
  id: Scalars['ID'];
  notification_type?: Maybe<ManualNotificationType>;
  send_at: Scalars['Int'];
  user_id: Scalars['ID'];
  segment_ids: Array<Maybe<Scalars['ID']>>;
  segments: Array<Maybe<UserSegment>>;
  message: ManualNotificationMessage;
  client_id: Scalars['ID'];
  email?: Maybe<ManualNotificationEmail>;
  created_at: Scalars['Int'];
  user_count?: Maybe<Scalars['Int']>;
  email_count?: Maybe<Scalars['Int']>;
  entire_company?: Maybe<Scalars['Boolean']>;
};

export type ManualNotificationsItemInput = {
  notification_type?: Maybe<ManualNotificationType>;
  send_at?: Maybe<Scalars['Int']>;
  segment_ids: Array<Maybe<Scalars['ID']>>;
  message: ManualNotificationMessageInput;
  email?: Maybe<ManualNotificationEmailInput>;
  entire_company?: Maybe<Scalars['Boolean']>;
};

export type ManualNotificationsItemsList = {
  count: Scalars['Int'];
  items?: Maybe<Array<Maybe<ManualNotificationsItem>>>;
  limit?: Maybe<Scalars['Int']>;
  paginate: Scalars['Boolean'];
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
};

export type ManualNotificationsItemUpdateInput = {
  id: Scalars['ID'];
  send_at?: Maybe<Scalars['Int']>;
  segment_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  message?: Maybe<ManualNotificationMessageInput>;
  email?: Maybe<ManualNotificationEmailInput>;
  entire_company?: Maybe<Scalars['Boolean']>;
  notification_type?: Maybe<ManualNotificationType>;
};

export enum ManualNotificationType {
  Scheduled = 'scheduled',
  Now = 'now',
}

export type MediaObject = {
  video?: Maybe<S3VideoObject>;
};

export type MediaObjectInput = {
  video?: Maybe<S3VideoObjectInput>;
};

/** Content / URL metadata fields */
export enum MetadataKey {
  UrlMetadata = 'url_metadata',
  TweetMetadata = 'tweet_metadata',
  YoutubeMetadata = 'youtube_metadata',
  InstagramMetadata = 'instagram_metadata',
  RedditMetadata = 'reddit_metadata',
}

/** Mutations */
export type Mutation = {
  createClient: Client;
  csUpdateClient: Client;
  createUpdateLeaderboardConfig: LeaderboardConfig;
  createReportRequest: ReportRequest;
  updateClientUrlParams: ClientUrlParams;
  adminUpdateClient: Client;
  /** CLIENT INVITATIONS */
  createClientInvitation: Array<Maybe<ClientInvitation>>;
  /** CLIENT LOCATIONS */
  createClientLocation: ClientLocation;
  updateClientLocation: ClientLocation;
  /** CLIENT DEPARTMENTS */
  createClientDepartment: ClientDepartment;
  updateClientDepartment: ClientDepartment;
  /** CLIENT FOLLOW MAPPINGS */
  createClientFollowMapping: ClientFollowMapping;
  updateClientFollowMapping: ClientFollowMapping;
  /** GROUP MODERATORS */
  createGroupModerator: GroupModerator;
  deleteGroupModerator: Scalars['Boolean'];
  /** GROUPS */
  createGroup: Group;
  updateGroup: Group;
  batchDeleteGroups: Array<Maybe<Group>>;
  /** COMMENTS */
  createComment: Comment;
  deleteComment: Comment;
  updateComment: Comment;
  /** REACTIONS */
  createReaction: Reaction;
  deleteReaction: Status;
  /** PROFILES */
  updateUserProfile: UserProfile;
  batchUpdateUserProfileStatus: Array<Maybe<UserProfile>>;
  batchUpdateUserProfileUserType: Array<Maybe<UserProfile>>;
  /** SEGMENTS */
  createUserSegment: UserSegment;
  updateUserSegment: UserSegment;
  /** CONTENT */
  updateContentApprovals?: Maybe<Content>;
  processContent: Content;
  follow?: Maybe<UserFeedFollow>;
  unfollow?: Maybe<UserFeedFollow>;
  clientGroupSourceCreate: ClientGroupSource;
  clientGroupSourceUpdate: ClientGroupSource;
  clientGroupSourceDelete: Status;
  markInboxAsRead: Status;
  markInboxItemAsRead?: Maybe<Inbox>;
  shareContent?: Maybe<SharedContentResults>;
  updateScheduledShares: Array<ScheduledShareItem>;
  deleteScheduledShare: ScheduledShareItem;
  deleteScheduledShares: Array<Maybe<SharesItem>>;
  deleteSocialConnection: Status;
  createManualNotification?: Maybe<ManualNotificationsItem>;
  updateManualNotification?: Maybe<ManualNotificationsItem>;
  deleteManualNotification?: Maybe<ManualNotificationsItem>;
  backendInboxItemCreated?: Maybe<Inbox>;
  processScheduledShare: Status;
};

/** Mutations */
export type MutationCreateClientArgs = {
  data: CreateClientInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationCsUpdateClientArgs = {
  data: CsUpdateClientInput;
};

/** Mutations */
export type MutationCreateUpdateLeaderboardConfigArgs = {
  data: LeaderboardConfigInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationCreateReportRequestArgs = {
  data: RunReportInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationUpdateClientUrlParamsArgs = {
  data: ClientUrlParamsUpdateInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationAdminUpdateClientArgs = {
  data: AdminUpdateClientInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationCreateClientInvitationArgs = {
  data: CreateClientInvitationInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationCreateClientLocationArgs = {
  data: CreateClientLocationInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationUpdateClientLocationArgs = {
  data: UpdateClientLocationInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationCreateClientDepartmentArgs = {
  data: CreateClientDepartmentInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationUpdateClientDepartmentArgs = {
  data: UpdateClientDepartmentInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationCreateClientFollowMappingArgs = {
  data: CreateClientFollowMappingInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationUpdateClientFollowMappingArgs = {
  data: UpdateClientFollowMappingInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationCreateGroupModeratorArgs = {
  group_id: Scalars['ID'];
  user_id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationDeleteGroupModeratorArgs = {
  group_id: Scalars['ID'];
  user_id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationCreateGroupArgs = {
  data: CreateGroupInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationUpdateGroupArgs = {
  data: UpdateGroupInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationBatchDeleteGroupsArgs = {
  ids: Array<Maybe<Scalars['ID']>>;
};

/** Mutations */
export type MutationCreateCommentArgs = {
  data: CommentInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationDeleteCommentArgs = {
  id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationUpdateCommentArgs = {
  data: CommentUpdateInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationCreateReactionArgs = {
  data: ReactionInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationDeleteReactionArgs = {
  data: ReactionInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationUpdateUserProfileArgs = {
  data: UserProfileInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationBatchUpdateUserProfileStatusArgs = {
  ids: Array<Maybe<Scalars['ID']>>;
  user_status: UserStatus;
};

/** Mutations */
export type MutationBatchUpdateUserProfileUserTypeArgs = {
  ids: Array<Maybe<Scalars['ID']>>;
  user_type: UserType;
};

/** Mutations */
export type MutationCreateUserSegmentArgs = {
  data: CreateUserSegmentInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationUpdateUserSegmentArgs = {
  data: UpdateUserSegmentInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationUpdateContentApprovalsArgs = {
  content_id: Scalars['String'];
  content_approvals: ContentApprovalsInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationProcessContentArgs = {
  content: ContentInput;
  process_metadata: Scalars['Boolean'];
  save: Scalars['Boolean'];
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationFollowArgs = {
  key: FeedKey;
  id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationUnfollowArgs = {
  key: FeedKey;
  id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationClientGroupSourceCreateArgs = {
  group_id: Scalars['ID'];
  source_type: GroupSourceType;
  source_value: Scalars['String'];
  source_status: SourceStatus;
  approval?: Maybe<ContentApproval>;
  disclosures?: Maybe<Array<Maybe<ContentDisclosuresInput>>>;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationClientGroupSourceUpdateArgs = {
  data: ClientGroupSourceUpdate;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationClientGroupSourceDeleteArgs = {
  id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationMarkInboxItemAsReadArgs = {
  id: Scalars['ID'];
};

/** Mutations */
export type MutationShareContentArgs = {
  share_session_id?: Maybe<Scalars['ID']>;
  content_id: Scalars['ID'];
  items: Array<Maybe<ShareContentInput>>;
  source?: Maybe<Scalars['String']>;
};

/** Mutations */
export type MutationUpdateScheduledSharesArgs = {
  data: ScheduledShareContentInput;
  override?: Maybe<OverrideInput>;
};

/** Mutations */
export type MutationDeleteScheduledShareArgs = {
  id: Scalars['ID'];
};

/** Mutations */
export type MutationDeleteScheduledSharesArgs = {
  ids: Array<Scalars['ID']>;
};

/** Mutations */
export type MutationDeleteSocialConnectionArgs = {
  id: Scalars['ID'];
};

/** Mutations */
export type MutationCreateManualNotificationArgs = {
  data?: Maybe<ManualNotificationsItemInput>;
};

/** Mutations */
export type MutationUpdateManualNotificationArgs = {
  data?: Maybe<ManualNotificationsItemUpdateInput>;
};

/** Mutations */
export type MutationDeleteManualNotificationArgs = {
  id: Scalars['ID'];
};

/** Mutations */
export type MutationBackendInboxItemCreatedArgs = {
  id: Scalars['ID'];
};

/** Mutations */
export type MutationProcessScheduledShareArgs = {
  share_id: Scalars['ID'];
  network_id: Scalars['ID'];
  share_queue_id: Scalars['ID'];
};

/** Sharing */
export enum Network {
  Facebook = 'facebook',
  Twitter = 'twitter',
  Linkedin = 'linkedin',
  Xing = 'xing',
}

export enum NotificationDeliveryType {
  Email = 'email',
  Push = 'push',
  Subscription = 'subscription',
  Inbox = 'inbox',
}

/** Reactions */
export enum ObjectType {
  Content = 'content',
}

export type OverrideInput = {
  client_id?: Maybe<Scalars['ID']>;
};

export type PaginatedFollowedByUsers = {
  followed_by_users?: Maybe<Array<PublicUserProfile>>;
  count: Scalars['Int'];
  user: ProfileContext;
  client: Client;
  followed_by_user_id?: Maybe<Scalars['ID']>;
  username?: Maybe<Scalars['String']>;
};

export type PaginatedFollowedByUsersInput = {
  user_id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
  followed_by_user_id?: Maybe<Scalars['ID']>;
  username?: Maybe<Scalars['String']>;
};

export type PaginatedUserFeedFollows = {
  feed_follows?: Maybe<Array<UserFeedFollow>>;
  count: Scalars['Int'];
  client: Client;
  title_lower?: Maybe<Scalars['String']>;
  client_id__feed__id?: Maybe<Scalars['String']>;
};

export type PaginatedUserFeedFollowsInput = {
  user_id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
  title_lower?: Maybe<Scalars['String']>;
  client_id__feed__id?: Maybe<Scalars['String']>;
};

export enum ParamsStatus {
  Active = 'active',
  Disabled = 'disabled',
}

export type PostedToGroup = {
  group_id: Scalars['ID'];
  score: Scalars['Int'];
};

/** Content fields */
export enum PostType {
  Manual = 'manual',
  Url = 'url',
  Tweet = 'tweet',
  Youtube = 'youtube',
  Instagram = 'instagram',
}

export type PreviousShareItem = {
  id: Scalars['ID'];
  successful: Scalars['Boolean'];
  network?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  shared_at?: Maybe<Scalars['Int']>;
};

export type ProfileContext = UserProfile | PublicUserProfile;

export type ProfileSuggestion = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  title: Scalars['String'];
  image?: Maybe<S3Object>;
};

export type PublicUserProfile = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  user_status: UserStatus;
  user_type: UserType;
  full_name?: Maybe<Scalars['String']>;
  image?: Maybe<S3Object>;
  reach?: Maybe<Scalars['Int']>;
  lang?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  group_moderator?: Maybe<Array<Maybe<GroupModerator>>>;
  last_accessed_at?: Maybe<Scalars['Int']>;
  department_id?: Maybe<Scalars['ID']>;
  location_id?: Maybe<Scalars['ID']>;
  email_address: Scalars['String'];
  department?: Maybe<ClientDepartment>;
  location?: Maybe<ClientLocation>;
  department_title?: Maybe<Scalars['String']>;
  location_title?: Maybe<Scalars['String']>;
  follower_count?: Maybe<Scalars['Int']>;
  karma?: Maybe<Scalars['String']>;
};

export type PushNotificationConfiguration = {
  device_platform: Scalars['String'];
  token: Scalars['String'];
};

export type PushNotificationConfigurationInput = {
  device_platform: Scalars['String'];
  token: Scalars['String'];
};

export type PushNotificationStatus = {
  paused: Scalars['Boolean'];
  paused_at?: Maybe<Scalars['Int']>;
};

export type Query = {
  getClients: Array<Maybe<Client>>;
  getLeaderboardConfig: LeaderboardConfig;
  getLeaderboardConfigScores: Array<Maybe<LeaderboardEventScores>>;
  getLeaderboardConfigs: Array<Maybe<LeaderboardConfig>>;
  userHasLeaderboards: Scalars['Boolean'];
  getLeaderboardForUser?: Maybe<LeaderboardForUser>;
  getLeaderboardScores: LeaderboardScores;
  getLeaderboardScoreForUser: LeaderboardScore;
  getReports?: Maybe<Array<Maybe<Report>>>;
  contextGetPostedToGroups?: Maybe<Array<Maybe<PostedToGroup>>>;
  getReportRequests: ReportRequestList;
  getReportResult: ReportResult;
  getReportRequest: ReportRequest;
  getReportsUrl?: Maybe<Array<Maybe<ReportUrl>>>;
  getAllClientUrlParams?: Maybe<Array<Maybe<ClientUrlParams>>>;
  getClient?: Maybe<Client>;
  /** CLIENT INVITATIONS */
  getClientInvitation?: Maybe<ClientInvitation>;
  getClientInvitationsByClient: ClientInvitationsClientList;
  /** CLIENT FOLLOW MAPPINGS */
  getUserClientFollowMappings: UserFollowMappings;
  getClientFollowMapping?: Maybe<ClientFollowMapping>;
  getAllClientFollowMappings: ClientFollowMappingList;
  getClientFollowMappingsByStatus: ClientFollowMappingStatusList;
  /** CLIENT DEPARTMENTS */
  getClientDepartmentsByStatus: ClientDepartmentStatusList;
  getClientDepartment?: Maybe<ClientDepartment>;
  getAllClientDepartments: ClientDepartmentList;
  /** CLIENT LOCATIONS */
  getClientLocationsByStatus: ClientLocationStatusList;
  getClientLocation?: Maybe<ClientLocation>;
  getAllClientLocations: ClientLocationList;
  /** CLIENTS */
  getActiveClientByAttr?: Maybe<Client>;
  getClientByEmailDomain?: Maybe<Client>;
  /** GROUP MODERATORS */
  isGroupModerator: Scalars['Boolean'];
  getModeratorsByGroup?: Maybe<Array<Maybe<GroupModerator>>>;
  /** GROUPS */
  getGroup?: Maybe<Group>;
  getActiveGroups: GroupList;
  getGroupColors: Array<Maybe<GroupColorMap>>;
  getGroupIconColors: Array<Maybe<GroupIconColorMap>>;
  getGroupIcons: Array<Maybe<GroupIconMap>>;
  /** COMMENTS */
  getActiveComments: CommentsList;
  /** PROFILES */
  getPublicUserProfile?: Maybe<PublicUserProfile>;
  getUserProfile?: Maybe<UserProfile>;
  getProfilesByClientIdFullName?: Maybe<Array<Maybe<PublicUserProfile>>>;
  getProfilesByUserStatus: UserProfilesByStatusList;
  /** SEGMENTS */
  getUserSegment?: Maybe<UserSegment>;
  getUserSegments?: Maybe<Array<Maybe<UserSegment>>>;
  getUserSegmentUsers?: Maybe<UserSegmentUsers>;
  /** SOURCES */
  getClientGroupSourcesByGroup?: Maybe<Array<Maybe<ClientGroupSource>>>;
  /** CONTENT */
  getContent?: Maybe<Content>;
  getContentUrlParamOptions?: Maybe<Array<Maybe<ContentUrlParamOptions>>>;
  getFeed: Feed;
  getActions: Actions;
  getPaginatedUserFeedFollows: PaginatedUserFeedFollows;
  getPaginatedFollowedByUsers: PaginatedFollowedByUsers;
  getByUserFeed: FeedByUser;
  feedFollowing?: Maybe<FeedFollowing>;
  search: SearchResults;
  getUserSearches?: Maybe<Array<Maybe<Scalars['String']>>>;
  recommendContent: RecommendedContentResults;
  searchAggregates: SearchAggregates;
  suggest: SuggestionResults;
  /** INBOX */
  getInboxItem: Inbox;
  getInboxItems: InboxList;
  /** get user social account connections */
  getUserSocialConnections: SocialAccountConnectionsList;
  getSharePreviewInfo: ContentSharePreview;
  getSharesItems: SharesList;
  getManualNotificationItems?: Maybe<ManualNotificationsItemsList>;
  /** Stats & Reporting */
  userEngagementStats?: Maybe<InternalEngagementStat>;
  clientEngagementStats?: Maybe<ClientEngagementStat>;
  userReachStats?: Maybe<Array<Maybe<ReachStat>>>;
  userTrendingStats?: Maybe<TrendingEngagementStat>;
  userDailyStats?: Maybe<TrendingEngagementStat>;
  clientReachStats?: Maybe<Array<Maybe<ReachStat>>>;
  clientDailyStats?: Maybe<ClientTrendingEngagementStat>;
  internalOverviewStats?: Maybe<InternalOverviewStat>;
  externalOverviewStats?: Maybe<ExternalOverviewStat>;
};

export type QueryGetClientsArgs = {
  client_status: ClientStatus;
};

export type QueryGetLeaderboardConfigArgs = {
  id: Scalars['ID'];
};

export type QueryGetLeaderboardConfigScoresArgs = {
  id: Scalars['ID'];
};

export type QueryUserHasLeaderboardsArgs = {
  user_id?: Maybe<Scalars['ID']>;
};

export type QueryGetLeaderboardForUserArgs = {
  user_id?: Maybe<Scalars['ID']>;
  leaderboard_config_id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryGetLeaderboardScoresArgs = {
  leaderboard_config_id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  ranking?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type QueryGetLeaderboardScoreForUserArgs = {
  leaderboard_config_id: Scalars['ID'];
  user_id?: Maybe<Scalars['ID']>;
};

export type QueryGetReportRequestsArgs = {
  data: ReportRequestListInput;
  override?: Maybe<OverrideInput>;
};

export type QueryGetReportResultArgs = {
  request_id: Scalars['ID'];
};

export type QueryGetReportRequestArgs = {
  request_id: Scalars['ID'];
};

export type QueryGetReportsUrlArgs = {
  report_id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

export type QueryGetAllClientUrlParamsArgs = {
  override?: Maybe<OverrideInput>;
};

export type QueryGetClientArgs = {
  id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

export type QueryGetClientInvitationArgs = {
  id: Scalars['ID'];
};

export type QueryGetClientInvitationsByClientArgs = {
  data: ClientInvitationsClientListInput;
  override?: Maybe<OverrideInput>;
};

export type QueryGetUserClientFollowMappingsArgs = {
  override?: Maybe<OverrideInput>;
};

export type QueryGetClientFollowMappingArgs = {
  id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

export type QueryGetAllClientFollowMappingsArgs = {
  data: ClientFollowMappingListInput;
  override?: Maybe<OverrideInput>;
};

export type QueryGetClientFollowMappingsByStatusArgs = {
  data: ClientFollowMappingStatusListInput;
  override?: Maybe<OverrideInput>;
};

export type QueryGetClientDepartmentsByStatusArgs = {
  data: ClientDepartmentStatusListInput;
  override?: Maybe<OverrideInput>;
};

export type QueryGetClientDepartmentArgs = {
  id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

export type QueryGetAllClientDepartmentsArgs = {
  data: ClientDepartmentListInput;
  override?: Maybe<OverrideInput>;
};

export type QueryGetClientLocationsByStatusArgs = {
  data: ClientLocationStatusListInput;
  override?: Maybe<OverrideInput>;
};

export type QueryGetClientLocationArgs = {
  id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

export type QueryGetAllClientLocationsArgs = {
  data: ClientLocationListInput;
  override?: Maybe<OverrideInput>;
};

export type QueryGetActiveClientByAttrArgs = {
  key: UniqueClientKey;
  value: Scalars['String'];
  override?: Maybe<OverrideInput>;
};

export type QueryGetClientByEmailDomainArgs = {
  email_domain: Scalars['String'];
};

export type QueryIsGroupModeratorArgs = {
  group_id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type QueryGetModeratorsByGroupArgs = {
  group_id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

export type QueryGetGroupArgs = {
  id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

export type QueryGetActiveGroupsArgs = {
  data: GroupListInput;
  override?: Maybe<OverrideInput>;
};

export type QueryGetGroupColorsArgs = {
  override?: Maybe<OverrideInput>;
};

export type QueryGetGroupIconColorsArgs = {
  override?: Maybe<OverrideInput>;
};

export type QueryGetGroupIconsArgs = {
  override?: Maybe<OverrideInput>;
};

export type QueryGetActiveCommentsArgs = {
  data: CommentStatusInput;
  override?: Maybe<OverrideInput>;
};

export type QueryGetPublicUserProfileArgs = {
  user_id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

export type QueryGetUserProfileArgs = {
  id?: Maybe<Scalars['ID']>;
  override?: Maybe<OverrideInput>;
};

export type QueryGetProfilesByClientIdFullNameArgs = {
  full_name: Scalars['String'];
  limit: Scalars['Int'];
  override?: Maybe<OverrideInput>;
};

export type QueryGetProfilesByUserStatusArgs = {
  data: UserProfilesByStatusListInput;
  override?: Maybe<OverrideInput>;
};

export type QueryGetUserSegmentArgs = {
  id: Scalars['ID'];
  override?: Maybe<OverrideInput>;
};

export type QueryGetUserSegmentsArgs = {
  segment_status?: Maybe<SegmentStatus>;
  override?: Maybe<OverrideInput>;
};

export type QueryGetUserSegmentUsersArgs = {
  id: Scalars['ID'];
  active: Scalars['Boolean'];
  override?: Maybe<OverrideInput>;
  count?: Maybe<Scalars['Boolean']>;
};

export type QueryGetClientGroupSourcesByGroupArgs = {
  group_id: Scalars['ID'];
};

export type QueryGetContentArgs = {
  content_id: Scalars['String'];
  override?: Maybe<OverrideInput>;
};

export type QueryGetContentUrlParamOptionsArgs = {
  content_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  override?: Maybe<OverrideInput>;
};

export type QueryGetFeedArgs = {
  key: Scalars['String'];
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  id_lt?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Boolean']>;
  override?: Maybe<OverrideInput>;
};

export type QueryGetActionsArgs = {
  user_id?: Maybe<Scalars['ID']>;
  group_id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
  id_lt?: Maybe<Scalars['String']>;
  override?: Maybe<OverrideInput>;
};

export type QueryGetPaginatedUserFeedFollowsArgs = {
  data?: Maybe<PaginatedUserFeedFollowsInput>;
  override?: Maybe<OverrideInput>;
};

export type QueryGetPaginatedFollowedByUsersArgs = {
  data?: Maybe<PaginatedFollowedByUsersInput>;
  override?: Maybe<OverrideInput>;
};

export type QueryGetByUserFeedArgs = {
  data?: Maybe<FeedByUserInput>;
  override?: Maybe<OverrideInput>;
};

export type QueryFeedFollowingArgs = {
  data?: Maybe<FeedFollowingInput>;
  override?: Maybe<OverrideInput>;
};

export type QuerySearchArgs = {
  documents: Array<Maybe<SearchDocuments>>;
  size: Scalars['Int'];
  results_from: Scalars['Int'];
  q?: Maybe<Scalars['String']>;
  q_documents_must_match?: Maybe<Array<Maybe<SearchDocuments>>>;
  required_department_id?: Maybe<Scalars['ID']>;
  required_location_id?: Maybe<Scalars['ID']>;
  sort?: Maybe<SearchSortFields>;
  sort_direction?: Maybe<SearchSortDirections>;
  exclude_profile_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  exclude_group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  auto_exclude?: Maybe<Scalars['Boolean']>;
  override?: Maybe<OverrideInput>;
};

export type QueryGetUserSearchesArgs = {
  limit: Scalars['Int'];
  override?: Maybe<OverrideInput>;
};

export type QueryRecommendContentArgs = {
  size: Scalars['Int'];
  results_from: Scalars['Int'];
  for_sharing?: Maybe<Scalars['Boolean']>;
  auto_restrict_groups?: Maybe<Scalars['Boolean']>;
  auto_exclude_sharing?: Maybe<Scalars['Boolean']>;
  auto_weight_groups?: Maybe<Scalars['Boolean']>;
  exclude_content_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  restrict_group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  override?: Maybe<OverrideInput>;
};

export type QuerySearchAggregatesArgs = {
  document: SearchDocuments;
  override?: Maybe<OverrideInput>;
};

export type QuerySuggestArgs = {
  index?: Maybe<SuggestIndex>;
  prefix: Scalars['String'];
  override?: Maybe<OverrideInput>;
};

export type QueryGetInboxItemArgs = {
  id: Scalars['ID'];
};

export type QueryGetInboxItemsArgs = {
  data: InboxStatusInput;
};

export type QueryGetUserSocialConnectionsArgs = {
  user_id: Scalars['String'];
};

export type QueryGetSharePreviewInfoArgs = {
  content_id: Scalars['String'];
};

export type QueryGetSharesItemsArgs = {
  data: ItemsListInput;
  scheduled?: Maybe<Scalars['Boolean']>;
  group_by_session?: Maybe<Scalars['Boolean']>;
};

export type QueryGetManualNotificationItemsArgs = {
  data?: Maybe<ItemsListInput>;
  scheduled?: Maybe<Scalars['Boolean']>;
};

export type QueryUserEngagementStatsArgs = {
  user_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
};

export type QueryClientEngagementStatsArgs = {
  client_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
};

export type QueryUserReachStatsArgs = {
  user_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
};

export type QueryUserTrendingStatsArgs = {
  user_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
};

export type QueryUserDailyStatsArgs = {
  user_id: Scalars['ID'];
  grouping: StatsGrouping;
};

export type QueryClientReachStatsArgs = {
  client_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
};

export type QueryClientDailyStatsArgs = {
  client_id: Scalars['ID'];
  grouping: StatsGrouping;
};

export type QueryInternalOverviewStatsArgs = {
  client_id: Scalars['ID'];
  start_date: Scalars['String'];
  end_date: Scalars['String'];
};

export type QueryExternalOverviewStatsArgs = {
  client_id: Scalars['ID'];
  start_date: Scalars['String'];
  end_date: Scalars['String'];
};

export type ReachStat = {
  reach: Scalars['Int'];
  previous_reach?: Maybe<Scalars['Int']>;
  provider: Scalars['String'];
  profile_identifier?: Maybe<Scalars['String']>;
};

export type Reaction = {
  object_type: ObjectType;
  object_id: Scalars['String'];
  reaction_type: ReactionType;
  user_id: Scalars['String'];
  created_at: Scalars['Int'];
};

export type ReactionCount = {
  total: Scalars['Int'];
  reaction_types?: Maybe<Array<Maybe<ReactionTypeCount>>>;
};

export type ReactionInput = {
  object_type: ObjectType;
  object_id: Scalars['String'];
  reaction_type: ReactionType;
};

export enum ReactionType {
  Like = 'like',
}

export type ReactionTypeCount = {
  reaction_type?: Maybe<ReactionType>;
  total: Scalars['Int'];
};

export type RecommendedContentResults = {
  results?: Maybe<Array<Maybe<Content>>>;
  count: Scalars['Int'];
  results_from: Scalars['Int'];
};

/** Reddit Metadata */
export type RedditMetadata = {
  archived: Scalars['Boolean'];
  author: Scalars['String'];
  author_id: Scalars['String'];
  created_utc: Scalars['Int'];
  distinguished?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  is_original_content: Scalars['Boolean'];
  is_self: Scalars['Boolean'];
  is_video: Scalars['Boolean'];
  media_only: Scalars['Boolean'];
  name: Scalars['String'];
  num_comments?: Maybe<Scalars['Int']>;
  over_18: Scalars['Boolean'];
  permalink: Scalars['String'];
  oembed_description?: Maybe<Scalars['String']>;
  oembed_height?: Maybe<Scalars['Int']>;
  oembed_width?: Maybe<Scalars['Int']>;
  oembed_html?: Maybe<Scalars['String']>;
  oembed_html_secure?: Maybe<Scalars['String']>;
  oembed_provider_name?: Maybe<Scalars['String']>;
  oembed_provider_url?: Maybe<Scalars['String']>;
  oembed_thumbnail_url?: Maybe<Scalars['String']>;
  oembed_thumbnail_width?: Maybe<Scalars['Int']>;
  oembed_thumbnail_height?: Maybe<Scalars['Int']>;
  oembed_thumbnail_bucket?: Maybe<Scalars['String']>;
  oembed_thumbnail_file_key?: Maybe<Scalars['String']>;
  oembed_title?: Maybe<Scalars['String']>;
  oembed_type?: Maybe<Scalars['String']>;
  preview_image_url?: Maybe<Scalars['String']>;
  preview_image_width?: Maybe<Scalars['Int']>;
  preview_image_height?: Maybe<Scalars['Int']>;
  preview_image_file_key?: Maybe<Scalars['String']>;
  preview_image_bucket?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  video_url?: Maybe<Scalars['String']>;
  video_width?: Maybe<Scalars['Int']>;
  video_height?: Maybe<Scalars['Int']>;
  video_duration?: Maybe<Scalars['Int']>;
  selftext?: Maybe<Scalars['String']>;
  selftext_html?: Maybe<Scalars['String']>;
  spoiler: Scalars['Boolean'];
  subreddit: Scalars['String'];
  subreddit_id: Scalars['String'];
  subreddit_name_prefixed: Scalars['String'];
  subscribers?: Maybe<Scalars['Int']>;
  subreddit_type: Scalars['String'];
  thumbnail_url?: Maybe<Scalars['String']>;
  thumbnail_width?: Maybe<Scalars['Int']>;
  thumbnail_height?: Maybe<Scalars['Int']>;
  thumbnail_bucket?: Maybe<Scalars['String']>;
  thumbnail_file_key?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type RedditMetadataInput = {
  archived: Scalars['Boolean'];
  author: Scalars['String'];
  author_id: Scalars['String'];
  created_utc: Scalars['Int'];
  distinguished?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  is_original_content: Scalars['Boolean'];
  is_self: Scalars['Boolean'];
  is_video: Scalars['Boolean'];
  media_only: Scalars['Boolean'];
  name: Scalars['String'];
  num_comments?: Maybe<Scalars['Int']>;
  over_18: Scalars['Boolean'];
  permalink: Scalars['String'];
  oembed_description?: Maybe<Scalars['String']>;
  oembed_height?: Maybe<Scalars['Int']>;
  oembed_width?: Maybe<Scalars['Int']>;
  oembed_html?: Maybe<Scalars['String']>;
  oembed_html_secure?: Maybe<Scalars['String']>;
  oembed_provider_name?: Maybe<Scalars['String']>;
  oembed_provider_url?: Maybe<Scalars['String']>;
  oembed_thumbnail_url?: Maybe<Scalars['String']>;
  oembed_thumbnail_width?: Maybe<Scalars['Int']>;
  oembed_thumbnail_height?: Maybe<Scalars['Int']>;
  oembed_thumbnail_bucket?: Maybe<Scalars['String']>;
  oembed_thumbnail_file_key?: Maybe<Scalars['String']>;
  oembed_title?: Maybe<Scalars['String']>;
  oembed_type?: Maybe<Scalars['String']>;
  preview_image_url?: Maybe<Scalars['String']>;
  preview_image_width?: Maybe<Scalars['Int']>;
  preview_image_height?: Maybe<Scalars['Int']>;
  preview_image_file_key?: Maybe<Scalars['String']>;
  preview_image_bucket?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  video_url?: Maybe<Scalars['String']>;
  video_width?: Maybe<Scalars['Int']>;
  video_height?: Maybe<Scalars['Int']>;
  video_duration?: Maybe<Scalars['Int']>;
  selftext?: Maybe<Scalars['String']>;
  selftext_html?: Maybe<Scalars['String']>;
  spoiler: Scalars['Boolean'];
  subreddit: Scalars['String'];
  subreddit_id: Scalars['String'];
  subreddit_name_prefixed: Scalars['String'];
  subscribers?: Maybe<Scalars['Int']>;
  subreddit_type: Scalars['String'];
  thumbnail_url?: Maybe<Scalars['String']>;
  thumbnail_width?: Maybe<Scalars['Int']>;
  thumbnail_height?: Maybe<Scalars['Int']>;
  thumbnail_bucket?: Maybe<Scalars['String']>;
  thumbnail_file_key?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type Report = {
  name: Scalars['String'];
  description: Scalars['String'];
  available: Scalars['Boolean'];
};

/** input to run a report */
export type ReportFilter = {
  filter_type: ReportFilterType;
  filter_ids: Array<Maybe<Scalars['ID']>>;
};

/** Reports */
export enum ReportFilterType {
  Group = 'group',
}

/**
 *  Data for a requested report.  The report_url is temporary signed url to the report result.
 * This is also what is returned from createReportRequest.
 */
export type ReportRequest = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  requestor?: Maybe<PublicUserProfile>;
  report: Report;
  request_status: ReportRequestStatus;
  start_at?: Maybe<Scalars['Int']>;
  end_at?: Maybe<Scalars['Int']>;
  error_details?: Maybe<Scalars['String']>;
  report_url?: Maybe<Scalars['String']>;
  report_start: Scalars['Int'];
  report_end: Scalars['Int'];
};

export type ReportRequestList = {
  report_requests?: Maybe<Array<Maybe<ReportRequest>>>;
  count: Scalars['Int'];
  paginate: Scalars['Boolean'];
};

export type ReportRequestListInput = {
  report_name?: Maybe<Scalars['String']>;
  start_at?: Maybe<Scalars['Int']>;
  end_at?: Maybe<Scalars['Int']>;
  requestor?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
};

export enum ReportRequestStatus {
  Generating = 'Generating',
  Completed = 'Completed',
  Error = 'Error',
}

/** Result from getReportResult explicit call. Result is the contents of the report result bucket. */
export type ReportResult = {
  request: ReportRequest;
  result: Scalars['String'];
};

export type ReportUrl = {
  request_id: Scalars['ID'];
  url: Scalars['String'];
};

export type RunReportInput = {
  report_name: Scalars['String'];
  start_at?: Maybe<Scalars['Int']>;
  end_at?: Maybe<Scalars['Int']>;
  group_by?: Maybe<StatsGrouping>;
  filter_by?: Maybe<Array<Maybe<ReportFilter>>>;
};

export type S3Object = {
  bucket: Scalars['String'];
  key: Scalars['String'];
  region: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
};

export type S3ObjectInput = {
  bucket: Scalars['String'];
  key: Scalars['String'];
  region: Scalars['String'];
  localUri?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
};

export type S3VideoObject = {
  playlist?: Maybe<Scalars['String']>;
  poster?: Maybe<Scalars['String']>;
  thumbnails?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type S3VideoObjectInput = {
  bucket: Scalars['String'];
  key: Scalars['String'];
  region: Scalars['String'];
};

export type ScheduledShareContentInput = {
  items: Array<ScheduledShareUpdateInputItem>;
};

export type ScheduledShareItem = {
  id: Scalars['ID'];
  share_session_id: Scalars['ID'];
  network_id: Scalars['ID'];
  share_at: Scalars['String'];
  user_commentary: Scalars['String'];
  network: Scalars['String'];
  shared_at?: Maybe<Scalars['String']>;
};

export type ScheduledShareUpdateInputItem = {
  id: Scalars['ID'];
  user_commentary?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['String']>;
  share_at?: Maybe<Scalars['Int']>;
  share_type?: Maybe<ShareType>;
};

export type SearchAggregates = {
  departments?: Maybe<Array<Maybe<ClientDepartment>>>;
  locations?: Maybe<Array<Maybe<ClientLocation>>>;
  total: Scalars['Int'];
};

/** Search */
export enum SearchDocuments {
  Groups = 'groups',
  Profiles = 'profiles',
  Content = 'content',
}

export type SearchResults = {
  results?: Maybe<Array<Maybe<SearchResultsObject>>>;
  count: Scalars['Int'];
  results_from: Scalars['Int'];
};

export type SearchResultsObject = Group | PublicUserProfile | Content;

export enum SearchSortDirections {
  Asc = 'asc',
  Desc = 'desc',
}

export enum SearchSortFields {
  Title = 'title',
  CreatedAt = 'created_at',
  FollowerCount = 'follower_count',
}

export enum SegmentStatus {
  Active = 'active',
  Disabled = 'disabled',
}

export enum ShareContentDestination {
  Email = 'email',
  Direct = 'direct',
  Facebook = 'facebook',
}

export type ShareContentInput = {
  network_id?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['String']>;
  user_commentary?: Maybe<Scalars['String']>;
  share_type?: Maybe<ShareType>;
  share_at?: Maybe<Scalars['Int']>;
  destination?: Maybe<ShareContentDestination>;
};

export type SharedContentItem = {
  url?: Maybe<Scalars['String']>;
  shortened_url?: Maybe<ShortenedUrlItem>;
  share_session_id: Scalars['ID'];
  error?: Maybe<Scalars['String']>;
  status: SharedStatus;
  network_id: Scalars['ID'];
};

export type SharedContentResults = {
  results: Array<SharedContentItem>;
};

export enum SharedStatus {
  Successful = 'successful',
  Failed = 'failed',
  Pending = 'pending',
}

export type SharesItem = {
  id: Scalars['ID'];
  successful: Scalars['Boolean'];
  content_id: Scalars['ID'];
  network: Scalars['String'];
  identifier?: Maybe<Scalars['String']>;
  shared_at?: Maybe<Scalars['Int']>;
  user_commentary?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['String']>;
  content?: Maybe<Content>;
  created_at: Scalars['Int'];
  share_session_id: Scalars['ID'];
  share_at: Scalars['Int'];
  client_id: Scalars['ID'];
  user_id: Scalars['ID'];
  photo_share: Scalars['Boolean'];
  urls: IUrls;
  share_type?: Maybe<Scalars['String']>;
  share_content_type?: Maybe<Scalars['String']>;
  share_source?: Maybe<Scalars['String']>;
  destination?: Maybe<Scalars['String']>;
  share_identifier?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['String']>;
  clicks?: Maybe<Scalars['Int']>;
  engagements?: Maybe<Scalars['Int']>;
};

export type SharesList = {
  count: Scalars['Int'];
  items: Array<SharesItem>;
  items_by_session?: Maybe<Array<Array<SharesItem>>>;
  limit?: Maybe<Scalars['Int']>;
  paginate: Scalars['Boolean'];
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
};

export enum ShareType {
  Scheduled = 'scheduled',
  Now = 'now',
  Frontend = 'frontend',
}

export type ShortenedUrlItem = {
  id?: Maybe<Scalars['String']>;
  short_link?: Maybe<Scalars['String']>;
};

export type ShortenedUrLs = {
  email?: Maybe<ShortenedUrlItem>;
  direct?: Maybe<ShortenedUrlItem>;
  twitter?: Maybe<ShortenedUrlItem>;
  linkedin?: Maybe<ShortenedUrlItem>;
  facebook?: Maybe<ShortenedUrlItem>;
};

export type SocialAccount = {
  id: Scalars['String'];
  provider: Network;
  identifier?: Maybe<Scalars['String']>;
  profile_name?: Maybe<Scalars['String']>;
  reach?: Maybe<Scalars['Int']>;
  expires_soon: Scalars['Boolean'];
  profile_url?: Maybe<Scalars['String']>;
};

export type SocialAccountConnectionsList = {
  count: Scalars['Int'];
  items: Array<SocialAccount>;
};

export enum SourceStatus {
  Active = 'active',
  Disabled = 'disabled',
}

export type SsoConfiguration = {
  metadata?: Maybe<Scalars['String']>;
  metadata_url?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
};

export type SsoConfigurationInput = {
  metadata?: Maybe<Scalars['String']>;
  metadata_url?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
};

export enum StatsGrouping {
  Year = 'year',
  Month = 'month',
  Week = 'week',
}

/** Generic fields */
export type Status = {
  status: Scalars['Boolean'];
};

export type Subscription = {
  /** "to_user_id" must be available in the result of the mutation for this subscription to work! */
  inboxItemCreated?: Maybe<Inbox>;
  followed?: Maybe<UserFeedFollow>;
  unfollowed?: Maybe<UserFeedFollow>;
};

export type SubscriptionInboxItemCreatedArgs = {
  to_user_id: Scalars['ID'];
};

export type SubscriptionFollowedArgs = {
  user_id: Scalars['ID'];
};

export type SubscriptionUnfollowedArgs = {
  user_id: Scalars['ID'];
};

export enum SuggestIndex {
  Suggestedprofiles = 'suggestedprofiles',
  Suggestedgroups = 'suggestedgroups',
}

export type SuggestionResults = {
  results?: Maybe<Array<Maybe<SuggestionResultsObject>>>;
};

export type SuggestionResultsObject = GroupSuggestion | ProfileSuggestion;

export type TrendingData = {
  posts: Scalars['Int'];
  clicks: Scalars['Int'];
  shares: Scalars['Int'];
  calendar_day: Scalars['String'];
};

export type TrendingEngagementStat = {
  total_posts: Scalars['Int'];
  total_shares: Scalars['Int'];
  total_clicks: Scalars['Int'];
  data: Array<Maybe<TrendingData>>;
};

/** Content / Tweet Metadata fields */
export type TweetHashtag = {
  text: Scalars['String'];
};

export type TweetHashtagInput = {
  text: Scalars['String'];
};

export type TweetMedia = {
  media_url_https?: Maybe<Scalars['String']>;
  media_url_original?: Maybe<Scalars['String']>;
  media_url_proxy?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type TweetMediaInput = {
  media_url_https?: Maybe<Scalars['String']>;
  media_url_original?: Maybe<Scalars['String']>;
  media_url_proxy?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type TweetMetadata = {
  id_str: Scalars['String'];
  created_at?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  possibly_sensitive?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  in_reply_to_user_id_str?: Maybe<Scalars['String']>;
  in_reply_to_status_id_str?: Maybe<Scalars['String']>;
  favorite_count?: Maybe<Scalars['Int']>;
  retweet_count?: Maybe<Scalars['Int']>;
  user: TweetUser;
  place?: Maybe<TweetPlace>;
  hashtags?: Maybe<Array<Maybe<TweetHashtag>>>;
  urls?: Maybe<Array<Maybe<TweetUrl>>>;
  user_mentions?: Maybe<Array<Maybe<TweetUserMention>>>;
  media?: Maybe<Array<Maybe<TweetMedia>>>;
};

export type TweetMetadataInput = {
  id_str: Scalars['String'];
  created_at?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  possibly_sensitive?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  in_reply_to_user_id_str?: Maybe<Scalars['String']>;
  in_reply_to_status_id_str?: Maybe<Scalars['String']>;
  favorite_count?: Maybe<Scalars['Int']>;
  retweet_count?: Maybe<Scalars['Int']>;
  user: TweetUserInput;
  place?: Maybe<TweetPlaceInput>;
  hashtags?: Maybe<Array<Maybe<TweetHashtagInput>>>;
  urls?: Maybe<Array<Maybe<TweetUrlInput>>>;
  user_mentions?: Maybe<Array<Maybe<TweetUserMentionInput>>>;
  media?: Maybe<Array<Maybe<TweetMediaInput>>>;
};

export type TweetPlace = {
  country?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  place_type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TweetPlaceInput = {
  country?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  place_type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TweetUrl = {
  display_url?: Maybe<Scalars['String']>;
  expanded_url?: Maybe<Scalars['String']>;
};

export type TweetUrlInput = {
  display_url?: Maybe<Scalars['String']>;
  expanded_url?: Maybe<Scalars['String']>;
};

export type TweetUser = {
  id_str: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  screen_name: Scalars['String'];
  profile_image_url_https?: Maybe<Scalars['String']>;
  profile_image_url_original?: Maybe<Scalars['String']>;
  profile_image_url_proxy?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  followers_count?: Maybe<Scalars['Int']>;
  friends_count?: Maybe<Scalars['Int']>;
  lang?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  protected?: Maybe<Scalars['Boolean']>;
  statuses_count?: Maybe<Scalars['Int']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type TweetUserInput = {
  id_str: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  screen_name: Scalars['String'];
  profile_image_url_https?: Maybe<Scalars['String']>;
  profile_image_url_original?: Maybe<Scalars['String']>;
  profile_image_url_proxy?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  followers_count?: Maybe<Scalars['Int']>;
  friends_count?: Maybe<Scalars['Int']>;
  lang?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  protected?: Maybe<Scalars['Boolean']>;
  statuses_count?: Maybe<Scalars['Int']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type TweetUserMention = {
  id_str?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  screen_name?: Maybe<Scalars['String']>;
};

export type TweetUserMentionInput = {
  id_str?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  screen_name?: Maybe<Scalars['String']>;
};

/** Clients */
export enum UniqueClientKey {
  Subdomain = 'subdomain',
  Id = 'id',
  EmailDomain = 'email_domain',
}

export type UpdateClientDepartmentInput = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  department_status?: Maybe<ClientDepartmentStatus>;
};

export type UpdateClientFollowMappingInput = {
  id: Scalars['ID'];
  title: Scalars['String'];
  mapping_status: ClientFollowMappingStatus;
  follow_conditions?: Maybe<FollowConditionsInput>;
  all_users: Scalars['Boolean'];
  required_group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  suggested_group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  required_user_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  suggested_user_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type UpdateClientLocationInput = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  location_status?: Maybe<ClientLocationStatus>;
};

export type UpdateGroupInput = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  group_status?: Maybe<GroupStatus>;
  content_approval_type?: Maybe<GroupContentApprovalType>;
  description?: Maybe<Scalars['String']>;
  allow_user_posts?: Maybe<Scalars['Boolean']>;
  color?: Maybe<GroupColor>;
  icon_color?: Maybe<GroupIconColor>;
  icon?: Maybe<GroupIcon>;
  image?: Maybe<S3ObjectInput>;
  department_id?: Maybe<Scalars['ID']>;
  location_id?: Maybe<Scalars['ID']>;
};

export type UpdateUserSegmentInput = {
  id: Scalars['ID'];
  title: Scalars['String'];
  segment_status: SegmentStatus;
  department_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  location_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  user_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  email_addresses?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UrlMetadata = {
  type: UrlMetadataType;
  provider_display?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  original_url?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  safe?: Maybe<Scalars['Boolean']>;
  images?: Maybe<Array<Maybe<UrlMetadataImage>>>;
  media?: Maybe<UrlMetadataMedia>;
};

export type UrlMetadataImage = {
  url: Scalars['String'];
  bucket?: Maybe<Scalars['String']>;
  file_key?: Maybe<Scalars['String']>;
  url_proxy?: Maybe<Scalars['Boolean']>;
  url_original?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  primary?: Maybe<Scalars['Boolean']>;
};

export type UrlMetadataImageInput = {
  url: Scalars['String'];
  url_proxy?: Maybe<Scalars['Boolean']>;
  url_original?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  primary?: Maybe<Scalars['Boolean']>;
};

export type UrlMetadataInput = {
  type: UrlMetadataType;
  provider_display?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  original_url?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  safe?: Maybe<Scalars['Boolean']>;
  images?: Maybe<Array<Maybe<UrlMetadataImageInput>>>;
  media?: Maybe<UrlMetadataMediaInput>;
};

export type UrlMetadataMedia = {
  duration?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  html?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  file_key?: Maybe<Scalars['String']>;
  url_proxy?: Maybe<Scalars['Boolean']>;
  url_original?: Maybe<Scalars['String']>;
};

export type UrlMetadataMediaInput = {
  duration?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  html?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  file_key?: Maybe<Scalars['String']>;
  url_proxy?: Maybe<Scalars['Boolean']>;
  url_original?: Maybe<Scalars['String']>;
};

export enum UrlMetadataType {
  Html = 'html',
  Image = 'image',
  Audio = 'audio',
  Video = 'video',
  Unknown = 'unknown',
}

export type UserFeedFollow = {
  feed: FeedKey;
  user_id: Scalars['ID'];
  created_at: Scalars['Int'];
  group?: Maybe<Group>;
  user?: Maybe<PublicUserProfile>;
  followed_by_user: PublicUserProfile;
  postable: Scalars['Boolean'];
  required?: Maybe<Scalars['Boolean']>;
};

export type UserFollowMappings = {
  required_group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  required_groups?: Maybe<Array<Maybe<Group>>>;
  suggested_group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  suggested_groups?: Maybe<Array<Maybe<Group>>>;
  required_user_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  required_users?: Maybe<Array<Maybe<PublicUserProfile>>>;
  suggested_user_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  suggested_users?: Maybe<Array<Maybe<PublicUserProfile>>>;
};

export type UserProfile = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  email_address: Scalars['String'];
  user_status: UserStatus;
  user_type: UserType;
  user_pool_id: Scalars['String'];
  email_address_verified: Scalars['Boolean'];
  backup_email_address?: Maybe<Scalars['String']>;
  backup_email_address_verified?: Maybe<Scalars['Boolean']>;
  notification_delivery_types?: Maybe<Array<Maybe<NotificationDeliveryType>>>;
  phone_number?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  image?: Maybe<S3Object>;
  reach?: Maybe<Scalars['Int']>;
  user_timezone?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
  deactivated_by_user_id?: Maybe<Scalars['String']>;
  deactivated_at?: Maybe<Scalars['Int']>;
  deactivated_message?: Maybe<Scalars['String']>;
  send_invitations?: Maybe<Scalars['Boolean']>;
  invitation_sent_at?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
  onboarding_completed?: Maybe<Scalars['Boolean']>;
  last_onboarding_step?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['Int']>;
  last_accessed_at?: Maybe<Scalars['Int']>;
  push_notification_configuration?: Maybe<Array<Maybe<PushNotificationConfiguration>>>;
  push_notifications_status?: Maybe<PushNotificationStatus>;
  german_privacy?: Maybe<Scalars['Boolean']>;
  leaderboard_enabled?: Maybe<Scalars['Boolean']>;
  group_moderator?: Maybe<Array<Maybe<GroupModerator>>>;
  department_id?: Maybe<Scalars['ID']>;
  location_id?: Maybe<Scalars['ID']>;
  department?: Maybe<ClientDepartment>;
  location?: Maybe<ClientLocation>;
  department_title?: Maybe<Scalars['String']>;
  location_title?: Maybe<Scalars['String']>;
  follower_count?: Maybe<Scalars['Int']>;
  karma?: Maybe<Scalars['String']>;
};

export type UserProfileInput = {
  id: Scalars['ID'];
  email_address?: Maybe<Scalars['String']>;
  user_status?: Maybe<UserStatus>;
  user_type?: Maybe<UserType>;
  user_pool_id?: Maybe<Scalars['String']>;
  email_address_verified?: Maybe<Scalars['Boolean']>;
  backup_email_address?: Maybe<Scalars['String']>;
  backup_email_address_verified?: Maybe<Scalars['Boolean']>;
  phone_number?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  image?: Maybe<S3ObjectInput>;
  reach?: Maybe<Scalars['Int']>;
  user_timezone?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
  deactivated_by_user_id?: Maybe<Scalars['String']>;
  deactivated_at?: Maybe<Scalars['Int']>;
  deactivated_message?: Maybe<Scalars['String']>;
  send_invitations?: Maybe<Scalars['Boolean']>;
  invitation_sent_at?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
  onboarding_completed?: Maybe<Scalars['Boolean']>;
  last_onboarding_step?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['Int']>;
  last_accessed_at?: Maybe<Scalars['Int']>;
  notification_delivery_types?: Maybe<Array<Maybe<NotificationDeliveryType>>>;
  push_notification_configuration?: Maybe<Array<Maybe<PushNotificationConfigurationInput>>>;
  delete_push_token?: Maybe<Scalars['String']>;
  german_privacy?: Maybe<Scalars['Boolean']>;
  department_id?: Maybe<Scalars['ID']>;
  location_id?: Maybe<Scalars['ID']>;
};

export type UserProfilesByStatusList = {
  profiles?: Maybe<Array<Maybe<UserProfile>>>;
  count: Scalars['Int'];
  paginate: Scalars['Boolean'];
  full_name_lower?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type UserProfilesByStatusListInput = {
  count?: Maybe<Scalars['Boolean']>;
  user_status: UserStatus;
  full_name_lower?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
};

export type UserSegment = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  title: Scalars['String'];
  segment_status: SegmentStatus;
  user_id: Scalars['ID'];
  department_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  departments?: Maybe<Array<Maybe<ClientDepartment>>>;
  location_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  locations?: Maybe<Array<Maybe<ClientLocation>>>;
  group_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  groups?: Maybe<Array<Maybe<Group>>>;
  user_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<PublicUserProfile>>>;
  email_addresses?: Maybe<Array<Maybe<Scalars['String']>>>;
  created_at?: Maybe<Scalars['Int']>;
};

export type UserSegmentsByStatusList = {
  user_segments?: Maybe<Array<Maybe<UserSegment>>>;
  count: Scalars['Int'];
  paginate: Scalars['Boolean'];
  segment_status?: Maybe<SegmentStatus>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type UserSegmentUsers = {
  users_count: Scalars['Int'];
  email_addresses_count: Scalars['Int'];
  users?: Maybe<Array<Maybe<UserProfile>>>;
  email_addresses?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** User fields */
export enum UserStatus {
  Active = 'active',
  Disabled = 'disabled',
}

export enum UserType {
  User = 'user',
  Admin = 'admin',
  Cs = 'cs',
  Contributor = 'contributor',
}

/** Youtube Content Metadata */
export type YoutubeMetadata = {
  video_id: Scalars['String'];
  video_url: Scalars['String'];
  channel_id?: Maybe<Scalars['String']>;
  channel_url?: Maybe<Scalars['String']>;
  video_title?: Maybe<Scalars['String']>;
  video_description?: Maybe<Scalars['String']>;
  video_thumbnail_original_url?: Maybe<Scalars['String']>;
  video_thumbnail_bucket?: Maybe<Scalars['String']>;
  video_thumbnail_file_key?: Maybe<Scalars['String']>;
  video_thumbnail_width?: Maybe<Scalars['Int']>;
  video_thumbnail_height?: Maybe<Scalars['Int']>;
  video_published_at?: Maybe<Scalars['Int']>;
  video_player?: Maybe<Scalars['String']>;
  video_projection?: Maybe<Scalars['String']>;
  video_duration?: Maybe<Scalars['String']>;
  video_dimension?: Maybe<Scalars['String']>;
  video_definition?: Maybe<Scalars['String']>;
  channel_country?: Maybe<Scalars['String']>;
  channel_description?: Maybe<Scalars['String']>;
  channel_title?: Maybe<Scalars['String']>;
  channel_thumbnail_original_url?: Maybe<Scalars['String']>;
  channel_thumbnail_bucket?: Maybe<Scalars['String']>;
  channel_thumbnail_file_key?: Maybe<Scalars['String']>;
  channel_thumbnail_width?: Maybe<Scalars['Int']>;
  channel_thumbnail_height?: Maybe<Scalars['Int']>;
};

export type YoutubeMetadataInput = {
  video_id: Scalars['String'];
  video_url: Scalars['String'];
  channel_id?: Maybe<Scalars['String']>;
  channel_url?: Maybe<Scalars['String']>;
  video_title?: Maybe<Scalars['String']>;
  video_description?: Maybe<Scalars['String']>;
  video_thumbnail_original_url?: Maybe<Scalars['String']>;
  video_thumbnail_bucket?: Maybe<Scalars['String']>;
  video_thumbnail_file_key?: Maybe<Scalars['String']>;
  video_thumbnail_width?: Maybe<Scalars['Int']>;
  video_thumbnail_height?: Maybe<Scalars['Int']>;
  video_published_at?: Maybe<Scalars['Int']>;
  video_player?: Maybe<Scalars['String']>;
  video_projection?: Maybe<Scalars['String']>;
  video_duration?: Maybe<Scalars['String']>;
  video_dimension?: Maybe<Scalars['String']>;
  video_definition?: Maybe<Scalars['String']>;
  channel_country?: Maybe<Scalars['String']>;
  channel_description?: Maybe<Scalars['String']>;
  channel_title?: Maybe<Scalars['String']>;
  channel_thumbnail_original_url?: Maybe<Scalars['String']>;
  channel_thumbnail_bucket?: Maybe<Scalars['String']>;
  channel_thumbnail_file_key?: Maybe<Scalars['String']>;
  channel_thumbnail_width?: Maybe<Scalars['Int']>;
  channel_thumbnail_height?: Maybe<Scalars['Int']>;
};

export type ClientCommonFragment = Pick<
  Client,
  | 'id'
  | 'title'
  | 'subdomain'
  | 'email_domains'
  | 'content_domains'
  | 'client_status'
  | 'authentication_type'
  | 'allow_user_signup'
  | 'departments_in_signup'
  | 'departments_in_signup_required'
  | 'locations_in_signup'
  | 'locations_in_signup_required'
  | 'default_timezone'
  | 'default_language'
  | 'support_multiple_languages'
> & {
  sso_configuration: Maybe<Pick<SsoConfiguration, 'provider'>>;
  image: Maybe<Pick<S3Object, 'bucket' | 'key' | 'width' | 'height' | 'region'>>;
};

export type ClientDepartmentFragment = Pick<
  ClientDepartment,
  'id' | 'title' | 'department_status' | 'groups_total' | 'profiles_total'
>;

export type ClientFollowMappingFragment = Pick<
  ClientFollowMapping,
  'id' | 'title' | 'mapping_status' | 'all_users'
> & {
  required_groups: Maybe<Array<Maybe<GroupFragment>>>;
  suggested_groups: Maybe<Array<Maybe<GroupFragment>>>;
  required_users: Maybe<Array<Maybe<PublicUserProfileFragment>>>;
  suggested_users: Maybe<Array<Maybe<PublicUserProfileFragment>>>;
  follow_conditions: Maybe<
    Pick<FollowConditions, 'department_id' | 'location_id' | 'language' | 'email_domain'> & {
      departments: Maybe<Array<Maybe<ClientDepartmentFragment>>>;
      locations: Maybe<Array<Maybe<ClientLocationFragment>>>;
    }
  >;
};

export type ClientGroupSourceFragment = Pick<
  ClientGroupSource,
  'id' | 'group_id' | 'source_status' | 'source_type' | 'source_value' | 'approval'
>;

export type ClientInvitationFragment = Pick<
  ClientInvitation,
  | 'id'
  | 'client_id'
  | 'email_address'
  | 'invitation_status'
  | 'subject'
  | 'message'
  | 'email_from_address'
  | 'created_at'
  | 'updated_at'
  | 'last_sent_at'
  | 'retries'
  | 'accepted_at'
  | 'accepted_by_user_id'
>;

export type ClientLocationFragment = Pick<
  ClientLocation,
  'id' | 'title' | 'location_status' | 'groups_total' | 'profiles_total'
>;

export type ClientProtectedFragment = Pick<
  Client,
  | 'created_at'
  | 'email_from_address'
  | 'allow_user_invites'
  | 'content_domains'
  | 'allow_group_creation'
  | 'disable_comments'
  | 'disable_timeline'
  | 'email_address'
  | 'sso_provider'
> &
  ClientCommonFragment;

export type ClientPublicFragment = ClientCommonFragment;

export type ClientUrlParamsFragment = Pick<
  ClientUrlParams,
  'id' | 'params_status' | 'content_domain'
> & {
  configuration: Maybe<
    Array<
      Maybe<
        Pick<
          ClientUrlParamsConfiguration,
          'key' | 'value' | 'dynamic_value' | 'value_options' | 'default_option_value'
        >
      >
    >
  >;
};

export type CommentFragment = Pick<
  Comment,
  'id' | 'comment_text' | 'object_id' | 'has_substitutions'
> & {
  user: Maybe<
    Pick<PublicUserProfile, 'id' | 'full_name'> & {
      image: Maybe<Pick<S3Object, 'bucket' | 'key' | 'width' | 'height'>>;
    }
  >;
  users_mentioned: Maybe<Array<Maybe<Pick<PublicUserProfile, 'id' | 'full_name'>>>>;
};

export type ContentFragment = Pick<
  Content,
  | 'content_id'
  | 'content_source_id'
  | 'is_shareable'
  | 'is_important'
  | 'is_engage'
  | 'is_pinned'
  | 'pinned_end_at'
  | 'important_to_share'
  | 'share_count'
  | 'engagement_count'
  | 'click_count'
  | 'publish_at'
  | 'group_ids'
  | 'has_requesting_user_shared'
> & {
  commentary: Maybe<Array<Maybe<Pick<ContentCommentary, 'network' | 'commentary'>>>>;
  group_id_approvals: Array<Maybe<Pick<GroupIdApproval, 'group_id' | 'approval'>>>;
  content_object: ContentObjectFragment;
  reactions: Maybe<ContentReactionsFragment>;
  comments: Maybe<
    Pick<CommentsList, 'id' | 'created_at' | 'paginate' | 'count'> & {
      comments: Maybe<Array<Maybe<CommentFragment>>>;
    }
  >;
  groups: Maybe<Array<Maybe<GetFeedGroupFragment>>>;
  user: Maybe<PublicUserProfileFragment>;
  url_param_values: Maybe<Array<Maybe<Pick<ContentUrlParamValues, 'key' | 'value'>>>>;
};

export type ContentShareFragment = Pick<
  Content,
  | 'content_id'
  | 'share_count'
  | 'engagement_count'
  | 'click_count'
  | 'publish_at'
  | 'has_requesting_user_shared'
> & {
  commentary: Maybe<Array<Maybe<Pick<ContentCommentary, 'network' | 'commentary'>>>>;
  groups: Maybe<Array<Maybe<GetFeedGroupFragment>>>;
  content_object: ContentObjectFragment;
};

export type ContentObjectFragment = Pick<
  ContentObject,
  'post_type' | 'metadata_keys' | 'body' | 'url'
> & {
  photos: Maybe<Array<Maybe<Pick<S3Object, 'bucket' | 'key' | 'width' | 'height' | 'region'>>>>;
  url_metadata: Maybe<
    Pick<
      UrlMetadata,
      'original_url' | 'provider_display' | 'provider_name' | 'title' | 'url' | 'description'
    > & {
      images: Maybe<
        Array<
          Maybe<Pick<UrlMetadataImage, 'bucket' | 'file_key' | 'height' | 'width' | 'url_original'>>
        >
      >;
    }
  >;
  tweet_metadata: Maybe<TweetMetadataFragment>;
  youtube_metadata: Maybe<Pick<YoutubeMetadata, 'video_id'>>;
  instagram_metadata: Maybe<Pick<InstagramMetadata, 'id' | 'shortcode'>>;
  reddit_metadata: Maybe<Pick<RedditMetadata, 'url'>>;
};

export type ContentReactionsFragment = Pick<ContentReactions, 'user_reactions'> & {
  reaction_count: Maybe<Pick<ReactionCount, 'total'>>;
  reaction_user_details: Maybe<Array<Maybe<PublicUserProfileFragment>>>;
};

export type GroupFragment = Pick<
  Group,
  | 'id'
  | 'created_at'
  | 'title'
  | 'follower_count'
  | 'color'
  | 'allow_user_posts'
  | 'content_approval_type'
  | 'group_status'
  | 'icon'
  | 'icon_color'
  | 'location_id'
  | 'location_title'
  | 'department_id'
  | 'department_title'
> & {
  color_map: Pick<GroupColorMap, 'hex'>;
  icon_color_map: Pick<GroupIconColorMap, 'hex'>;
  icon_map: Pick<GroupIconMap, 'bucket' | 'file_key' | 'width' | 'height'>;
  image: Maybe<Pick<S3Object, 'bucket' | 'key' | 'width' | 'height' | 'region'>>;
};

export type GetFeedGroupFragment = Pick<Group, 'id' | 'title'> & {
  color_map: Pick<GroupColorMap, 'hex'>;
};

export type UserFeedFollowGroupFragment = Pick<
  Group,
  'id' | 'title' | 'follower_count' | 'location_title' | 'department_title'
> & {
  color_map: Pick<GroupColorMap, 'hex'>;
  icon_map: Pick<GroupIconMap, 'bucket' | 'file_key' | 'width' | 'height'>;
  image: Maybe<Pick<S3Object, 'bucket' | 'key' | 'width' | 'height'>>;
};

export type GroupModeratorFragment = Pick<
  GroupModerator,
  'group_id' | 'user_id' | 'created_at' | 'added_by_user_id'
> & { user: Maybe<PublicUserProfileFragment> };

export type GroupSearchResultsFragment = Pick<SearchResults, 'count' | 'results_from'> & {
  results: Maybe<Array<Maybe<UserFeedFollowGroupFragment>>>;
};

export type InboxFragment = Pick<
  Inbox,
  'id' | 'created_at' | 'updated_at' | 'item_read' | 'message' | 'to_user_id' | 'url'
>;

export type LeaderboardConfigFragment = Pick<
  LeaderboardConfig,
  | 'id'
  | 'title'
  | 'description'
  | 'leaderboard_status'
  | 'created_at'
  | 'start_at'
  | 'end_at'
  | 'all_users'
  | 'segment_ids'
> & { segments: Maybe<Array<Maybe<UserSegmentFragment>>> };

export type LeaderboardScoreFragment = Pick<
  LeaderboardScore,
  'leaderboard_config_id' | 'user_id' | 'score' | 'ranking' | 'position_change'
> & {
  user: PublicUserProfileFragment;
  events: Array<Maybe<Pick<LeaderboardEventScores, 'event' | 'score'>>>;
};

export type ManualNotificationsItemFragment = Pick<
  ManualNotificationsItem,
  | 'id'
  | 'notification_type'
  | 'send_at'
  | 'segment_ids'
  | 'created_at'
  | 'user_count'
  | 'email_count'
  | 'entire_company'
> & {
  segments: Array<Maybe<Pick<UserSegment, 'id' | 'title'>>>;
  message: Pick<ManualNotificationMessage, 'body' | 'url'>;
  email: Maybe<Pick<ManualNotificationEmail, 'subject' | 'body' | 'format'>>;
};

export type ProfileSearchResultsFragment = Pick<SearchResults, 'count' | 'results_from'> & {
  results: Maybe<Array<Maybe<PublicUserProfileFragment>>>;
};

export type PublicUserProfileFragment = Pick<
  PublicUserProfile,
  | 'id'
  | 'full_name'
  | 'job_title'
  | 'follower_count'
  | 'email_address'
  | 'location_title'
  | 'department_title'
  | 'user_type'
  | 'reach'
  | 'karma'
> & { image: Maybe<Pick<S3Object, 'bucket' | 'key' | 'width' | 'height'>> };

export type ReportFragment = Pick<Report, 'name' | 'description' | 'available'>;

export type ReportRequestFragment = Pick<
  ReportRequest,
  | 'id'
  | 'request_status'
  | 'start_at'
  | 'end_at'
  | 'error_details'
  | 'report_url'
  | 'report_start'
  | 'report_end'
> & { report: Pick<Report, 'name'> };

export type ScheduledShareItemFragment = Pick<
  ScheduledShareItem,
  | 'id'
  | 'network'
  | 'network_id'
  | 'user_commentary'
  | 'share_at'
  | 'shared_at'
  | 'share_session_id'
>;

export type SharesItemFragment = Pick<
  SharesItem,
  | 'id'
  | 'network'
  | 'network_id'
  | 'identifier'
  | 'user_commentary'
  | 'share_at'
  | 'shared_at'
  | 'share_session_id'
  | 'clicks'
  | 'engagements'
> & { content: Maybe<ContentFragment> };

export type TweetMetadataFragment = Pick<
  TweetMetadata,
  'id_str' | 'created_at' | 'text' | 'favorite_count' | 'retweet_count'
> & {
  user: Pick<TweetUser, 'name' | 'screen_name' | 'profile_image_url_https' | 'verified'>;
  hashtags: Maybe<Array<Maybe<Pick<TweetHashtag, 'text'>>>>;
  urls: Maybe<Array<Maybe<Pick<TweetUrl, 'display_url' | 'expanded_url'>>>>;
  user_mentions: Maybe<Array<Maybe<Pick<TweetUserMention, 'id_str' | 'name' | 'screen_name'>>>>;
  media: Maybe<Array<Maybe<Pick<TweetMedia, 'media_url_https' | 'type'>>>>;
};

export type UserFeedFollowFragment = Pick<
  UserFeedFollow,
  'feed' | 'user_id' | 'created_at' | 'postable'
> & { group: Maybe<UserFeedFollowGroupFragment>; user: Maybe<PublicUserProfileFragment> };

export type UserProfileFragment = Pick<
  UserProfile,
  | 'id'
  | 'full_name'
  | 'job_title'
  | 'follower_count'
  | 'karma'
  | 'leaderboard_enabled'
  | 'email_address'
  | 'user_type'
  | 'client_id'
  | 'location_id'
  | 'location_title'
  | 'department_id'
  | 'department_title'
  | 'last_onboarding_step'
  | 'lang'
  | 'onboarding_completed'
  | 'last_accessed_at'
  | 'user_timezone'
  | 'created_at'
  | 'german_privacy'
  | 'reach'
  | 'notification_delivery_types'
> & {
  image: Maybe<Pick<S3Object, 'bucket' | 'key' | 'width' | 'height'>>;
  group_moderator: Maybe<Array<Maybe<GroupModeratorFragment>>>;
};

export type UserSegmentFragment = Pick<
  UserSegment,
  | 'id'
  | 'title'
  | 'created_at'
  | 'segment_status'
  | 'email_addresses'
  | 'department_ids'
  | 'location_ids'
  | 'group_ids'
  | 'user_ids'
> & {
  departments: Maybe<Array<Maybe<ClientDepartmentFragment>>>;
  locations: Maybe<Array<Maybe<ClientLocationFragment>>>;
  groups: Maybe<Array<Maybe<GroupFragment>>>;
  users: Maybe<Array<Maybe<PublicUserProfileFragment>>>;
};

export type AdminUpdateClientMutationVariables = {
  data: AdminUpdateClientInput;
};

export type AdminUpdateClientMutation = {
  adminUpdateClient: Pick<Client, 'id' | 'content_domains'>;
};

export type BatchDeleteGroupsMutationVariables = {
  ids: Array<Maybe<Scalars['ID']>>;
};

export type BatchDeleteGroupsMutation = { batchDeleteGroups: Array<Maybe<Pick<Group, 'id'>>> };

export type BatchUpdateUserProfileStatusMutationVariables = {
  ids: Array<Maybe<Scalars['ID']>>;
  user_status: UserStatus;
};

export type BatchUpdateUserProfileStatusMutation = {
  batchUpdateUserProfileStatus: Array<Maybe<Pick<UserProfile, 'id' | 'user_status'>>>;
};

export type BatchUpdateUserProfileTypeMutationVariables = {
  ids: Array<Maybe<Scalars['ID']>>;
  user_type: UserType;
};

export type BatchUpdateUserProfileTypeMutation = {
  batchUpdateUserProfileUserType: Array<Maybe<Pick<UserProfile, 'id' | 'user_type'>>>;
};

export type CreateClientDepartmentMutationVariables = {
  data: CreateClientDepartmentInput;
};

export type CreateClientDepartmentMutation = { createClientDepartment: ClientDepartmentFragment };

export type CreateClientFollowMappingMutationVariables = {
  data: CreateClientFollowMappingInput;
};

export type CreateClientFollowMappingMutation = {
  createClientFollowMapping: ClientFollowMappingFragment;
};

export type CreateClientInvitationMutationVariables = {
  data: CreateClientInvitationInput;
};

export type CreateClientInvitationMutation = {
  createClientInvitation: Array<Maybe<ClientInvitationFragment>>;
};

export type CreateClientLocationMutationVariables = {
  data: CreateClientLocationInput;
};

export type CreateClientLocationMutation = { createClientLocation: ClientLocationFragment };

export type CreateCommentMutationVariables = {
  comment_text: Scalars['String'];
  object_id: Scalars['ID'];
};

export type CreateCommentMutation = { createComment: CommentFragment };

export type CreateCommentReplyMutationVariables = {
  comment_text: Scalars['String'];
  object_id: Scalars['ID'];
  parent_id: Scalars['ID'];
};

export type CreateCommentReplyMutation = { createComment: CommentFragment };

export type CreateGroupMutationVariables = {
  data: CreateGroupInput;
};

export type CreateGroupMutation = { createGroup: GroupFragment };

export type CreateGroupModeratorMutationVariables = {
  group_id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type CreateGroupModeratorMutation = { createGroupModerator: GroupModeratorFragment };

export type CreateGroupSourceMutationVariables = {
  group_id: Scalars['ID'];
  source_status: SourceStatus;
  source_type: GroupSourceType;
  source_value: Scalars['String'];
  approval?: Maybe<ContentApproval>;
};

export type CreateGroupSourceMutation = { clientGroupSourceCreate: ClientGroupSourceFragment };

export type CreateManualNotificationMutationVariables = {
  data: ManualNotificationsItemInput;
};

export type CreateManualNotificationMutation = {
  createManualNotification: Maybe<ManualNotificationsItemFragment>;
};

export type CreateReactionMutationVariables = {
  content_id: Scalars['String'];
};

export type CreateReactionMutation = {
  createReaction: Pick<
    Reaction,
    'object_type' | 'object_id' | 'reaction_type' | 'user_id' | 'created_at'
  >;
};

export type CreateReportRequestMutationVariables = {
  data: RunReportInput;
};

export type CreateReportRequestMutation = { createReportRequest: ReportRequestFragment };

export type CreateUpdateLeaderboardConfigMutationVariables = {
  data: LeaderboardConfigInput;
};

export type CreateUpdateLeaderboardConfigMutation = {
  createUpdateLeaderboardConfig: LeaderboardConfigFragment;
};

export type CreateUserSegmentMutationVariables = {
  data: CreateUserSegmentInput;
};

export type CreateUserSegmentMutation = { createUserSegment: UserSegmentFragment };

export type DeleteCommentMutationVariables = {
  id: Scalars['ID'];
};

export type DeleteCommentMutation = { deleteComment: Pick<Comment, 'id'> };

export type DeleteGroupModeratorMutationVariables = {
  group_id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type DeleteGroupModeratorMutation = Pick<Mutation, 'deleteGroupModerator'>;

export type DeleteGroupSourceMutationVariables = {
  id: Scalars['ID'];
};

export type DeleteGroupSourceMutation = { clientGroupSourceDelete: Pick<Status, 'status'> };

export type DeleteManualNotificationMutationVariables = {
  id: Scalars['ID'];
};

export type DeleteManualNotificationMutation = {
  deleteManualNotification: Maybe<ManualNotificationsItemFragment>;
};

export type DeleteReactionMutationVariables = {
  content_id: Scalars['String'];
};

export type DeleteReactionMutation = { deleteReaction: Pick<Status, 'status'> };

export type DeleteScheduledSharesMutationVariables = {
  ids: Array<Scalars['ID']>;
};

export type DeleteScheduledSharesMutation = {
  deleteScheduledShares: Array<Maybe<Pick<SharesItem, 'id'>>>;
};

export type DeleteSocialConnectionMutationVariables = {
  id: Scalars['ID'];
};

export type DeleteSocialConnectionMutation = { deleteSocialConnection: Pick<Status, 'status'> };

export type FollowMutationVariables = {
  id: Scalars['ID'];
  key: FeedKey;
};

export type FollowMutation = { follow: Maybe<UserFeedFollowFragment> };

export type MarkInboxAsReadMutationVariables = {};

export type MarkInboxAsReadMutation = { markInboxAsRead: Pick<Status, 'status'> };

export type MarkInboxItemAsReadMutationVariables = {
  id: Scalars['ID'];
};

export type MarkInboxItemAsReadMutation = { markInboxItemAsRead: Maybe<InboxFragment> };

export type ManualPostMutationVariables = {
  content: ContentInput;
};

export type ManualPostMutation = { processContent: ContentFragment };

export type PreviewUrlMutationVariables = {
  url: Scalars['String'];
};

export type PreviewUrlMutation = { processContent: { content_object: ContentObjectFragment } };

export type ShareContentMutationVariables = {
  share_session_id?: Maybe<Scalars['ID']>;
  content_id: Scalars['ID'];
  items: Array<Maybe<ShareContentInput>>;
};

export type ShareContentMutation = {
  shareContent: Maybe<{
    results: Array<
      Pick<SharedContentItem, 'url' | 'status'> & {
        shortened_url: Maybe<Pick<ShortenedUrlItem, 'short_link' | 'id'>>;
      }
    >;
  }>;
};

export type UnfollowMutationVariables = {
  id: Scalars['ID'];
  key: FeedKey;
};

export type UnfollowMutation = { unfollow: Maybe<UserFeedFollowFragment> };

export type UpdateClientDepartmentMutationVariables = {
  data: UpdateClientDepartmentInput;
};

export type UpdateClientDepartmentMutation = { updateClientDepartment: ClientDepartmentFragment };

export type UpdateClientFollowMappingMutationVariables = {
  data: UpdateClientFollowMappingInput;
};

export type UpdateClientFollowMappingMutation = {
  updateClientFollowMapping: ClientFollowMappingFragment;
};

export type UpdateClientLocationMutationVariables = {
  data: UpdateClientLocationInput;
};

export type UpdateClientLocationMutation = { updateClientLocation: ClientLocationFragment };

export type UpdateClientUrlParamsMutationVariables = {
  data: ClientUrlParamsUpdateInput;
};

export type UpdateClientUrlParamsMutation = { updateClientUrlParams: ClientUrlParamsFragment };

export type UpdateCommentMutationVariables = {
  id: Scalars['ID'];
  comment_text: Scalars['String'];
};

export type UpdateCommentMutation = { updateComment: CommentFragment };

export type UpdateContentApprovalsMutationVariables = {
  content_id: Scalars['String'];
  group_id_approvals: Array<Maybe<GroupIdApprovalInput>>;
};

export type UpdateContentApprovalsMutation = {
  updateContentApprovals: Maybe<Pick<Content, 'content_id'>>;
};

export type UpdateGroupMutationVariables = {
  data: UpdateGroupInput;
};

export type UpdateGroupMutation = { updateGroup: GroupFragment };

export type UpdateGroupSourceMutationVariables = {
  data: ClientGroupSourceUpdate;
};

export type UpdateGroupSourceMutation = { clientGroupSourceUpdate: ClientGroupSourceFragment };

export type UpdateManualNotificationMutationVariables = {
  data: ManualNotificationsItemUpdateInput;
};

export type UpdateManualNotificationMutation = {
  updateManualNotification: Maybe<ManualNotificationsItemFragment>;
};

export type UpdateScheduledSharesMutationVariables = {
  data: ScheduledShareContentInput;
};

export type UpdateScheduledSharesMutation = {
  updateScheduledShares: Array<ScheduledShareItemFragment>;
};

export type UpdateUserProfileMutationVariables = {
  data: UserProfileInput;
};

export type UpdateUserProfileMutation = { updateUserProfile: UserProfileFragment };

export type UpdateUserSegmentMutationVariables = {
  data: UpdateUserSegmentInput;
};

export type UpdateUserSegmentMutation = { updateUserSegment: UserSegmentFragment };

export type ClientDailyStatsQueryVariables = {
  client_id: Scalars['ID'];
  grouping: StatsGrouping;
};

export type ClientDailyStatsQuery = {
  clientDailyStats: Maybe<
    Pick<
      ClientTrendingEngagementStat,
      'total_posts' | 'total_shares' | 'total_clicks' | 'total_users'
    > & {
      data: Array<
        Maybe<Pick<ClientTrendingData, 'posts' | 'clicks' | 'shares' | 'users' | 'calendar_day'>>
      >;
    }
  >;
};

export type ClientEngagementStatsQueryVariables = {
  client_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
};

export type ClientEngagementStatsQuery = {
  clientEngagementStats: Maybe<
    Pick<ClientEngagementStat, 'comments' | 'reactions' | 'posts' | 'groups' | 'users'>
  >;
};

export type ClientReachStatsQueryVariables = {
  client_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
};

export type ClientReachStatsQuery = {
  clientReachStats: Maybe<
    Array<Maybe<Pick<ReachStat, 'reach' | 'previous_reach' | 'provider' | 'profile_identifier'>>>
  >;
};

export type GetGroupFollowersQueryVariables = {
  id: Scalars['ID'];
  limit: Scalars['Int'];
};

export type GetGroupFollowersQuery = {
  feedFollowing: Maybe<
    Pick<FeedFollowing, 'id' | 'paginate' | 'count'> & {
      feed_follows: Maybe<Array<Maybe<{ followed_by_user: PublicUserProfileFragment }>>>;
    }
  >;
};

export type GetUserFollowersQueryVariables = {
  id: Scalars['ID'];
  limit: Scalars['Int'];
};

export type GetUserFollowersQuery = {
  feedFollowing: Maybe<
    Pick<FeedFollowing, 'id' | 'paginate' | 'count'> & {
      feed_follows: Maybe<Array<Maybe<{ followed_by_user: PublicUserProfileFragment }>>>;
    }
  >;
};

export type GetActionsQueryVariables = {
  limit: Scalars['Int'];
};

export type GetActionsQuery = {
  getActions: Pick<Actions, 'id_lt'> & {
    results: Maybe<
      Array<
        Maybe<
          Pick<Action, 'created_at' | 'id' | 'user_id' | 'group_id'> & {
            display: Pick<ActionDisplay, 'message'> & {
              substitutions: Pick<ActionDisplayParams, 'actor' | 'adjective'>;
              urls: Pick<ActionDisplayParams, 'actor' | 'adjective'>;
            };
          }
        >
      >
    >;
  };
};

export type GetActiveCommentsQueryVariables = {
  object_id: Scalars['ID'];
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
};

export type GetActiveCommentsQuery = {
  getActiveComments: Pick<CommentsList, 'id' | 'created_at' | 'paginate' | 'count'> & {
    comments: Maybe<Array<Maybe<CommentFragment>>>;
  };
};

export type GetAllClientFollowMappingsQueryVariables = {};

export type GetAllClientFollowMappingsQuery = {
  getAllClientFollowMappings: {
    client_follow_mappings: Maybe<Array<Maybe<ClientFollowMappingFragment>>>;
  };
};

export type GetAllClientUrlParamsQueryVariables = {};

export type GetAllClientUrlParamsQuery = {
  getAllClientUrlParams: Maybe<Array<Maybe<ClientUrlParamsFragment>>>;
};

export type GetAllUserSegmentsQueryVariables = {};

export type GetAllUserSegmentsQuery = { getUserSegments: Maybe<Array<Maybe<UserSegmentFragment>>> };

export type GetUserSegmentsByStatusQueryVariables = {
  segment_status: SegmentStatus;
};

export type GetUserSegmentsByStatusQuery = {
  getUserSegments: Maybe<Array<Maybe<UserSegmentFragment>>>;
};

export type GetCurrentUserFeedQueryVariables = {
  user_id: Scalars['ID'];
  feed?: Maybe<FeedKey>;
};

export type GetCurrentUserFeedQuery = {
  getByUserFeed: {
    client: ClientProtectedFragment;
    user: UserProfileFragment | PublicUserProfileFragment;
  };
};

export type GetProfileUserFeedQueryVariables = {
  user_id: Scalars['ID'];
  feed?: Maybe<FeedKey>;
};

export type GetProfileUserFeedQuery = {
  getByUserFeed: { user: UserProfileFragment | PublicUserProfileFragment };
};

export type GetClientDepartmentsByStatusQueryVariables = {};

export type GetClientDepartmentsByStatusQuery = {
  getClientDepartmentsByStatus: Pick<
    ClientDepartmentStatusList,
    'count' | 'paginate' | 'department_status' | 'title' | 'id'
  > & { client_departments: Maybe<Array<Maybe<ClientDepartmentFragment>>> };
};

export type GetClientInvitationsByClientQueryVariables = {
  count?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['Int']>;
  invitation_status: ClientInvitationStatus;
};

export type GetClientInvitationsByClientQuery = {
  getClientInvitationsByClient: Pick<
    ClientInvitationsClientList,
    'count' | 'paginate' | 'invitation_status' | 'created_at' | 'id' | 'client_id'
  > & {
    client_invitations: Maybe<
      Array<
        Maybe<
          Pick<
            ClientInvitation,
            | 'id'
            | 'client_id'
            | 'email_address'
            | 'invitation_status'
            | 'created_at'
            | 'updated_at'
            | 'accepted_at'
          > & {
            accepted_by_user: Maybe<Pick<PublicUserProfile, 'id' | 'full_name' | 'email_address'>>;
            added_by_user: Maybe<Pick<PublicUserProfile, 'id' | 'full_name' | 'email_address'>>;
          }
        >
      >
    >;
  };
};

export type GetClientLocationsByStatusQueryVariables = {};

export type GetClientLocationsByStatusQuery = {
  getClientLocationsByStatus: Pick<
    ClientLocationStatusList,
    'count' | 'paginate' | 'location_status' | 'title' | 'id'
  > & { client_locations: Maybe<Array<Maybe<ClientLocationFragment>>> };
};

export type GetContentQueryVariables = {
  content_id: Scalars['String'];
};

export type GetContentQuery = { getContent: Maybe<ContentFragment> };

export type GetContentUrlParamOptionsQueryVariables = {
  url: Scalars['String'];
};

export type GetContentUrlParamOptionsQuery = {
  getContentUrlParamOptions: Maybe<
    Array<Maybe<Pick<ContentUrlParamOptions, 'key' | 'options' | 'default_option_value'>>>
  >;
};

export type GetFeedQueryVariables = {
  key: Scalars['String'];
  id: Scalars['String'];
  limit: Scalars['Int'];
  id_lt?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  sort: Scalars['Boolean'];
};

export type GetFeedQuery = {
  getFeed: Pick<Feed, 'id_lt' | 'offset'> & { results: Maybe<Array<Maybe<ContentFragment>>> };
};

export type GetFollowedQueryVariables = {
  data?: Maybe<PaginatedUserFeedFollowsInput>;
};

export type GetFollowedQuery = {
  getPaginatedUserFeedFollows: Pick<
    PaginatedUserFeedFollows,
    'count' | 'title_lower' | 'client_id__feed__id'
  > & { feed_follows: Maybe<Array<UserFeedFollowFragment>> };
};

export type GetFollowersQueryVariables = {
  data?: Maybe<PaginatedFollowedByUsersInput>;
};

export type GetFollowersQuery = {
  getPaginatedFollowedByUsers: Pick<
    PaginatedFollowedByUsers,
    'count' | 'username' | 'followed_by_user_id'
  > & { followed_by_users: Maybe<Array<PublicUserProfileFragment>> };
};

export type GetGroupQueryVariables = {
  id: Scalars['ID'];
};

export type GetGroupQuery = { getGroup: Maybe<GroupFragment> };

export type GetGroupColorsQueryVariables = {};

export type GetGroupColorsQuery = {
  getGroupColors: Array<Maybe<Pick<GroupColorMap, 'label' | 'hex' | 'group_color'>>>;
};

export type GetGroupIconsQueryVariables = {};

export type GetGroupIconsQuery = {
  getGroupIcons: Array<
    Maybe<Pick<GroupIconMap, 'bucket' | 'file_key' | 'width' | 'height' | 'group_icon'>>
  >;
};

export type GetGroupModeratorsQueryVariables = {
  group_id: Scalars['ID'];
};

export type GetGroupModeratorsQuery = {
  getModeratorsByGroup: Maybe<Array<Maybe<GroupModeratorFragment>>>;
};

export type GetGroupSourcesQueryVariables = {
  group_id: Scalars['ID'];
};

export type GetGroupSourcesQuery = {
  getClientGroupSourcesByGroup: Maybe<Array<Maybe<ClientGroupSourceFragment>>>;
};

export type GetInboxItemsQueryVariables = {
  limit?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
};

export type GetInboxItemsQuery = {
  getInboxItems: Pick<InboxList, 'count' | 'limit' | 'paginate' | 'created_at' | 'id'> & {
    inbox: Maybe<Array<Maybe<InboxFragment>>>;
  };
};

export type GetLeaderboardConfigsQueryVariables = {};

export type GetLeaderboardConfigsQuery = {
  getLeaderboardConfigs: Array<Maybe<LeaderboardConfigFragment>>;
};

export type GetLeaderboardConfigScoresQueryVariables = {
  id: Scalars['ID'];
};

export type GetLeaderboardConfigScoresQuery = {
  getLeaderboardConfigScores: Array<Maybe<Pick<LeaderboardEventScores, 'event' | 'score'>>>;
};

export type GetUserLeaderboardsQueryVariables = {
  user_id?: Maybe<Scalars['ID']>;
};

export type GetUserLeaderboardsQuery = {
  getLeaderboardForUser: Maybe<{
    leaderboard_configs: Maybe<Array<Maybe<LeaderboardConfigFragment>>>;
  }>;
};

export type GetUserLeaderboardQueryVariables = {
  user_id?: Maybe<Scalars['ID']>;
  leaderboard_config_id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
};

export type GetUserLeaderboardQuery = {
  getLeaderboardForUser: Maybe<{
    leaderboard_scores: Maybe<
      Pick<LeaderboardScores, 'paginate' | 'leaderboard_config_id' | 'ranking' | 'user_id'> & {
        items: Maybe<Array<Maybe<LeaderboardScoreFragment>>>;
      }
    >;
    user_score: Maybe<LeaderboardScoreFragment>;
  }>;
};

export type GetLeaderboardScoresQueryVariables = {
  leaderboard_config_id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  ranking?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type GetLeaderboardScoresQuery = {
  getLeaderboardScores: Pick<
    LeaderboardScores,
    'paginate' | 'leaderboard_config_id' | 'ranking' | 'user_id'
  > & { items: Maybe<Array<Maybe<LeaderboardScoreFragment>>> };
};

export type GetLeaderboardScoreForUserQueryVariables = {
  leaderboard_config_id: Scalars['ID'];
  user_id?: Maybe<Scalars['ID']>;
};

export type GetLeaderboardScoreForUserQuery = {
  getLeaderboardScoreForUser: LeaderboardScoreFragment;
};

export type GetManualNotificationsQueryVariables = {
  data: ItemsListInput;
  scheduled?: Maybe<Scalars['Boolean']>;
};

export type GetManualNotificationsQuery = {
  getManualNotificationItems: Maybe<
    Pick<ManualNotificationsItemsList, 'count' | 'paginate' | 'created_at' | 'id'> & {
      items: Maybe<Array<Maybe<ManualNotificationsItemFragment>>>;
    }
  >;
};

export type GetPostedToGroupsQueryVariables = {};

export type GetPostedToGroupsQuery = {
  contextGetPostedToGroups: Maybe<Array<Maybe<Pick<PostedToGroup, 'group_id' | 'score'>>>>;
};

export type GetProfilesByClientIdFullNameQueryVariables = {
  full_name: Scalars['String'];
};

export type GetProfilesByClientIdFullNameQuery = {
  getProfilesByClientIdFullName: Maybe<
    Array<
      Maybe<
        Pick<
          PublicUserProfile,
          | 'id'
          | 'full_name'
          | 'job_title'
          | 'follower_count'
          | 'department_title'
          | 'location_title'
          | 'email_address'
          | 'user_type'
        > & { image: Maybe<Pick<S3Object, 'bucket' | 'key' | 'width' | 'height'>> }
      >
    >
  >;
};

export type GetProfilesByUserStatusQueryVariables = {
  user_status: UserStatus;
  id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
  full_name_lower?: Maybe<Scalars['String']>;
};

export type GetProfilesByUserStatusQuery = {
  getProfilesByUserStatus: Pick<
    UserProfilesByStatusList,
    'id' | 'count' | 'paginate' | 'full_name_lower'
  > & { profiles: Maybe<Array<Maybe<UserProfileFragment>>> };
};

export type GetReportsQueryVariables = {};

export type GetReportsQuery = { getReports: Maybe<Array<Maybe<ReportFragment>>> };

export type GetReportRequestsQueryVariables = {
  data: ReportRequestListInput;
};

export type GetReportRequestsQuery = {
  getReportRequests: Pick<ReportRequestList, 'count' | 'paginate'> & {
    report_requests: Maybe<Array<Maybe<ReportRequestFragment>>>;
  };
};

export type GetSharesItemsQueryVariables = {
  data: ItemsListInput;
  group_by_session?: Maybe<Scalars['Boolean']>;
  scheduled?: Maybe<Scalars['Boolean']>;
};

export type GetSharesItemsQuery = {
  getSharesItems: Pick<SharesList, 'count' | 'paginate' | 'created_at' | 'id'> & {
    items_by_session: Maybe<Array<Array<SharesItemFragment>>>;
    items: Array<SharesItemFragment>;
  };
};

export type GetSharePreviewInfoQueryVariables = {
  content_id: Scalars['String'];
};

export type GetSharePreviewInfoQuery = {
  getSharePreviewInfo: Pick<ContentSharePreview, 'suggested_share_time'> & {
    allowed_counts: Maybe<Pick<AllowedCounts, 'twitter' | 'linkedin' | 'facebook'>>;
    suggested_commentary: Array<Pick<ContentCommentary, 'network' | 'commentary'>>;
    shortened_urls: Maybe<{
      email: Maybe<Pick<ShortenedUrlItem, 'short_link'>>;
      direct: Maybe<Pick<ShortenedUrlItem, 'short_link'>>;
    }>;
  };
};

export type GetUserClientFollowMappingsQueryVariables = {};

export type GetUserClientFollowMappingsQuery = {
  getUserClientFollowMappings: {
    suggested_groups: Maybe<Array<Maybe<GroupFragment>>>;
    suggested_users: Maybe<Array<Maybe<PublicUserProfileFragment>>>;
  };
};

export type GetUserSearchesQueryVariables = {
  limit: Scalars['Int'];
};

export type GetUserSearchesQuery = Pick<Query, 'getUserSearches'>;

export type GetUserSocialConnectionsQueryVariables = {
  user_id: Scalars['String'];
};

export type GetUserSocialConnectionsQuery = {
  getUserSocialConnections: Pick<SocialAccountConnectionsList, 'count'> & {
    items: Array<
      Pick<
        SocialAccount,
        'id' | 'provider' | 'identifier' | 'profile_name' | 'reach' | 'expires_soon' | 'profile_url'
      >
    >;
  };
};

export type RecommendContentQueryVariables = {
  size: Scalars['Int'];
  results_from: Scalars['Int'];
};

export type RecommendContentQuery = {
  recommendContent: Pick<RecommendedContentResults, 'count' | 'results_from'> & {
    results: Maybe<Array<Maybe<ContentShareFragment>>>;
  };
};

export type SearchQueryVariables = {
  size: Scalars['Int'];
  results_from: Scalars['Int'];
  q?: Maybe<Scalars['String']>;
};

export type SearchQuery = {
  search: Pick<SearchResults, 'count'> & {
    results: Maybe<
      Array<
        Maybe<
          | Pick<Group, 'id' | 'title' | 'follower_count' | 'department_title' | 'location_title'>
          | Pick<
              PublicUserProfile,
              'id' | 'full_name' | 'follower_count' | 'department_title' | 'location_title'
            >
          | (Pick<Content, 'content_id' | 'publish_at'> & {
              groups: Maybe<Array<Maybe<GetFeedGroupFragment>>>;
              user: Maybe<Pick<PublicUserProfile, 'full_name'>>;
              content_object: Pick<ContentObject, 'body' | 'url'> & {
                url_metadata: Maybe<Pick<UrlMetadata, 'provider_name' | 'title' | 'description'>>;
                photos: Maybe<Array<Maybe<Pick<S3Object, 'bucket'>>>>;
              };
            })
        >
      >
    >;
  };
};

export type SearchGroupsQueryVariables = {
  size: Scalars['Int'];
  results_from: Scalars['Int'];
  q?: Maybe<Scalars['String']>;
  auto_exclude?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<SearchSortFields>;
  sort_direction?: Maybe<SearchSortDirections>;
  required_location_id?: Maybe<Scalars['ID']>;
  required_department_id?: Maybe<Scalars['ID']>;
};

export type SearchGroupsQuery = { search: GroupSearchResultsFragment };

export type SearchPeopleQueryVariables = {
  size: Scalars['Int'];
  results_from: Scalars['Int'];
  q?: Maybe<Scalars['String']>;
  auto_exclude?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<SearchSortFields>;
  sort_direction?: Maybe<SearchSortDirections>;
  required_location_id?: Maybe<Scalars['ID']>;
  required_department_id?: Maybe<Scalars['ID']>;
};

export type SearchPeopleQuery = { search: ProfileSearchResultsFragment };

export type SearchAggregatesQueryVariables = {};

export type SearchAggregatesQuery = {
  searchAggregates: {
    departments: Maybe<Array<Maybe<Pick<ClientDepartment, 'id' | 'title'>>>>;
    locations: Maybe<Array<Maybe<Pick<ClientLocation, 'id' | 'title'>>>>;
  };
};

export type SearchSuggestQueryVariables = {
  prefix: Scalars['String'];
};

export type SearchSuggestQuery = {
  suggest: {
    results: Maybe<
      Array<Maybe<Pick<GroupSuggestion, 'id' | 'title'> | Pick<ProfileSuggestion, 'id' | 'title'>>>
    >;
  };
};

export type GroupSuggestQueryVariables = {
  prefix: Scalars['String'];
  index: SuggestIndex;
};

export type GroupSuggestQuery = {
  suggest: {
    results: Maybe<
      Array<
        Maybe<
          Pick<GroupSuggestion, 'id' | 'title' | 'color' | 'icon_color' | 'icon'> & {
            color_map: Pick<GroupColorMap, 'hex'>;
            icon_color_map: Pick<GroupIconColorMap, 'hex'>;
            icon_map: Pick<GroupIconMap, 'bucket' | 'file_key' | 'width' | 'height'>;
            image: Maybe<Pick<S3Object, 'bucket' | 'key' | 'width' | 'height'>>;
          }
        >
      >
    >;
  };
};

export type UserSuggestQueryVariables = {
  prefix: Scalars['String'];
  index: SuggestIndex;
};

export type UserSuggestQuery = {
  suggest: {
    results: Maybe<
      Array<
        Maybe<
          Pick<ProfileSuggestion, 'id' | 'title'> & {
            image: Maybe<Pick<S3Object, 'bucket' | 'key' | 'width' | 'height'>>;
          }
        >
      >
    >;
  };
};

export type UserDailyStatsQueryVariables = {
  user_id: Scalars['ID'];
  grouping: StatsGrouping;
};

export type UserDailyStatsQuery = {
  userDailyStats: Maybe<
    Pick<TrendingEngagementStat, 'total_posts' | 'total_shares' | 'total_clicks'> & {
      data: Array<Maybe<Pick<TrendingData, 'clicks' | 'posts' | 'shares' | 'calendar_day'>>>;
    }
  >;
};

export type UserEngagementStatsQueryVariables = {
  user_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
};

export type UserEngagementStatsQuery = {
  userEngagementStats: Maybe<
    Pick<
      InternalEngagementStat,
      'clicks' | 'comments' | 'reactions' | 'posts' | 'shares' | 'engagements' | 'groups'
    >
  >;
};

export type UserReachStatsQueryVariables = {
  user_id: Scalars['ID'];
  grouping: StatsGrouping;
  value: Scalars['Int'];
};

export type UserReachStatsQuery = {
  userReachStats: Maybe<
    Array<Maybe<Pick<ReachStat, 'reach' | 'previous_reach' | 'provider' | 'profile_identifier'>>>
  >;
};

export type FollowedSubscriptionVariables = {
  user_id: Scalars['ID'];
};

export type FollowedSubscription = { followed: Maybe<UserFeedFollowFragment> };

export type InboxItemCreatedSubscriptionVariables = {
  user_id: Scalars['ID'];
};

export type InboxItemCreatedSubscription = { inboxItemCreated: Maybe<InboxFragment> };

export type UnfollowedSubscriptionVariables = {
  user_id: Scalars['ID'];
};

export type UnfollowedSubscription = { unfollowed: Maybe<UserFeedFollowFragment> };

export type CsUpdateClientMutationVariables = {
  data: CsUpdateClientInput;
};

export type CsUpdateClientMutation = { csUpdateClient: ClientProtectedFragment };

export type CreateClientMutationVariables = {
  data: CreateClientInput;
};

export type CreateClientMutation = { createClient: ClientProtectedFragment };

export type GetClientQueryVariables = {
  id: Scalars['ID'];
};

export type GetClientQuery = { getClient: Maybe<ClientProtectedFragment> };

export type GetClientsQueryVariables = {
  client_status: ClientStatus;
};

export type GetClientsQuery = { getClients: Array<Maybe<ClientProtectedFragment>> };

export const GroupFragmentDoc = gql`
  fragment Group on Group {
    id
    created_at
    title
    follower_count
    color
    color_map {
      hex
    }
    allow_user_posts
    content_approval_type
    group_status
    icon
    icon_color
    icon_color_map {
      hex
    }
    icon_map {
      bucket
      file_key
      width
      height
    }
    image {
      bucket
      key
      width
      height
      region
    }
    location_id
    location_title
    department_id
    department_title
  }
`;
export const PublicUserProfileFragmentDoc = gql`
  fragment PublicUserProfile on PublicUserProfile {
    id
    full_name
    job_title
    follower_count
    email_address
    location_title
    department_title
    user_type
    reach
    karma
    image {
      bucket
      key
      width
      height
    }
  }
`;
export const ClientDepartmentFragmentDoc = gql`
  fragment ClientDepartment on ClientDepartment {
    id
    title
    department_status
    groups_total
    profiles_total
  }
`;
export const ClientLocationFragmentDoc = gql`
  fragment ClientLocation on ClientLocation {
    id
    title
    location_status
    groups_total
    profiles_total
  }
`;
export const ClientFollowMappingFragmentDoc = gql`
  fragment ClientFollowMapping on ClientFollowMapping {
    id
    title
    mapping_status
    all_users
    required_groups {
      ...Group
    }
    suggested_groups {
      ...Group
    }
    required_users {
      ...PublicUserProfile
    }
    suggested_users {
      ...PublicUserProfile
    }
    follow_conditions {
      department_id
      departments {
        ...ClientDepartment
      }
      location_id
      locations {
        ...ClientLocation
      }
      language
      email_domain
    }
  }
  ${GroupFragmentDoc}
  ${PublicUserProfileFragmentDoc}
  ${ClientDepartmentFragmentDoc}
  ${ClientLocationFragmentDoc}
`;
export const ClientGroupSourceFragmentDoc = gql`
  fragment ClientGroupSource on ClientGroupSource {
    id
    group_id
    source_status
    source_type
    source_value
    approval
  }
`;
export const ClientInvitationFragmentDoc = gql`
  fragment ClientInvitation on ClientInvitation {
    id
    client_id
    email_address
    invitation_status
    subject
    message
    email_from_address
    created_at
    updated_at
    last_sent_at
    retries
    accepted_at
    accepted_by_user_id
  }
`;
export const ClientCommonFragmentDoc = gql`
  fragment ClientCommon on Client {
    id
    title
    subdomain
    email_domains
    content_domains
    client_status
    authentication_type
    allow_user_signup
    departments_in_signup
    departments_in_signup_required
    locations_in_signup
    locations_in_signup_required
    default_timezone
    default_language
    support_multiple_languages
    sso_configuration {
      provider
    }
    image {
      bucket
      key
      width
      height
      region
    }
  }
`;
export const ClientProtectedFragmentDoc = gql`
  fragment ClientProtected on Client {
    created_at
    email_from_address
    allow_user_invites
    content_domains
    allow_group_creation
    disable_comments
    disable_timeline
    email_address
    sso_provider
    ...ClientCommon
  }
  ${ClientCommonFragmentDoc}
`;
export const ClientPublicFragmentDoc = gql`
  fragment ClientPublic on Client {
    ...ClientCommon
  }
  ${ClientCommonFragmentDoc}
`;
export const ClientUrlParamsFragmentDoc = gql`
  fragment ClientUrlParams on ClientUrlParams {
    id
    params_status
    content_domain
    configuration {
      key
      value
      dynamic_value
      value_options
      default_option_value
    }
  }
`;
export const GetFeedGroupFragmentDoc = gql`
  fragment GetFeedGroup on Group {
    id
    title
    color_map {
      hex
    }
  }
`;
export const TweetMetadataFragmentDoc = gql`
  fragment TweetMetadata on TweetMetadata {
    id_str
    created_at
    text
    favorite_count
    retweet_count
    user {
      name
      screen_name
      profile_image_url_https
      verified
    }
    hashtags {
      text
    }
    urls {
      display_url
      expanded_url
    }
    user_mentions {
      id_str
      name
      screen_name
    }
    media {
      media_url_https
      type
    }
  }
`;
export const ContentObjectFragmentDoc = gql`
  fragment ContentObject on ContentObject {
    post_type
    metadata_keys
    body
    url
    photos {
      bucket
      key
      width
      height
      region
    }
    url_metadata {
      original_url
      provider_display
      provider_name
      title
      url
      description
      images {
        bucket
        file_key
        height
        width
        url_original
      }
    }
    tweet_metadata {
      ...TweetMetadata
    }
    youtube_metadata {
      video_id
    }
    instagram_metadata {
      id
      shortcode
    }
    reddit_metadata {
      url
    }
  }
  ${TweetMetadataFragmentDoc}
`;
export const ContentShareFragmentDoc = gql`
  fragment ContentShare on Content {
    content_id
    share_count
    engagement_count
    click_count
    publish_at
    has_requesting_user_shared
    commentary {
      network
      commentary
    }
    groups {
      ...GetFeedGroup
    }
    content_object {
      ...ContentObject
    }
  }
  ${GetFeedGroupFragmentDoc}
  ${ContentObjectFragmentDoc}
`;
export const UserFeedFollowGroupFragmentDoc = gql`
  fragment UserFeedFollowGroup on Group {
    id
    title
    follower_count
    location_title
    department_title
    color_map {
      hex
    }
    icon_map {
      bucket
      file_key
      width
      height
    }
    image {
      bucket
      key
      width
      height
    }
  }
`;
export const GroupSearchResultsFragmentDoc = gql`
  fragment GroupSearchResults on SearchResults {
    count
    results_from
    results {
      ... on Group {
        ...UserFeedFollowGroup
      }
    }
  }
  ${UserFeedFollowGroupFragmentDoc}
`;
export const InboxFragmentDoc = gql`
  fragment Inbox on Inbox {
    id
    created_at
    updated_at
    item_read
    message
    to_user_id
    url
  }
`;
export const UserSegmentFragmentDoc = gql`
  fragment UserSegment on UserSegment {
    id
    title
    created_at
    segment_status
    email_addresses
    department_ids
    departments {
      ...ClientDepartment
    }
    location_ids
    locations {
      ...ClientLocation
    }
    group_ids
    groups {
      ...Group
    }
    user_ids
    users {
      ...PublicUserProfile
    }
  }
  ${ClientDepartmentFragmentDoc}
  ${ClientLocationFragmentDoc}
  ${GroupFragmentDoc}
  ${PublicUserProfileFragmentDoc}
`;
export const LeaderboardConfigFragmentDoc = gql`
  fragment LeaderboardConfig on LeaderboardConfig {
    id
    title
    description
    leaderboard_status
    created_at
    start_at
    end_at
    all_users
    segment_ids
    segments {
      ...UserSegment
    }
  }
  ${UserSegmentFragmentDoc}
`;
export const LeaderboardScoreFragmentDoc = gql`
  fragment LeaderboardScore on LeaderboardScore {
    leaderboard_config_id
    user_id
    user {
      ...PublicUserProfile
    }
    score
    ranking
    position_change
    events {
      event
      score
    }
  }
  ${PublicUserProfileFragmentDoc}
`;
export const ManualNotificationsItemFragmentDoc = gql`
  fragment ManualNotificationsItem on ManualNotificationsItem {
    id
    notification_type
    send_at
    segment_ids
    segments {
      id
      title
    }
    created_at
    user_count
    email_count
    entire_company
    message {
      body
      url
    }
    email {
      subject
      body
      format
    }
  }
`;
export const ProfileSearchResultsFragmentDoc = gql`
  fragment ProfileSearchResults on SearchResults {
    count
    results_from
    results {
      ... on PublicUserProfile {
        ...PublicUserProfile
      }
    }
  }
  ${PublicUserProfileFragmentDoc}
`;
export const ReportFragmentDoc = gql`
  fragment Report on Report {
    name
    description
    available
  }
`;
export const ReportRequestFragmentDoc = gql`
  fragment ReportRequest on ReportRequest {
    id
    report {
      name
    }
    request_status
    start_at
    end_at
    error_details
    report_url
    report_start
    report_end
  }
`;
export const ScheduledShareItemFragmentDoc = gql`
  fragment ScheduledShareItem on ScheduledShareItem {
    id
    network
    network_id
    user_commentary
    share_at
    shared_at
    share_session_id
  }
`;
export const ContentReactionsFragmentDoc = gql`
  fragment ContentReactions on ContentReactions {
    reaction_count {
      total
    }
    user_reactions
    reaction_user_details {
      ...PublicUserProfile
    }
  }
  ${PublicUserProfileFragmentDoc}
`;
export const CommentFragmentDoc = gql`
  fragment Comment on Comment {
    id
    comment_text
    object_id
    has_substitutions
    user {
      id
      full_name
      image {
        bucket
        key
        width
        height
      }
    }
    users_mentioned {
      id
      full_name
    }
  }
`;
export const ContentFragmentDoc = gql`
  fragment Content on Content {
    content_id
    content_source_id
    is_shareable
    is_important
    is_engage
    is_pinned
    pinned_end_at
    important_to_share
    share_count
    engagement_count
    click_count
    publish_at
    group_ids
    has_requesting_user_shared
    commentary {
      network
      commentary
    }
    group_id_approvals {
      group_id
      approval
    }
    content_object {
      ...ContentObject
    }
    reactions {
      ...ContentReactions
    }
    comments {
      id
      created_at
      paginate
      count
      comments {
        ...Comment
      }
    }
    groups {
      ...GetFeedGroup
    }
    group_ids
    user {
      ...PublicUserProfile
    }
    url_param_values {
      key
      value
    }
  }
  ${ContentObjectFragmentDoc}
  ${ContentReactionsFragmentDoc}
  ${CommentFragmentDoc}
  ${GetFeedGroupFragmentDoc}
  ${PublicUserProfileFragmentDoc}
`;
export const SharesItemFragmentDoc = gql`
  fragment SharesItem on SharesItem {
    id
    network
    network_id
    identifier
    user_commentary
    share_at
    shared_at
    share_session_id
    clicks
    engagements
    content {
      ...Content
    }
  }
  ${ContentFragmentDoc}
`;
export const UserFeedFollowFragmentDoc = gql`
  fragment UserFeedFollow on UserFeedFollow {
    feed
    user_id
    created_at
    postable
    group {
      ...UserFeedFollowGroup
    }
    user {
      ...PublicUserProfile
    }
  }
  ${UserFeedFollowGroupFragmentDoc}
  ${PublicUserProfileFragmentDoc}
`;
export const GroupModeratorFragmentDoc = gql`
  fragment GroupModerator on GroupModerator {
    group_id
    user_id
    created_at
    added_by_user_id
    user {
      ...PublicUserProfile
    }
  }
  ${PublicUserProfileFragmentDoc}
`;
export const UserProfileFragmentDoc = gql`
  fragment UserProfile on UserProfile {
    id
    full_name
    job_title
    follower_count
    karma
    image {
      bucket
      key
      width
      height
    }
    leaderboard_enabled
    email_address
    user_type
    client_id
    location_id
    location_title
    department_id
    department_title
    last_onboarding_step
    lang
    onboarding_completed
    last_accessed_at
    user_timezone
    created_at
    german_privacy
    reach
    group_moderator {
      ...GroupModerator
    }
    notification_delivery_types
  }
  ${GroupModeratorFragmentDoc}
`;
export const AdminUpdateClientDocument = gql`
  mutation ADMIN_UPDATE_CLIENT($data: AdminUpdateClientInput!) {
    adminUpdateClient(data: $data) {
      id
      content_domains
    }
  }
`;
export type AdminUpdateClientMutationFn = ApolloReactCommon.MutationFunction<
  AdminUpdateClientMutation,
  AdminUpdateClientMutationVariables
>;
export type AdminUpdateClientComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AdminUpdateClientMutation,
    AdminUpdateClientMutationVariables
  >,
  'mutation'
>;

export const AdminUpdateClientComponent = (props: AdminUpdateClientComponentProps) => (
  <ApolloReactComponents.Mutation<AdminUpdateClientMutation, AdminUpdateClientMutationVariables>
    mutation={AdminUpdateClientDocument}
    {...props}
  />
);

export type AdminUpdateClientProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  AdminUpdateClientMutation,
  AdminUpdateClientMutationVariables
> &
  TChildProps;
export function withAdminUpdateClient<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    AdminUpdateClientMutation,
    AdminUpdateClientMutationVariables,
    AdminUpdateClientProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    AdminUpdateClientMutation,
    AdminUpdateClientMutationVariables,
    AdminUpdateClientProps<TChildProps>
  >(AdminUpdateClientDocument, {
    alias: 'adminUpdateClient',
    ...operationOptions,
  });
}

/**
 * __useAdminUpdateClientMutation__
 *
 * To run a mutation, you first call `useAdminUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateClientMutation, { data, loading, error }] = useAdminUpdateClientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminUpdateClientMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AdminUpdateClientMutation,
    AdminUpdateClientMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    AdminUpdateClientMutation,
    AdminUpdateClientMutationVariables
  >(AdminUpdateClientDocument, baseOptions);
}
export type AdminUpdateClientMutationHookResult = ReturnType<typeof useAdminUpdateClientMutation>;
export type AdminUpdateClientMutationResult = ApolloReactCommon.MutationResult<
  AdminUpdateClientMutation
>;
export type AdminUpdateClientMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AdminUpdateClientMutation,
  AdminUpdateClientMutationVariables
>;
export const BatchDeleteGroupsDocument = gql`
  mutation BATCH_DELETE_GROUPS($ids: [ID]!) {
    batchDeleteGroups(ids: $ids) {
      id
    }
  }
`;
export type BatchDeleteGroupsMutationFn = ApolloReactCommon.MutationFunction<
  BatchDeleteGroupsMutation,
  BatchDeleteGroupsMutationVariables
>;
export type BatchDeleteGroupsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BatchDeleteGroupsMutation,
    BatchDeleteGroupsMutationVariables
  >,
  'mutation'
>;

export const BatchDeleteGroupsComponent = (props: BatchDeleteGroupsComponentProps) => (
  <ApolloReactComponents.Mutation<BatchDeleteGroupsMutation, BatchDeleteGroupsMutationVariables>
    mutation={BatchDeleteGroupsDocument}
    {...props}
  />
);

export type BatchDeleteGroupsProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  BatchDeleteGroupsMutation,
  BatchDeleteGroupsMutationVariables
> &
  TChildProps;
export function withBatchDeleteGroups<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    BatchDeleteGroupsMutation,
    BatchDeleteGroupsMutationVariables,
    BatchDeleteGroupsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    BatchDeleteGroupsMutation,
    BatchDeleteGroupsMutationVariables,
    BatchDeleteGroupsProps<TChildProps>
  >(BatchDeleteGroupsDocument, {
    alias: 'batchDeleteGroups',
    ...operationOptions,
  });
}

/**
 * __useBatchDeleteGroupsMutation__
 *
 * To run a mutation, you first call `useBatchDeleteGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchDeleteGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchDeleteGroupsMutation, { data, loading, error }] = useBatchDeleteGroupsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBatchDeleteGroupsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    BatchDeleteGroupsMutation,
    BatchDeleteGroupsMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    BatchDeleteGroupsMutation,
    BatchDeleteGroupsMutationVariables
  >(BatchDeleteGroupsDocument, baseOptions);
}
export type BatchDeleteGroupsMutationHookResult = ReturnType<typeof useBatchDeleteGroupsMutation>;
export type BatchDeleteGroupsMutationResult = ApolloReactCommon.MutationResult<
  BatchDeleteGroupsMutation
>;
export type BatchDeleteGroupsMutationOptions = ApolloReactCommon.BaseMutationOptions<
  BatchDeleteGroupsMutation,
  BatchDeleteGroupsMutationVariables
>;
export const BatchUpdateUserProfileStatusDocument = gql`
  mutation BATCH_UPDATE_USER_PROFILE_STATUS($ids: [ID]!, $user_status: UserStatus!) {
    batchUpdateUserProfileStatus(ids: $ids, user_status: $user_status) {
      id
      user_status
    }
  }
`;
export type BatchUpdateUserProfileStatusMutationFn = ApolloReactCommon.MutationFunction<
  BatchUpdateUserProfileStatusMutation,
  BatchUpdateUserProfileStatusMutationVariables
>;
export type BatchUpdateUserProfileStatusComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BatchUpdateUserProfileStatusMutation,
    BatchUpdateUserProfileStatusMutationVariables
  >,
  'mutation'
>;

export const BatchUpdateUserProfileStatusComponent = (
  props: BatchUpdateUserProfileStatusComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    BatchUpdateUserProfileStatusMutation,
    BatchUpdateUserProfileStatusMutationVariables
  >
    mutation={BatchUpdateUserProfileStatusDocument}
    {...props}
  />
);

export type BatchUpdateUserProfileStatusProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  BatchUpdateUserProfileStatusMutation,
  BatchUpdateUserProfileStatusMutationVariables
> &
  TChildProps;
export function withBatchUpdateUserProfileStatus<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    BatchUpdateUserProfileStatusMutation,
    BatchUpdateUserProfileStatusMutationVariables,
    BatchUpdateUserProfileStatusProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    BatchUpdateUserProfileStatusMutation,
    BatchUpdateUserProfileStatusMutationVariables,
    BatchUpdateUserProfileStatusProps<TChildProps>
  >(BatchUpdateUserProfileStatusDocument, {
    alias: 'batchUpdateUserProfileStatus',
    ...operationOptions,
  });
}

/**
 * __useBatchUpdateUserProfileStatusMutation__
 *
 * To run a mutation, you first call `useBatchUpdateUserProfileStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateUserProfileStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpdateUserProfileStatusMutation, { data, loading, error }] = useBatchUpdateUserProfileStatusMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      user_status: // value for 'user_status'
 *   },
 * });
 */
export function useBatchUpdateUserProfileStatusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    BatchUpdateUserProfileStatusMutation,
    BatchUpdateUserProfileStatusMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    BatchUpdateUserProfileStatusMutation,
    BatchUpdateUserProfileStatusMutationVariables
  >(BatchUpdateUserProfileStatusDocument, baseOptions);
}
export type BatchUpdateUserProfileStatusMutationHookResult = ReturnType<
  typeof useBatchUpdateUserProfileStatusMutation
>;
export type BatchUpdateUserProfileStatusMutationResult = ApolloReactCommon.MutationResult<
  BatchUpdateUserProfileStatusMutation
>;
export type BatchUpdateUserProfileStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<
  BatchUpdateUserProfileStatusMutation,
  BatchUpdateUserProfileStatusMutationVariables
>;
export const BatchUpdateUserProfileTypeDocument = gql`
  mutation BATCH_UPDATE_USER_PROFILE_TYPE($ids: [ID]!, $user_type: UserType!) {
    batchUpdateUserProfileUserType(ids: $ids, user_type: $user_type) {
      id
      user_type
    }
  }
`;
export type BatchUpdateUserProfileTypeMutationFn = ApolloReactCommon.MutationFunction<
  BatchUpdateUserProfileTypeMutation,
  BatchUpdateUserProfileTypeMutationVariables
>;
export type BatchUpdateUserProfileTypeComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BatchUpdateUserProfileTypeMutation,
    BatchUpdateUserProfileTypeMutationVariables
  >,
  'mutation'
>;

export const BatchUpdateUserProfileTypeComponent = (
  props: BatchUpdateUserProfileTypeComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    BatchUpdateUserProfileTypeMutation,
    BatchUpdateUserProfileTypeMutationVariables
  >
    mutation={BatchUpdateUserProfileTypeDocument}
    {...props}
  />
);

export type BatchUpdateUserProfileTypeProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  BatchUpdateUserProfileTypeMutation,
  BatchUpdateUserProfileTypeMutationVariables
> &
  TChildProps;
export function withBatchUpdateUserProfileType<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    BatchUpdateUserProfileTypeMutation,
    BatchUpdateUserProfileTypeMutationVariables,
    BatchUpdateUserProfileTypeProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    BatchUpdateUserProfileTypeMutation,
    BatchUpdateUserProfileTypeMutationVariables,
    BatchUpdateUserProfileTypeProps<TChildProps>
  >(BatchUpdateUserProfileTypeDocument, {
    alias: 'batchUpdateUserProfileType',
    ...operationOptions,
  });
}

/**
 * __useBatchUpdateUserProfileTypeMutation__
 *
 * To run a mutation, you first call `useBatchUpdateUserProfileTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateUserProfileTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpdateUserProfileTypeMutation, { data, loading, error }] = useBatchUpdateUserProfileTypeMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      user_type: // value for 'user_type'
 *   },
 * });
 */
export function useBatchUpdateUserProfileTypeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    BatchUpdateUserProfileTypeMutation,
    BatchUpdateUserProfileTypeMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    BatchUpdateUserProfileTypeMutation,
    BatchUpdateUserProfileTypeMutationVariables
  >(BatchUpdateUserProfileTypeDocument, baseOptions);
}
export type BatchUpdateUserProfileTypeMutationHookResult = ReturnType<
  typeof useBatchUpdateUserProfileTypeMutation
>;
export type BatchUpdateUserProfileTypeMutationResult = ApolloReactCommon.MutationResult<
  BatchUpdateUserProfileTypeMutation
>;
export type BatchUpdateUserProfileTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<
  BatchUpdateUserProfileTypeMutation,
  BatchUpdateUserProfileTypeMutationVariables
>;
export const CreateClientDepartmentDocument = gql`
  mutation CREATE_CLIENT_DEPARTMENT($data: CreateClientDepartmentInput!) {
    createClientDepartment(data: $data) {
      ...ClientDepartment
    }
  }
  ${ClientDepartmentFragmentDoc}
`;
export type CreateClientDepartmentMutationFn = ApolloReactCommon.MutationFunction<
  CreateClientDepartmentMutation,
  CreateClientDepartmentMutationVariables
>;
export type CreateClientDepartmentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateClientDepartmentMutation,
    CreateClientDepartmentMutationVariables
  >,
  'mutation'
>;

export const CreateClientDepartmentComponent = (props: CreateClientDepartmentComponentProps) => (
  <ApolloReactComponents.Mutation<
    CreateClientDepartmentMutation,
    CreateClientDepartmentMutationVariables
  >
    mutation={CreateClientDepartmentDocument}
    {...props}
  />
);

export type CreateClientDepartmentProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateClientDepartmentMutation,
  CreateClientDepartmentMutationVariables
> &
  TChildProps;
export function withCreateClientDepartment<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateClientDepartmentMutation,
    CreateClientDepartmentMutationVariables,
    CreateClientDepartmentProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateClientDepartmentMutation,
    CreateClientDepartmentMutationVariables,
    CreateClientDepartmentProps<TChildProps>
  >(CreateClientDepartmentDocument, {
    alias: 'createClientDepartment',
    ...operationOptions,
  });
}

/**
 * __useCreateClientDepartmentMutation__
 *
 * To run a mutation, you first call `useCreateClientDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientDepartmentMutation, { data, loading, error }] = useCreateClientDepartmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientDepartmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateClientDepartmentMutation,
    CreateClientDepartmentMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateClientDepartmentMutation,
    CreateClientDepartmentMutationVariables
  >(CreateClientDepartmentDocument, baseOptions);
}
export type CreateClientDepartmentMutationHookResult = ReturnType<
  typeof useCreateClientDepartmentMutation
>;
export type CreateClientDepartmentMutationResult = ApolloReactCommon.MutationResult<
  CreateClientDepartmentMutation
>;
export type CreateClientDepartmentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateClientDepartmentMutation,
  CreateClientDepartmentMutationVariables
>;
export const CreateClientFollowMappingDocument = gql`
  mutation CREATE_CLIENT_FOLLOW_MAPPING($data: CreateClientFollowMappingInput!) {
    createClientFollowMapping(data: $data) {
      ...ClientFollowMapping
    }
  }
  ${ClientFollowMappingFragmentDoc}
`;
export type CreateClientFollowMappingMutationFn = ApolloReactCommon.MutationFunction<
  CreateClientFollowMappingMutation,
  CreateClientFollowMappingMutationVariables
>;
export type CreateClientFollowMappingComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateClientFollowMappingMutation,
    CreateClientFollowMappingMutationVariables
  >,
  'mutation'
>;

export const CreateClientFollowMappingComponent = (
  props: CreateClientFollowMappingComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    CreateClientFollowMappingMutation,
    CreateClientFollowMappingMutationVariables
  >
    mutation={CreateClientFollowMappingDocument}
    {...props}
  />
);

export type CreateClientFollowMappingProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateClientFollowMappingMutation,
  CreateClientFollowMappingMutationVariables
> &
  TChildProps;
export function withCreateClientFollowMapping<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateClientFollowMappingMutation,
    CreateClientFollowMappingMutationVariables,
    CreateClientFollowMappingProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateClientFollowMappingMutation,
    CreateClientFollowMappingMutationVariables,
    CreateClientFollowMappingProps<TChildProps>
  >(CreateClientFollowMappingDocument, {
    alias: 'createClientFollowMapping',
    ...operationOptions,
  });
}

/**
 * __useCreateClientFollowMappingMutation__
 *
 * To run a mutation, you first call `useCreateClientFollowMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientFollowMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientFollowMappingMutation, { data, loading, error }] = useCreateClientFollowMappingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientFollowMappingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateClientFollowMappingMutation,
    CreateClientFollowMappingMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateClientFollowMappingMutation,
    CreateClientFollowMappingMutationVariables
  >(CreateClientFollowMappingDocument, baseOptions);
}
export type CreateClientFollowMappingMutationHookResult = ReturnType<
  typeof useCreateClientFollowMappingMutation
>;
export type CreateClientFollowMappingMutationResult = ApolloReactCommon.MutationResult<
  CreateClientFollowMappingMutation
>;
export type CreateClientFollowMappingMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateClientFollowMappingMutation,
  CreateClientFollowMappingMutationVariables
>;
export const CreateClientInvitationDocument = gql`
  mutation CREATE_CLIENT_INVITATION($data: CreateClientInvitationInput!) {
    createClientInvitation(data: $data) {
      ...ClientInvitation
    }
  }
  ${ClientInvitationFragmentDoc}
`;
export type CreateClientInvitationMutationFn = ApolloReactCommon.MutationFunction<
  CreateClientInvitationMutation,
  CreateClientInvitationMutationVariables
>;
export type CreateClientInvitationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateClientInvitationMutation,
    CreateClientInvitationMutationVariables
  >,
  'mutation'
>;

export const CreateClientInvitationComponent = (props: CreateClientInvitationComponentProps) => (
  <ApolloReactComponents.Mutation<
    CreateClientInvitationMutation,
    CreateClientInvitationMutationVariables
  >
    mutation={CreateClientInvitationDocument}
    {...props}
  />
);

export type CreateClientInvitationProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateClientInvitationMutation,
  CreateClientInvitationMutationVariables
> &
  TChildProps;
export function withCreateClientInvitation<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateClientInvitationMutation,
    CreateClientInvitationMutationVariables,
    CreateClientInvitationProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateClientInvitationMutation,
    CreateClientInvitationMutationVariables,
    CreateClientInvitationProps<TChildProps>
  >(CreateClientInvitationDocument, {
    alias: 'createClientInvitation',
    ...operationOptions,
  });
}

/**
 * __useCreateClientInvitationMutation__
 *
 * To run a mutation, you first call `useCreateClientInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientInvitationMutation, { data, loading, error }] = useCreateClientInvitationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientInvitationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateClientInvitationMutation,
    CreateClientInvitationMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateClientInvitationMutation,
    CreateClientInvitationMutationVariables
  >(CreateClientInvitationDocument, baseOptions);
}
export type CreateClientInvitationMutationHookResult = ReturnType<
  typeof useCreateClientInvitationMutation
>;
export type CreateClientInvitationMutationResult = ApolloReactCommon.MutationResult<
  CreateClientInvitationMutation
>;
export type CreateClientInvitationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateClientInvitationMutation,
  CreateClientInvitationMutationVariables
>;
export const CreateClientLocationDocument = gql`
  mutation CREATE_CLIENT_LOCATION($data: CreateClientLocationInput!) {
    createClientLocation(data: $data) {
      ...ClientLocation
    }
  }
  ${ClientLocationFragmentDoc}
`;
export type CreateClientLocationMutationFn = ApolloReactCommon.MutationFunction<
  CreateClientLocationMutation,
  CreateClientLocationMutationVariables
>;
export type CreateClientLocationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateClientLocationMutation,
    CreateClientLocationMutationVariables
  >,
  'mutation'
>;

export const CreateClientLocationComponent = (props: CreateClientLocationComponentProps) => (
  <ApolloReactComponents.Mutation<
    CreateClientLocationMutation,
    CreateClientLocationMutationVariables
  >
    mutation={CreateClientLocationDocument}
    {...props}
  />
);

export type CreateClientLocationProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateClientLocationMutation,
  CreateClientLocationMutationVariables
> &
  TChildProps;
export function withCreateClientLocation<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateClientLocationMutation,
    CreateClientLocationMutationVariables,
    CreateClientLocationProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateClientLocationMutation,
    CreateClientLocationMutationVariables,
    CreateClientLocationProps<TChildProps>
  >(CreateClientLocationDocument, {
    alias: 'createClientLocation',
    ...operationOptions,
  });
}

/**
 * __useCreateClientLocationMutation__
 *
 * To run a mutation, you first call `useCreateClientLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientLocationMutation, { data, loading, error }] = useCreateClientLocationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientLocationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateClientLocationMutation,
    CreateClientLocationMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateClientLocationMutation,
    CreateClientLocationMutationVariables
  >(CreateClientLocationDocument, baseOptions);
}
export type CreateClientLocationMutationHookResult = ReturnType<
  typeof useCreateClientLocationMutation
>;
export type CreateClientLocationMutationResult = ApolloReactCommon.MutationResult<
  CreateClientLocationMutation
>;
export type CreateClientLocationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateClientLocationMutation,
  CreateClientLocationMutationVariables
>;
export const CreateCommentDocument = gql`
  mutation CREATE_COMMENT($comment_text: String!, $object_id: ID!) {
    createComment(
      data: { comment_text: $comment_text, object_id: $object_id, object_type: content }
    ) {
      ...Comment
    }
  }
  ${CommentFragmentDoc}
`;
export type CreateCommentMutationFn = ApolloReactCommon.MutationFunction<
  CreateCommentMutation,
  CreateCommentMutationVariables
>;
export type CreateCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateCommentMutation,
    CreateCommentMutationVariables
  >,
  'mutation'
>;

export const CreateCommentComponent = (props: CreateCommentComponentProps) => (
  <ApolloReactComponents.Mutation<CreateCommentMutation, CreateCommentMutationVariables>
    mutation={CreateCommentDocument}
    {...props}
  />
);

export type CreateCommentProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateCommentMutation,
  CreateCommentMutationVariables
> &
  TChildProps;
export function withCreateComment<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateCommentMutation,
    CreateCommentMutationVariables,
    CreateCommentProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateCommentMutation,
    CreateCommentMutationVariables,
    CreateCommentProps<TChildProps>
  >(CreateCommentDocument, {
    alias: 'createComment',
    ...operationOptions,
  });
}

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      comment_text: // value for 'comment_text'
 *      object_id: // value for 'object_id'
 *   },
 * });
 */
export function useCreateCommentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateCommentMutation,
    CreateCommentMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(
    CreateCommentDocument,
    baseOptions,
  );
}
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = ApolloReactCommon.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateCommentMutation,
  CreateCommentMutationVariables
>;
export const CreateCommentReplyDocument = gql`
  mutation CREATE_COMMENT_REPLY($comment_text: String!, $object_id: ID!, $parent_id: ID!) {
    createComment(
      data: {
        comment_text: $comment_text
        object_id: $object_id
        object_type: content
        parent_id: $parent_id
      }
    ) {
      ...Comment
    }
  }
  ${CommentFragmentDoc}
`;
export type CreateCommentReplyMutationFn = ApolloReactCommon.MutationFunction<
  CreateCommentReplyMutation,
  CreateCommentReplyMutationVariables
>;
export type CreateCommentReplyComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateCommentReplyMutation,
    CreateCommentReplyMutationVariables
  >,
  'mutation'
>;

export const CreateCommentReplyComponent = (props: CreateCommentReplyComponentProps) => (
  <ApolloReactComponents.Mutation<CreateCommentReplyMutation, CreateCommentReplyMutationVariables>
    mutation={CreateCommentReplyDocument}
    {...props}
  />
);

export type CreateCommentReplyProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateCommentReplyMutation,
  CreateCommentReplyMutationVariables
> &
  TChildProps;
export function withCreateCommentReply<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateCommentReplyMutation,
    CreateCommentReplyMutationVariables,
    CreateCommentReplyProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateCommentReplyMutation,
    CreateCommentReplyMutationVariables,
    CreateCommentReplyProps<TChildProps>
  >(CreateCommentReplyDocument, {
    alias: 'createCommentReply',
    ...operationOptions,
  });
}

/**
 * __useCreateCommentReplyMutation__
 *
 * To run a mutation, you first call `useCreateCommentReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentReplyMutation, { data, loading, error }] = useCreateCommentReplyMutation({
 *   variables: {
 *      comment_text: // value for 'comment_text'
 *      object_id: // value for 'object_id'
 *      parent_id: // value for 'parent_id'
 *   },
 * });
 */
export function useCreateCommentReplyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateCommentReplyMutation,
    CreateCommentReplyMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateCommentReplyMutation,
    CreateCommentReplyMutationVariables
  >(CreateCommentReplyDocument, baseOptions);
}
export type CreateCommentReplyMutationHookResult = ReturnType<typeof useCreateCommentReplyMutation>;
export type CreateCommentReplyMutationResult = ApolloReactCommon.MutationResult<
  CreateCommentReplyMutation
>;
export type CreateCommentReplyMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateCommentReplyMutation,
  CreateCommentReplyMutationVariables
>;
export const CreateGroupDocument = gql`
  mutation CREATE_GROUP($data: CreateGroupInput!) {
    createGroup(data: $data) {
      ...Group
    }
  }
  ${GroupFragmentDoc}
`;
export type CreateGroupMutationFn = ApolloReactCommon.MutationFunction<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;
export type CreateGroupComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<CreateGroupMutation, CreateGroupMutationVariables>,
  'mutation'
>;

export const CreateGroupComponent = (props: CreateGroupComponentProps) => (
  <ApolloReactComponents.Mutation<CreateGroupMutation, CreateGroupMutationVariables>
    mutation={CreateGroupDocument}
    {...props}
  />
);

export type CreateGroupProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateGroupMutation,
  CreateGroupMutationVariables
> &
  TChildProps;
export function withCreateGroup<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateGroupMutation,
    CreateGroupMutationVariables,
    CreateGroupProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateGroupMutation,
    CreateGroupMutationVariables,
    CreateGroupProps<TChildProps>
  >(CreateGroupDocument, {
    alias: 'createGroup',
    ...operationOptions,
  });
}

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGroupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateGroupMutation,
    CreateGroupMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(
    CreateGroupDocument,
    baseOptions,
  );
}
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = ApolloReactCommon.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;
export const CreateGroupModeratorDocument = gql`
  mutation CREATE_GROUP_MODERATOR($group_id: ID!, $user_id: ID!) {
    createGroupModerator(group_id: $group_id, user_id: $user_id) {
      ...GroupModerator
    }
  }
  ${GroupModeratorFragmentDoc}
`;
export type CreateGroupModeratorMutationFn = ApolloReactCommon.MutationFunction<
  CreateGroupModeratorMutation,
  CreateGroupModeratorMutationVariables
>;
export type CreateGroupModeratorComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateGroupModeratorMutation,
    CreateGroupModeratorMutationVariables
  >,
  'mutation'
>;

export const CreateGroupModeratorComponent = (props: CreateGroupModeratorComponentProps) => (
  <ApolloReactComponents.Mutation<
    CreateGroupModeratorMutation,
    CreateGroupModeratorMutationVariables
  >
    mutation={CreateGroupModeratorDocument}
    {...props}
  />
);

export type CreateGroupModeratorProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateGroupModeratorMutation,
  CreateGroupModeratorMutationVariables
> &
  TChildProps;
export function withCreateGroupModerator<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateGroupModeratorMutation,
    CreateGroupModeratorMutationVariables,
    CreateGroupModeratorProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateGroupModeratorMutation,
    CreateGroupModeratorMutationVariables,
    CreateGroupModeratorProps<TChildProps>
  >(CreateGroupModeratorDocument, {
    alias: 'createGroupModerator',
    ...operationOptions,
  });
}

/**
 * __useCreateGroupModeratorMutation__
 *
 * To run a mutation, you first call `useCreateGroupModeratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupModeratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupModeratorMutation, { data, loading, error }] = useCreateGroupModeratorMutation({
 *   variables: {
 *      group_id: // value for 'group_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useCreateGroupModeratorMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateGroupModeratorMutation,
    CreateGroupModeratorMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateGroupModeratorMutation,
    CreateGroupModeratorMutationVariables
  >(CreateGroupModeratorDocument, baseOptions);
}
export type CreateGroupModeratorMutationHookResult = ReturnType<
  typeof useCreateGroupModeratorMutation
>;
export type CreateGroupModeratorMutationResult = ApolloReactCommon.MutationResult<
  CreateGroupModeratorMutation
>;
export type CreateGroupModeratorMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateGroupModeratorMutation,
  CreateGroupModeratorMutationVariables
>;
export const CreateGroupSourceDocument = gql`
  mutation CREATE_GROUP_SOURCE(
    $group_id: ID!
    $source_status: SourceStatus!
    $source_type: GroupSourceType!
    $source_value: String!
    $approval: ContentApproval
  ) {
    clientGroupSourceCreate(
      group_id: $group_id
      source_status: $source_status
      source_type: $source_type
      source_value: $source_value
      approval: $approval
    ) {
      ...ClientGroupSource
    }
  }
  ${ClientGroupSourceFragmentDoc}
`;
export type CreateGroupSourceMutationFn = ApolloReactCommon.MutationFunction<
  CreateGroupSourceMutation,
  CreateGroupSourceMutationVariables
>;
export type CreateGroupSourceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateGroupSourceMutation,
    CreateGroupSourceMutationVariables
  >,
  'mutation'
>;

export const CreateGroupSourceComponent = (props: CreateGroupSourceComponentProps) => (
  <ApolloReactComponents.Mutation<CreateGroupSourceMutation, CreateGroupSourceMutationVariables>
    mutation={CreateGroupSourceDocument}
    {...props}
  />
);

export type CreateGroupSourceProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateGroupSourceMutation,
  CreateGroupSourceMutationVariables
> &
  TChildProps;
export function withCreateGroupSource<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateGroupSourceMutation,
    CreateGroupSourceMutationVariables,
    CreateGroupSourceProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateGroupSourceMutation,
    CreateGroupSourceMutationVariables,
    CreateGroupSourceProps<TChildProps>
  >(CreateGroupSourceDocument, {
    alias: 'createGroupSource',
    ...operationOptions,
  });
}

/**
 * __useCreateGroupSourceMutation__
 *
 * To run a mutation, you first call `useCreateGroupSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupSourceMutation, { data, loading, error }] = useCreateGroupSourceMutation({
 *   variables: {
 *      group_id: // value for 'group_id'
 *      source_status: // value for 'source_status'
 *      source_type: // value for 'source_type'
 *      source_value: // value for 'source_value'
 *      approval: // value for 'approval'
 *   },
 * });
 */
export function useCreateGroupSourceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateGroupSourceMutation,
    CreateGroupSourceMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateGroupSourceMutation,
    CreateGroupSourceMutationVariables
  >(CreateGroupSourceDocument, baseOptions);
}
export type CreateGroupSourceMutationHookResult = ReturnType<typeof useCreateGroupSourceMutation>;
export type CreateGroupSourceMutationResult = ApolloReactCommon.MutationResult<
  CreateGroupSourceMutation
>;
export type CreateGroupSourceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateGroupSourceMutation,
  CreateGroupSourceMutationVariables
>;
export const CreateManualNotificationDocument = gql`
  mutation CREATE_MANUAL_NOTIFICATION($data: ManualNotificationsItemInput!) {
    createManualNotification(data: $data) {
      ...ManualNotificationsItem
    }
  }
  ${ManualNotificationsItemFragmentDoc}
`;
export type CreateManualNotificationMutationFn = ApolloReactCommon.MutationFunction<
  CreateManualNotificationMutation,
  CreateManualNotificationMutationVariables
>;
export type CreateManualNotificationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateManualNotificationMutation,
    CreateManualNotificationMutationVariables
  >,
  'mutation'
>;

export const CreateManualNotificationComponent = (
  props: CreateManualNotificationComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    CreateManualNotificationMutation,
    CreateManualNotificationMutationVariables
  >
    mutation={CreateManualNotificationDocument}
    {...props}
  />
);

export type CreateManualNotificationProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateManualNotificationMutation,
  CreateManualNotificationMutationVariables
> &
  TChildProps;
export function withCreateManualNotification<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateManualNotificationMutation,
    CreateManualNotificationMutationVariables,
    CreateManualNotificationProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateManualNotificationMutation,
    CreateManualNotificationMutationVariables,
    CreateManualNotificationProps<TChildProps>
  >(CreateManualNotificationDocument, {
    alias: 'createManualNotification',
    ...operationOptions,
  });
}

/**
 * __useCreateManualNotificationMutation__
 *
 * To run a mutation, you first call `useCreateManualNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualNotificationMutation, { data, loading, error }] = useCreateManualNotificationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateManualNotificationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateManualNotificationMutation,
    CreateManualNotificationMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateManualNotificationMutation,
    CreateManualNotificationMutationVariables
  >(CreateManualNotificationDocument, baseOptions);
}
export type CreateManualNotificationMutationHookResult = ReturnType<
  typeof useCreateManualNotificationMutation
>;
export type CreateManualNotificationMutationResult = ApolloReactCommon.MutationResult<
  CreateManualNotificationMutation
>;
export type CreateManualNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateManualNotificationMutation,
  CreateManualNotificationMutationVariables
>;
export const CreateReactionDocument = gql`
  mutation CREATE_REACTION($content_id: String!) {
    createReaction(data: { object_type: content, object_id: $content_id, reaction_type: like }) {
      object_type
      object_id
      reaction_type
      user_id
      created_at
    }
  }
`;
export type CreateReactionMutationFn = ApolloReactCommon.MutationFunction<
  CreateReactionMutation,
  CreateReactionMutationVariables
>;
export type CreateReactionComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateReactionMutation,
    CreateReactionMutationVariables
  >,
  'mutation'
>;

export const CreateReactionComponent = (props: CreateReactionComponentProps) => (
  <ApolloReactComponents.Mutation<CreateReactionMutation, CreateReactionMutationVariables>
    mutation={CreateReactionDocument}
    {...props}
  />
);

export type CreateReactionProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateReactionMutation,
  CreateReactionMutationVariables
> &
  TChildProps;
export function withCreateReaction<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateReactionMutation,
    CreateReactionMutationVariables,
    CreateReactionProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateReactionMutation,
    CreateReactionMutationVariables,
    CreateReactionProps<TChildProps>
  >(CreateReactionDocument, {
    alias: 'createReaction',
    ...operationOptions,
  });
}

/**
 * __useCreateReactionMutation__
 *
 * To run a mutation, you first call `useCreateReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReactionMutation, { data, loading, error }] = useCreateReactionMutation({
 *   variables: {
 *      content_id: // value for 'content_id'
 *   },
 * });
 */
export function useCreateReactionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateReactionMutation,
    CreateReactionMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<CreateReactionMutation, CreateReactionMutationVariables>(
    CreateReactionDocument,
    baseOptions,
  );
}
export type CreateReactionMutationHookResult = ReturnType<typeof useCreateReactionMutation>;
export type CreateReactionMutationResult = ApolloReactCommon.MutationResult<CreateReactionMutation>;
export type CreateReactionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateReactionMutation,
  CreateReactionMutationVariables
>;
export const CreateReportRequestDocument = gql`
  mutation CREATE_REPORT_REQUEST($data: RunReportInput!) {
    createReportRequest(data: $data) {
      ...ReportRequest
    }
  }
  ${ReportRequestFragmentDoc}
`;
export type CreateReportRequestMutationFn = ApolloReactCommon.MutationFunction<
  CreateReportRequestMutation,
  CreateReportRequestMutationVariables
>;
export type CreateReportRequestComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateReportRequestMutation,
    CreateReportRequestMutationVariables
  >,
  'mutation'
>;

export const CreateReportRequestComponent = (props: CreateReportRequestComponentProps) => (
  <ApolloReactComponents.Mutation<CreateReportRequestMutation, CreateReportRequestMutationVariables>
    mutation={CreateReportRequestDocument}
    {...props}
  />
);

export type CreateReportRequestProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateReportRequestMutation,
  CreateReportRequestMutationVariables
> &
  TChildProps;
export function withCreateReportRequest<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateReportRequestMutation,
    CreateReportRequestMutationVariables,
    CreateReportRequestProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateReportRequestMutation,
    CreateReportRequestMutationVariables,
    CreateReportRequestProps<TChildProps>
  >(CreateReportRequestDocument, {
    alias: 'createReportRequest',
    ...operationOptions,
  });
}

/**
 * __useCreateReportRequestMutation__
 *
 * To run a mutation, you first call `useCreateReportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportRequestMutation, { data, loading, error }] = useCreateReportRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateReportRequestMutation,
    CreateReportRequestMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateReportRequestMutation,
    CreateReportRequestMutationVariables
  >(CreateReportRequestDocument, baseOptions);
}
export type CreateReportRequestMutationHookResult = ReturnType<
  typeof useCreateReportRequestMutation
>;
export type CreateReportRequestMutationResult = ApolloReactCommon.MutationResult<
  CreateReportRequestMutation
>;
export type CreateReportRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateReportRequestMutation,
  CreateReportRequestMutationVariables
>;
export const CreateUpdateLeaderboardConfigDocument = gql`
  mutation CREATE_UPDATE_LEADERBOARD_CONFIG($data: LeaderboardConfigInput!) {
    createUpdateLeaderboardConfig(data: $data) {
      ...LeaderboardConfig
    }
  }
  ${LeaderboardConfigFragmentDoc}
`;
export type CreateUpdateLeaderboardConfigMutationFn = ApolloReactCommon.MutationFunction<
  CreateUpdateLeaderboardConfigMutation,
  CreateUpdateLeaderboardConfigMutationVariables
>;
export type CreateUpdateLeaderboardConfigComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateUpdateLeaderboardConfigMutation,
    CreateUpdateLeaderboardConfigMutationVariables
  >,
  'mutation'
>;

export const CreateUpdateLeaderboardConfigComponent = (
  props: CreateUpdateLeaderboardConfigComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    CreateUpdateLeaderboardConfigMutation,
    CreateUpdateLeaderboardConfigMutationVariables
  >
    mutation={CreateUpdateLeaderboardConfigDocument}
    {...props}
  />
);

export type CreateUpdateLeaderboardConfigProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateUpdateLeaderboardConfigMutation,
  CreateUpdateLeaderboardConfigMutationVariables
> &
  TChildProps;
export function withCreateUpdateLeaderboardConfig<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateUpdateLeaderboardConfigMutation,
    CreateUpdateLeaderboardConfigMutationVariables,
    CreateUpdateLeaderboardConfigProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateUpdateLeaderboardConfigMutation,
    CreateUpdateLeaderboardConfigMutationVariables,
    CreateUpdateLeaderboardConfigProps<TChildProps>
  >(CreateUpdateLeaderboardConfigDocument, {
    alias: 'createUpdateLeaderboardConfig',
    ...operationOptions,
  });
}

/**
 * __useCreateUpdateLeaderboardConfigMutation__
 *
 * To run a mutation, you first call `useCreateUpdateLeaderboardConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateLeaderboardConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateLeaderboardConfigMutation, { data, loading, error }] = useCreateUpdateLeaderboardConfigMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUpdateLeaderboardConfigMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateUpdateLeaderboardConfigMutation,
    CreateUpdateLeaderboardConfigMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateUpdateLeaderboardConfigMutation,
    CreateUpdateLeaderboardConfigMutationVariables
  >(CreateUpdateLeaderboardConfigDocument, baseOptions);
}
export type CreateUpdateLeaderboardConfigMutationHookResult = ReturnType<
  typeof useCreateUpdateLeaderboardConfigMutation
>;
export type CreateUpdateLeaderboardConfigMutationResult = ApolloReactCommon.MutationResult<
  CreateUpdateLeaderboardConfigMutation
>;
export type CreateUpdateLeaderboardConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateUpdateLeaderboardConfigMutation,
  CreateUpdateLeaderboardConfigMutationVariables
>;
export const CreateUserSegmentDocument = gql`
  mutation CREATE_USER_SEGMENT($data: CreateUserSegmentInput!) {
    createUserSegment(data: $data) {
      ...UserSegment
    }
  }
  ${UserSegmentFragmentDoc}
`;
export type CreateUserSegmentMutationFn = ApolloReactCommon.MutationFunction<
  CreateUserSegmentMutation,
  CreateUserSegmentMutationVariables
>;
export type CreateUserSegmentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateUserSegmentMutation,
    CreateUserSegmentMutationVariables
  >,
  'mutation'
>;

export const CreateUserSegmentComponent = (props: CreateUserSegmentComponentProps) => (
  <ApolloReactComponents.Mutation<CreateUserSegmentMutation, CreateUserSegmentMutationVariables>
    mutation={CreateUserSegmentDocument}
    {...props}
  />
);

export type CreateUserSegmentProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateUserSegmentMutation,
  CreateUserSegmentMutationVariables
> &
  TChildProps;
export function withCreateUserSegment<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateUserSegmentMutation,
    CreateUserSegmentMutationVariables,
    CreateUserSegmentProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateUserSegmentMutation,
    CreateUserSegmentMutationVariables,
    CreateUserSegmentProps<TChildProps>
  >(CreateUserSegmentDocument, {
    alias: 'createUserSegment',
    ...operationOptions,
  });
}

/**
 * __useCreateUserSegmentMutation__
 *
 * To run a mutation, you first call `useCreateUserSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserSegmentMutation, { data, loading, error }] = useCreateUserSegmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUserSegmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateUserSegmentMutation,
    CreateUserSegmentMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateUserSegmentMutation,
    CreateUserSegmentMutationVariables
  >(CreateUserSegmentDocument, baseOptions);
}
export type CreateUserSegmentMutationHookResult = ReturnType<typeof useCreateUserSegmentMutation>;
export type CreateUserSegmentMutationResult = ApolloReactCommon.MutationResult<
  CreateUserSegmentMutation
>;
export type CreateUserSegmentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateUserSegmentMutation,
  CreateUserSegmentMutationVariables
>;
export const DeleteCommentDocument = gql`
  mutation DELETE_COMMENT($id: ID!) {
    deleteComment(id: $id) {
      id
    }
  }
`;
export type DeleteCommentMutationFn = ApolloReactCommon.MutationFunction<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>;
export type DeleteCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteCommentMutation,
    DeleteCommentMutationVariables
  >,
  'mutation'
>;

export const DeleteCommentComponent = (props: DeleteCommentComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteCommentMutation, DeleteCommentMutationVariables>
    mutation={DeleteCommentDocument}
    {...props}
  />
);

export type DeleteCommentProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
> &
  TChildProps;
export function withDeleteComment<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    DeleteCommentMutation,
    DeleteCommentMutationVariables,
    DeleteCommentProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    DeleteCommentMutation,
    DeleteCommentMutationVariables,
    DeleteCommentProps<TChildProps>
  >(DeleteCommentDocument, {
    alias: 'deleteComment',
    ...operationOptions,
  });
}

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteCommentMutation,
    DeleteCommentMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(
    DeleteCommentDocument,
    baseOptions,
  );
}
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = ApolloReactCommon.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>;
export const DeleteGroupModeratorDocument = gql`
  mutation DELETE_GROUP_MODERATOR($group_id: ID!, $user_id: ID!) {
    deleteGroupModerator(group_id: $group_id, user_id: $user_id)
  }
`;
export type DeleteGroupModeratorMutationFn = ApolloReactCommon.MutationFunction<
  DeleteGroupModeratorMutation,
  DeleteGroupModeratorMutationVariables
>;
export type DeleteGroupModeratorComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteGroupModeratorMutation,
    DeleteGroupModeratorMutationVariables
  >,
  'mutation'
>;

export const DeleteGroupModeratorComponent = (props: DeleteGroupModeratorComponentProps) => (
  <ApolloReactComponents.Mutation<
    DeleteGroupModeratorMutation,
    DeleteGroupModeratorMutationVariables
  >
    mutation={DeleteGroupModeratorDocument}
    {...props}
  />
);

export type DeleteGroupModeratorProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  DeleteGroupModeratorMutation,
  DeleteGroupModeratorMutationVariables
> &
  TChildProps;
export function withDeleteGroupModerator<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    DeleteGroupModeratorMutation,
    DeleteGroupModeratorMutationVariables,
    DeleteGroupModeratorProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    DeleteGroupModeratorMutation,
    DeleteGroupModeratorMutationVariables,
    DeleteGroupModeratorProps<TChildProps>
  >(DeleteGroupModeratorDocument, {
    alias: 'deleteGroupModerator',
    ...operationOptions,
  });
}

/**
 * __useDeleteGroupModeratorMutation__
 *
 * To run a mutation, you first call `useDeleteGroupModeratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupModeratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupModeratorMutation, { data, loading, error }] = useDeleteGroupModeratorMutation({
 *   variables: {
 *      group_id: // value for 'group_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useDeleteGroupModeratorMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteGroupModeratorMutation,
    DeleteGroupModeratorMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    DeleteGroupModeratorMutation,
    DeleteGroupModeratorMutationVariables
  >(DeleteGroupModeratorDocument, baseOptions);
}
export type DeleteGroupModeratorMutationHookResult = ReturnType<
  typeof useDeleteGroupModeratorMutation
>;
export type DeleteGroupModeratorMutationResult = ApolloReactCommon.MutationResult<
  DeleteGroupModeratorMutation
>;
export type DeleteGroupModeratorMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteGroupModeratorMutation,
  DeleteGroupModeratorMutationVariables
>;
export const DeleteGroupSourceDocument = gql`
  mutation DELETE_GROUP_SOURCE($id: ID!) {
    clientGroupSourceDelete(id: $id) {
      status
    }
  }
`;
export type DeleteGroupSourceMutationFn = ApolloReactCommon.MutationFunction<
  DeleteGroupSourceMutation,
  DeleteGroupSourceMutationVariables
>;
export type DeleteGroupSourceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteGroupSourceMutation,
    DeleteGroupSourceMutationVariables
  >,
  'mutation'
>;

export const DeleteGroupSourceComponent = (props: DeleteGroupSourceComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteGroupSourceMutation, DeleteGroupSourceMutationVariables>
    mutation={DeleteGroupSourceDocument}
    {...props}
  />
);

export type DeleteGroupSourceProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  DeleteGroupSourceMutation,
  DeleteGroupSourceMutationVariables
> &
  TChildProps;
export function withDeleteGroupSource<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    DeleteGroupSourceMutation,
    DeleteGroupSourceMutationVariables,
    DeleteGroupSourceProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    DeleteGroupSourceMutation,
    DeleteGroupSourceMutationVariables,
    DeleteGroupSourceProps<TChildProps>
  >(DeleteGroupSourceDocument, {
    alias: 'deleteGroupSource',
    ...operationOptions,
  });
}

/**
 * __useDeleteGroupSourceMutation__
 *
 * To run a mutation, you first call `useDeleteGroupSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupSourceMutation, { data, loading, error }] = useDeleteGroupSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGroupSourceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteGroupSourceMutation,
    DeleteGroupSourceMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    DeleteGroupSourceMutation,
    DeleteGroupSourceMutationVariables
  >(DeleteGroupSourceDocument, baseOptions);
}
export type DeleteGroupSourceMutationHookResult = ReturnType<typeof useDeleteGroupSourceMutation>;
export type DeleteGroupSourceMutationResult = ApolloReactCommon.MutationResult<
  DeleteGroupSourceMutation
>;
export type DeleteGroupSourceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteGroupSourceMutation,
  DeleteGroupSourceMutationVariables
>;
export const DeleteManualNotificationDocument = gql`
  mutation DELETE_MANUAL_NOTIFICATION($id: ID!) {
    deleteManualNotification(id: $id) {
      ...ManualNotificationsItem
    }
  }
  ${ManualNotificationsItemFragmentDoc}
`;
export type DeleteManualNotificationMutationFn = ApolloReactCommon.MutationFunction<
  DeleteManualNotificationMutation,
  DeleteManualNotificationMutationVariables
>;
export type DeleteManualNotificationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteManualNotificationMutation,
    DeleteManualNotificationMutationVariables
  >,
  'mutation'
>;

export const DeleteManualNotificationComponent = (
  props: DeleteManualNotificationComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    DeleteManualNotificationMutation,
    DeleteManualNotificationMutationVariables
  >
    mutation={DeleteManualNotificationDocument}
    {...props}
  />
);

export type DeleteManualNotificationProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  DeleteManualNotificationMutation,
  DeleteManualNotificationMutationVariables
> &
  TChildProps;
export function withDeleteManualNotification<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    DeleteManualNotificationMutation,
    DeleteManualNotificationMutationVariables,
    DeleteManualNotificationProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    DeleteManualNotificationMutation,
    DeleteManualNotificationMutationVariables,
    DeleteManualNotificationProps<TChildProps>
  >(DeleteManualNotificationDocument, {
    alias: 'deleteManualNotification',
    ...operationOptions,
  });
}

/**
 * __useDeleteManualNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteManualNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManualNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManualNotificationMutation, { data, loading, error }] = useDeleteManualNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteManualNotificationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteManualNotificationMutation,
    DeleteManualNotificationMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    DeleteManualNotificationMutation,
    DeleteManualNotificationMutationVariables
  >(DeleteManualNotificationDocument, baseOptions);
}
export type DeleteManualNotificationMutationHookResult = ReturnType<
  typeof useDeleteManualNotificationMutation
>;
export type DeleteManualNotificationMutationResult = ApolloReactCommon.MutationResult<
  DeleteManualNotificationMutation
>;
export type DeleteManualNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteManualNotificationMutation,
  DeleteManualNotificationMutationVariables
>;
export const DeleteReactionDocument = gql`
  mutation DELETE_REACTION($content_id: String!) {
    deleteReaction(data: { object_type: content, object_id: $content_id, reaction_type: like }) {
      status
    }
  }
`;
export type DeleteReactionMutationFn = ApolloReactCommon.MutationFunction<
  DeleteReactionMutation,
  DeleteReactionMutationVariables
>;
export type DeleteReactionComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteReactionMutation,
    DeleteReactionMutationVariables
  >,
  'mutation'
>;

export const DeleteReactionComponent = (props: DeleteReactionComponentProps) => (
  <ApolloReactComponents.Mutation<DeleteReactionMutation, DeleteReactionMutationVariables>
    mutation={DeleteReactionDocument}
    {...props}
  />
);

export type DeleteReactionProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  DeleteReactionMutation,
  DeleteReactionMutationVariables
> &
  TChildProps;
export function withDeleteReaction<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    DeleteReactionMutation,
    DeleteReactionMutationVariables,
    DeleteReactionProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    DeleteReactionMutation,
    DeleteReactionMutationVariables,
    DeleteReactionProps<TChildProps>
  >(DeleteReactionDocument, {
    alias: 'deleteReaction',
    ...operationOptions,
  });
}

/**
 * __useDeleteReactionMutation__
 *
 * To run a mutation, you first call `useDeleteReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReactionMutation, { data, loading, error }] = useDeleteReactionMutation({
 *   variables: {
 *      content_id: // value for 'content_id'
 *   },
 * });
 */
export function useDeleteReactionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteReactionMutation,
    DeleteReactionMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<DeleteReactionMutation, DeleteReactionMutationVariables>(
    DeleteReactionDocument,
    baseOptions,
  );
}
export type DeleteReactionMutationHookResult = ReturnType<typeof useDeleteReactionMutation>;
export type DeleteReactionMutationResult = ApolloReactCommon.MutationResult<DeleteReactionMutation>;
export type DeleteReactionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteReactionMutation,
  DeleteReactionMutationVariables
>;
export const DeleteScheduledSharesDocument = gql`
  mutation DELETE_SCHEDULED_SHARES($ids: [ID!]!) {
    deleteScheduledShares(ids: $ids) {
      id
    }
  }
`;
export type DeleteScheduledSharesMutationFn = ApolloReactCommon.MutationFunction<
  DeleteScheduledSharesMutation,
  DeleteScheduledSharesMutationVariables
>;
export type DeleteScheduledSharesComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteScheduledSharesMutation,
    DeleteScheduledSharesMutationVariables
  >,
  'mutation'
>;

export const DeleteScheduledSharesComponent = (props: DeleteScheduledSharesComponentProps) => (
  <ApolloReactComponents.Mutation<
    DeleteScheduledSharesMutation,
    DeleteScheduledSharesMutationVariables
  >
    mutation={DeleteScheduledSharesDocument}
    {...props}
  />
);

export type DeleteScheduledSharesProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  DeleteScheduledSharesMutation,
  DeleteScheduledSharesMutationVariables
> &
  TChildProps;
export function withDeleteScheduledShares<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    DeleteScheduledSharesMutation,
    DeleteScheduledSharesMutationVariables,
    DeleteScheduledSharesProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    DeleteScheduledSharesMutation,
    DeleteScheduledSharesMutationVariables,
    DeleteScheduledSharesProps<TChildProps>
  >(DeleteScheduledSharesDocument, {
    alias: 'deleteScheduledShares',
    ...operationOptions,
  });
}

/**
 * __useDeleteScheduledSharesMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledSharesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledSharesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledSharesMutation, { data, loading, error }] = useDeleteScheduledSharesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteScheduledSharesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteScheduledSharesMutation,
    DeleteScheduledSharesMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    DeleteScheduledSharesMutation,
    DeleteScheduledSharesMutationVariables
  >(DeleteScheduledSharesDocument, baseOptions);
}
export type DeleteScheduledSharesMutationHookResult = ReturnType<
  typeof useDeleteScheduledSharesMutation
>;
export type DeleteScheduledSharesMutationResult = ApolloReactCommon.MutationResult<
  DeleteScheduledSharesMutation
>;
export type DeleteScheduledSharesMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteScheduledSharesMutation,
  DeleteScheduledSharesMutationVariables
>;
export const DeleteSocialConnectionDocument = gql`
  mutation DELETE_SOCIAL_CONNECTION($id: ID!) {
    deleteSocialConnection(id: $id) {
      status
    }
  }
`;
export type DeleteSocialConnectionMutationFn = ApolloReactCommon.MutationFunction<
  DeleteSocialConnectionMutation,
  DeleteSocialConnectionMutationVariables
>;
export type DeleteSocialConnectionComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    DeleteSocialConnectionMutation,
    DeleteSocialConnectionMutationVariables
  >,
  'mutation'
>;

export const DeleteSocialConnectionComponent = (props: DeleteSocialConnectionComponentProps) => (
  <ApolloReactComponents.Mutation<
    DeleteSocialConnectionMutation,
    DeleteSocialConnectionMutationVariables
  >
    mutation={DeleteSocialConnectionDocument}
    {...props}
  />
);

export type DeleteSocialConnectionProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  DeleteSocialConnectionMutation,
  DeleteSocialConnectionMutationVariables
> &
  TChildProps;
export function withDeleteSocialConnection<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    DeleteSocialConnectionMutation,
    DeleteSocialConnectionMutationVariables,
    DeleteSocialConnectionProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    DeleteSocialConnectionMutation,
    DeleteSocialConnectionMutationVariables,
    DeleteSocialConnectionProps<TChildProps>
  >(DeleteSocialConnectionDocument, {
    alias: 'deleteSocialConnection',
    ...operationOptions,
  });
}

/**
 * __useDeleteSocialConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteSocialConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSocialConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSocialConnectionMutation, { data, loading, error }] = useDeleteSocialConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSocialConnectionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteSocialConnectionMutation,
    DeleteSocialConnectionMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    DeleteSocialConnectionMutation,
    DeleteSocialConnectionMutationVariables
  >(DeleteSocialConnectionDocument, baseOptions);
}
export type DeleteSocialConnectionMutationHookResult = ReturnType<
  typeof useDeleteSocialConnectionMutation
>;
export type DeleteSocialConnectionMutationResult = ApolloReactCommon.MutationResult<
  DeleteSocialConnectionMutation
>;
export type DeleteSocialConnectionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteSocialConnectionMutation,
  DeleteSocialConnectionMutationVariables
>;
export const FollowDocument = gql`
  mutation FOLLOW($id: ID!, $key: FeedKey!) {
    follow(id: $id, key: $key) {
      ...UserFeedFollow
    }
  }
  ${UserFeedFollowFragmentDoc}
`;
export type FollowMutationFn = ApolloReactCommon.MutationFunction<
  FollowMutation,
  FollowMutationVariables
>;
export type FollowComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<FollowMutation, FollowMutationVariables>,
  'mutation'
>;

export const FollowComponent = (props: FollowComponentProps) => (
  <ApolloReactComponents.Mutation<FollowMutation, FollowMutationVariables>
    mutation={FollowDocument}
    {...props}
  />
);

export type FollowProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  FollowMutation,
  FollowMutationVariables
> &
  TChildProps;
export function withFollow<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    FollowMutation,
    FollowMutationVariables,
    FollowProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    FollowMutation,
    FollowMutationVariables,
    FollowProps<TChildProps>
  >(FollowDocument, {
    alias: 'follow',
    ...operationOptions,
  });
}

/**
 * __useFollowMutation__
 *
 * To run a mutation, you first call `useFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followMutation, { data, loading, error }] = useFollowMutation({
 *   variables: {
 *      id: // value for 'id'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useFollowMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<FollowMutation, FollowMutationVariables>,
) {
  return ApolloReactHooks.useMutation<FollowMutation, FollowMutationVariables>(
    FollowDocument,
    baseOptions,
  );
}
export type FollowMutationHookResult = ReturnType<typeof useFollowMutation>;
export type FollowMutationResult = ApolloReactCommon.MutationResult<FollowMutation>;
export type FollowMutationOptions = ApolloReactCommon.BaseMutationOptions<
  FollowMutation,
  FollowMutationVariables
>;
export const MarkInboxAsReadDocument = gql`
  mutation MARK_INBOX_AS_READ {
    markInboxAsRead {
      status
    }
  }
`;
export type MarkInboxAsReadMutationFn = ApolloReactCommon.MutationFunction<
  MarkInboxAsReadMutation,
  MarkInboxAsReadMutationVariables
>;
export type MarkInboxAsReadComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    MarkInboxAsReadMutation,
    MarkInboxAsReadMutationVariables
  >,
  'mutation'
>;

export const MarkInboxAsReadComponent = (props: MarkInboxAsReadComponentProps) => (
  <ApolloReactComponents.Mutation<MarkInboxAsReadMutation, MarkInboxAsReadMutationVariables>
    mutation={MarkInboxAsReadDocument}
    {...props}
  />
);

export type MarkInboxAsReadProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  MarkInboxAsReadMutation,
  MarkInboxAsReadMutationVariables
> &
  TChildProps;
export function withMarkInboxAsRead<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    MarkInboxAsReadMutation,
    MarkInboxAsReadMutationVariables,
    MarkInboxAsReadProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    MarkInboxAsReadMutation,
    MarkInboxAsReadMutationVariables,
    MarkInboxAsReadProps<TChildProps>
  >(MarkInboxAsReadDocument, {
    alias: 'markInboxAsRead',
    ...operationOptions,
  });
}

/**
 * __useMarkInboxAsReadMutation__
 *
 * To run a mutation, you first call `useMarkInboxAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInboxAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInboxAsReadMutation, { data, loading, error }] = useMarkInboxAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkInboxAsReadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    MarkInboxAsReadMutation,
    MarkInboxAsReadMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<MarkInboxAsReadMutation, MarkInboxAsReadMutationVariables>(
    MarkInboxAsReadDocument,
    baseOptions,
  );
}
export type MarkInboxAsReadMutationHookResult = ReturnType<typeof useMarkInboxAsReadMutation>;
export type MarkInboxAsReadMutationResult = ApolloReactCommon.MutationResult<
  MarkInboxAsReadMutation
>;
export type MarkInboxAsReadMutationOptions = ApolloReactCommon.BaseMutationOptions<
  MarkInboxAsReadMutation,
  MarkInboxAsReadMutationVariables
>;
export const MarkInboxItemAsReadDocument = gql`
  mutation MARK_INBOX_ITEM_AS_READ($id: ID!) {
    markInboxItemAsRead(id: $id) {
      ...Inbox
    }
  }
  ${InboxFragmentDoc}
`;
export type MarkInboxItemAsReadMutationFn = ApolloReactCommon.MutationFunction<
  MarkInboxItemAsReadMutation,
  MarkInboxItemAsReadMutationVariables
>;
export type MarkInboxItemAsReadComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    MarkInboxItemAsReadMutation,
    MarkInboxItemAsReadMutationVariables
  >,
  'mutation'
>;

export const MarkInboxItemAsReadComponent = (props: MarkInboxItemAsReadComponentProps) => (
  <ApolloReactComponents.Mutation<MarkInboxItemAsReadMutation, MarkInboxItemAsReadMutationVariables>
    mutation={MarkInboxItemAsReadDocument}
    {...props}
  />
);

export type MarkInboxItemAsReadProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  MarkInboxItemAsReadMutation,
  MarkInboxItemAsReadMutationVariables
> &
  TChildProps;
export function withMarkInboxItemAsRead<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    MarkInboxItemAsReadMutation,
    MarkInboxItemAsReadMutationVariables,
    MarkInboxItemAsReadProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    MarkInboxItemAsReadMutation,
    MarkInboxItemAsReadMutationVariables,
    MarkInboxItemAsReadProps<TChildProps>
  >(MarkInboxItemAsReadDocument, {
    alias: 'markInboxItemAsRead',
    ...operationOptions,
  });
}

/**
 * __useMarkInboxItemAsReadMutation__
 *
 * To run a mutation, you first call `useMarkInboxItemAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInboxItemAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInboxItemAsReadMutation, { data, loading, error }] = useMarkInboxItemAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkInboxItemAsReadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    MarkInboxItemAsReadMutation,
    MarkInboxItemAsReadMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    MarkInboxItemAsReadMutation,
    MarkInboxItemAsReadMutationVariables
  >(MarkInboxItemAsReadDocument, baseOptions);
}
export type MarkInboxItemAsReadMutationHookResult = ReturnType<
  typeof useMarkInboxItemAsReadMutation
>;
export type MarkInboxItemAsReadMutationResult = ApolloReactCommon.MutationResult<
  MarkInboxItemAsReadMutation
>;
export type MarkInboxItemAsReadMutationOptions = ApolloReactCommon.BaseMutationOptions<
  MarkInboxItemAsReadMutation,
  MarkInboxItemAsReadMutationVariables
>;
export const ManualPostDocument = gql`
  mutation MANUAL_POST($content: ContentInput!) {
    processContent(process_metadata: true, save: true, content: $content) {
      ...Content
    }
  }
  ${ContentFragmentDoc}
`;
export type ManualPostMutationFn = ApolloReactCommon.MutationFunction<
  ManualPostMutation,
  ManualPostMutationVariables
>;
export type ManualPostComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<ManualPostMutation, ManualPostMutationVariables>,
  'mutation'
>;

export const ManualPostComponent = (props: ManualPostComponentProps) => (
  <ApolloReactComponents.Mutation<ManualPostMutation, ManualPostMutationVariables>
    mutation={ManualPostDocument}
    {...props}
  />
);

export type ManualPostProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  ManualPostMutation,
  ManualPostMutationVariables
> &
  TChildProps;
export function withManualPost<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    ManualPostMutation,
    ManualPostMutationVariables,
    ManualPostProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    ManualPostMutation,
    ManualPostMutationVariables,
    ManualPostProps<TChildProps>
  >(ManualPostDocument, {
    alias: 'manualPost',
    ...operationOptions,
  });
}

/**
 * __useManualPostMutation__
 *
 * To run a mutation, you first call `useManualPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManualPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manualPostMutation, { data, loading, error }] = useManualPostMutation({
 *   variables: {
 *      content: // value for 'content'
 *   },
 * });
 */
export function useManualPostMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ManualPostMutation,
    ManualPostMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<ManualPostMutation, ManualPostMutationVariables>(
    ManualPostDocument,
    baseOptions,
  );
}
export type ManualPostMutationHookResult = ReturnType<typeof useManualPostMutation>;
export type ManualPostMutationResult = ApolloReactCommon.MutationResult<ManualPostMutation>;
export type ManualPostMutationOptions = ApolloReactCommon.BaseMutationOptions<
  ManualPostMutation,
  ManualPostMutationVariables
>;
export const PreviewUrlDocument = gql`
  mutation PREVIEW_URL($url: String!) {
    processContent(
      process_metadata: true
      save: false
      content: {
        group_ids: ["0"]
        content_source_id: "manual"
        content_object: { url: $url, post_type: url }
      }
    ) {
      content_object {
        ...ContentObject
      }
    }
  }
  ${ContentObjectFragmentDoc}
`;
export type PreviewUrlMutationFn = ApolloReactCommon.MutationFunction<
  PreviewUrlMutation,
  PreviewUrlMutationVariables
>;
export type PreviewUrlComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<PreviewUrlMutation, PreviewUrlMutationVariables>,
  'mutation'
>;

export const PreviewUrlComponent = (props: PreviewUrlComponentProps) => (
  <ApolloReactComponents.Mutation<PreviewUrlMutation, PreviewUrlMutationVariables>
    mutation={PreviewUrlDocument}
    {...props}
  />
);

export type PreviewUrlProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  PreviewUrlMutation,
  PreviewUrlMutationVariables
> &
  TChildProps;
export function withPreviewUrl<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    PreviewUrlMutation,
    PreviewUrlMutationVariables,
    PreviewUrlProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    PreviewUrlMutation,
    PreviewUrlMutationVariables,
    PreviewUrlProps<TChildProps>
  >(PreviewUrlDocument, {
    alias: 'previewUrl',
    ...operationOptions,
  });
}

/**
 * __usePreviewUrlMutation__
 *
 * To run a mutation, you first call `usePreviewUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewUrlMutation, { data, loading, error }] = usePreviewUrlMutation({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function usePreviewUrlMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    PreviewUrlMutation,
    PreviewUrlMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<PreviewUrlMutation, PreviewUrlMutationVariables>(
    PreviewUrlDocument,
    baseOptions,
  );
}
export type PreviewUrlMutationHookResult = ReturnType<typeof usePreviewUrlMutation>;
export type PreviewUrlMutationResult = ApolloReactCommon.MutationResult<PreviewUrlMutation>;
export type PreviewUrlMutationOptions = ApolloReactCommon.BaseMutationOptions<
  PreviewUrlMutation,
  PreviewUrlMutationVariables
>;
export const ShareContentDocument = gql`
  mutation SHARE_CONTENT($share_session_id: ID, $content_id: ID!, $items: [ShareContentInput]!) {
    shareContent(share_session_id: $share_session_id, content_id: $content_id, items: $items) {
      results {
        url
        shortened_url {
          short_link
          id
        }
        status
      }
    }
  }
`;
export type ShareContentMutationFn = ApolloReactCommon.MutationFunction<
  ShareContentMutation,
  ShareContentMutationVariables
>;
export type ShareContentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ShareContentMutation,
    ShareContentMutationVariables
  >,
  'mutation'
>;

export const ShareContentComponent = (props: ShareContentComponentProps) => (
  <ApolloReactComponents.Mutation<ShareContentMutation, ShareContentMutationVariables>
    mutation={ShareContentDocument}
    {...props}
  />
);

export type ShareContentProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  ShareContentMutation,
  ShareContentMutationVariables
> &
  TChildProps;
export function withShareContent<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    ShareContentMutation,
    ShareContentMutationVariables,
    ShareContentProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    ShareContentMutation,
    ShareContentMutationVariables,
    ShareContentProps<TChildProps>
  >(ShareContentDocument, {
    alias: 'shareContent',
    ...operationOptions,
  });
}

/**
 * __useShareContentMutation__
 *
 * To run a mutation, you first call `useShareContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareContentMutation, { data, loading, error }] = useShareContentMutation({
 *   variables: {
 *      share_session_id: // value for 'share_session_id'
 *      content_id: // value for 'content_id'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useShareContentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ShareContentMutation,
    ShareContentMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<ShareContentMutation, ShareContentMutationVariables>(
    ShareContentDocument,
    baseOptions,
  );
}
export type ShareContentMutationHookResult = ReturnType<typeof useShareContentMutation>;
export type ShareContentMutationResult = ApolloReactCommon.MutationResult<ShareContentMutation>;
export type ShareContentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  ShareContentMutation,
  ShareContentMutationVariables
>;
export const UnfollowDocument = gql`
  mutation UNFOLLOW($id: ID!, $key: FeedKey!) {
    unfollow(id: $id, key: $key) {
      ...UserFeedFollow
    }
  }
  ${UserFeedFollowFragmentDoc}
`;
export type UnfollowMutationFn = ApolloReactCommon.MutationFunction<
  UnfollowMutation,
  UnfollowMutationVariables
>;
export type UnfollowComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UnfollowMutation, UnfollowMutationVariables>,
  'mutation'
>;

export const UnfollowComponent = (props: UnfollowComponentProps) => (
  <ApolloReactComponents.Mutation<UnfollowMutation, UnfollowMutationVariables>
    mutation={UnfollowDocument}
    {...props}
  />
);

export type UnfollowProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  UnfollowMutation,
  UnfollowMutationVariables
> &
  TChildProps;
export function withUnfollow<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UnfollowMutation,
    UnfollowMutationVariables,
    UnfollowProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UnfollowMutation,
    UnfollowMutationVariables,
    UnfollowProps<TChildProps>
  >(UnfollowDocument, {
    alias: 'unfollow',
    ...operationOptions,
  });
}

/**
 * __useUnfollowMutation__
 *
 * To run a mutation, you first call `useUnfollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowMutation, { data, loading, error }] = useUnfollowMutation({
 *   variables: {
 *      id: // value for 'id'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useUnfollowMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UnfollowMutation, UnfollowMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UnfollowMutation, UnfollowMutationVariables>(
    UnfollowDocument,
    baseOptions,
  );
}
export type UnfollowMutationHookResult = ReturnType<typeof useUnfollowMutation>;
export type UnfollowMutationResult = ApolloReactCommon.MutationResult<UnfollowMutation>;
export type UnfollowMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UnfollowMutation,
  UnfollowMutationVariables
>;
export const UpdateClientDepartmentDocument = gql`
  mutation UPDATE_CLIENT_DEPARTMENT($data: UpdateClientDepartmentInput!) {
    updateClientDepartment(data: $data) {
      ...ClientDepartment
    }
  }
  ${ClientDepartmentFragmentDoc}
`;
export type UpdateClientDepartmentMutationFn = ApolloReactCommon.MutationFunction<
  UpdateClientDepartmentMutation,
  UpdateClientDepartmentMutationVariables
>;
export type UpdateClientDepartmentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateClientDepartmentMutation,
    UpdateClientDepartmentMutationVariables
  >,
  'mutation'
>;

export const UpdateClientDepartmentComponent = (props: UpdateClientDepartmentComponentProps) => (
  <ApolloReactComponents.Mutation<
    UpdateClientDepartmentMutation,
    UpdateClientDepartmentMutationVariables
  >
    mutation={UpdateClientDepartmentDocument}
    {...props}
  />
);

export type UpdateClientDepartmentProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  UpdateClientDepartmentMutation,
  UpdateClientDepartmentMutationVariables
> &
  TChildProps;
export function withUpdateClientDepartment<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UpdateClientDepartmentMutation,
    UpdateClientDepartmentMutationVariables,
    UpdateClientDepartmentProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UpdateClientDepartmentMutation,
    UpdateClientDepartmentMutationVariables,
    UpdateClientDepartmentProps<TChildProps>
  >(UpdateClientDepartmentDocument, {
    alias: 'updateClientDepartment',
    ...operationOptions,
  });
}

/**
 * __useUpdateClientDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateClientDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientDepartmentMutation, { data, loading, error }] = useUpdateClientDepartmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClientDepartmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateClientDepartmentMutation,
    UpdateClientDepartmentMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateClientDepartmentMutation,
    UpdateClientDepartmentMutationVariables
  >(UpdateClientDepartmentDocument, baseOptions);
}
export type UpdateClientDepartmentMutationHookResult = ReturnType<
  typeof useUpdateClientDepartmentMutation
>;
export type UpdateClientDepartmentMutationResult = ApolloReactCommon.MutationResult<
  UpdateClientDepartmentMutation
>;
export type UpdateClientDepartmentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateClientDepartmentMutation,
  UpdateClientDepartmentMutationVariables
>;
export const UpdateClientFollowMappingDocument = gql`
  mutation UPDATE_CLIENT_FOLLOW_MAPPING($data: UpdateClientFollowMappingInput!) {
    updateClientFollowMapping(data: $data) {
      ...ClientFollowMapping
    }
  }
  ${ClientFollowMappingFragmentDoc}
`;
export type UpdateClientFollowMappingMutationFn = ApolloReactCommon.MutationFunction<
  UpdateClientFollowMappingMutation,
  UpdateClientFollowMappingMutationVariables
>;
export type UpdateClientFollowMappingComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateClientFollowMappingMutation,
    UpdateClientFollowMappingMutationVariables
  >,
  'mutation'
>;

export const UpdateClientFollowMappingComponent = (
  props: UpdateClientFollowMappingComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UpdateClientFollowMappingMutation,
    UpdateClientFollowMappingMutationVariables
  >
    mutation={UpdateClientFollowMappingDocument}
    {...props}
  />
);

export type UpdateClientFollowMappingProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  UpdateClientFollowMappingMutation,
  UpdateClientFollowMappingMutationVariables
> &
  TChildProps;
export function withUpdateClientFollowMapping<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UpdateClientFollowMappingMutation,
    UpdateClientFollowMappingMutationVariables,
    UpdateClientFollowMappingProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UpdateClientFollowMappingMutation,
    UpdateClientFollowMappingMutationVariables,
    UpdateClientFollowMappingProps<TChildProps>
  >(UpdateClientFollowMappingDocument, {
    alias: 'updateClientFollowMapping',
    ...operationOptions,
  });
}

/**
 * __useUpdateClientFollowMappingMutation__
 *
 * To run a mutation, you first call `useUpdateClientFollowMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientFollowMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientFollowMappingMutation, { data, loading, error }] = useUpdateClientFollowMappingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClientFollowMappingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateClientFollowMappingMutation,
    UpdateClientFollowMappingMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateClientFollowMappingMutation,
    UpdateClientFollowMappingMutationVariables
  >(UpdateClientFollowMappingDocument, baseOptions);
}
export type UpdateClientFollowMappingMutationHookResult = ReturnType<
  typeof useUpdateClientFollowMappingMutation
>;
export type UpdateClientFollowMappingMutationResult = ApolloReactCommon.MutationResult<
  UpdateClientFollowMappingMutation
>;
export type UpdateClientFollowMappingMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateClientFollowMappingMutation,
  UpdateClientFollowMappingMutationVariables
>;
export const UpdateClientLocationDocument = gql`
  mutation UPDATE_CLIENT_LOCATION($data: UpdateClientLocationInput!) {
    updateClientLocation(data: $data) {
      ...ClientLocation
    }
  }
  ${ClientLocationFragmentDoc}
`;
export type UpdateClientLocationMutationFn = ApolloReactCommon.MutationFunction<
  UpdateClientLocationMutation,
  UpdateClientLocationMutationVariables
>;
export type UpdateClientLocationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateClientLocationMutation,
    UpdateClientLocationMutationVariables
  >,
  'mutation'
>;

export const UpdateClientLocationComponent = (props: UpdateClientLocationComponentProps) => (
  <ApolloReactComponents.Mutation<
    UpdateClientLocationMutation,
    UpdateClientLocationMutationVariables
  >
    mutation={UpdateClientLocationDocument}
    {...props}
  />
);

export type UpdateClientLocationProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  UpdateClientLocationMutation,
  UpdateClientLocationMutationVariables
> &
  TChildProps;
export function withUpdateClientLocation<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UpdateClientLocationMutation,
    UpdateClientLocationMutationVariables,
    UpdateClientLocationProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UpdateClientLocationMutation,
    UpdateClientLocationMutationVariables,
    UpdateClientLocationProps<TChildProps>
  >(UpdateClientLocationDocument, {
    alias: 'updateClientLocation',
    ...operationOptions,
  });
}

/**
 * __useUpdateClientLocationMutation__
 *
 * To run a mutation, you first call `useUpdateClientLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientLocationMutation, { data, loading, error }] = useUpdateClientLocationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClientLocationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateClientLocationMutation,
    UpdateClientLocationMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateClientLocationMutation,
    UpdateClientLocationMutationVariables
  >(UpdateClientLocationDocument, baseOptions);
}
export type UpdateClientLocationMutationHookResult = ReturnType<
  typeof useUpdateClientLocationMutation
>;
export type UpdateClientLocationMutationResult = ApolloReactCommon.MutationResult<
  UpdateClientLocationMutation
>;
export type UpdateClientLocationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateClientLocationMutation,
  UpdateClientLocationMutationVariables
>;
export const UpdateClientUrlParamsDocument = gql`
  mutation UPDATE_CLIENT_URL_PARAMS($data: ClientUrlParamsUpdateInput!) {
    updateClientUrlParams(data: $data) {
      ...ClientUrlParams
    }
  }
  ${ClientUrlParamsFragmentDoc}
`;
export type UpdateClientUrlParamsMutationFn = ApolloReactCommon.MutationFunction<
  UpdateClientUrlParamsMutation,
  UpdateClientUrlParamsMutationVariables
>;
export type UpdateClientUrlParamsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateClientUrlParamsMutation,
    UpdateClientUrlParamsMutationVariables
  >,
  'mutation'
>;

export const UpdateClientUrlParamsComponent = (props: UpdateClientUrlParamsComponentProps) => (
  <ApolloReactComponents.Mutation<
    UpdateClientUrlParamsMutation,
    UpdateClientUrlParamsMutationVariables
  >
    mutation={UpdateClientUrlParamsDocument}
    {...props}
  />
);

export type UpdateClientUrlParamsProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  UpdateClientUrlParamsMutation,
  UpdateClientUrlParamsMutationVariables
> &
  TChildProps;
export function withUpdateClientUrlParams<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UpdateClientUrlParamsMutation,
    UpdateClientUrlParamsMutationVariables,
    UpdateClientUrlParamsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UpdateClientUrlParamsMutation,
    UpdateClientUrlParamsMutationVariables,
    UpdateClientUrlParamsProps<TChildProps>
  >(UpdateClientUrlParamsDocument, {
    alias: 'updateClientUrlParams',
    ...operationOptions,
  });
}

/**
 * __useUpdateClientUrlParamsMutation__
 *
 * To run a mutation, you first call `useUpdateClientUrlParamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientUrlParamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientUrlParamsMutation, { data, loading, error }] = useUpdateClientUrlParamsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClientUrlParamsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateClientUrlParamsMutation,
    UpdateClientUrlParamsMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateClientUrlParamsMutation,
    UpdateClientUrlParamsMutationVariables
  >(UpdateClientUrlParamsDocument, baseOptions);
}
export type UpdateClientUrlParamsMutationHookResult = ReturnType<
  typeof useUpdateClientUrlParamsMutation
>;
export type UpdateClientUrlParamsMutationResult = ApolloReactCommon.MutationResult<
  UpdateClientUrlParamsMutation
>;
export type UpdateClientUrlParamsMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateClientUrlParamsMutation,
  UpdateClientUrlParamsMutationVariables
>;
export const UpdateCommentDocument = gql`
  mutation UPDATE_COMMENT($id: ID!, $comment_text: String!) {
    updateComment(data: { comment_text: $comment_text, id: $id }) {
      ...Comment
    }
  }
  ${CommentFragmentDoc}
`;
export type UpdateCommentMutationFn = ApolloReactCommon.MutationFunction<
  UpdateCommentMutation,
  UpdateCommentMutationVariables
>;
export type UpdateCommentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateCommentMutation,
    UpdateCommentMutationVariables
  >,
  'mutation'
>;

export const UpdateCommentComponent = (props: UpdateCommentComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateCommentMutation, UpdateCommentMutationVariables>
    mutation={UpdateCommentDocument}
    {...props}
  />
);

export type UpdateCommentProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  UpdateCommentMutation,
  UpdateCommentMutationVariables
> &
  TChildProps;
export function withUpdateComment<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UpdateCommentMutation,
    UpdateCommentMutationVariables,
    UpdateCommentProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UpdateCommentMutation,
    UpdateCommentMutationVariables,
    UpdateCommentProps<TChildProps>
  >(UpdateCommentDocument, {
    alias: 'updateComment',
    ...operationOptions,
  });
}

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment_text: // value for 'comment_text'
 *   },
 * });
 */
export function useUpdateCommentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateCommentMutation,
    UpdateCommentMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(
    UpdateCommentDocument,
    baseOptions,
  );
}
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = ApolloReactCommon.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateCommentMutation,
  UpdateCommentMutationVariables
>;
export const UpdateContentApprovalsDocument = gql`
  mutation UPDATE_CONTENT_APPROVALS(
    $content_id: String!
    $group_id_approvals: [GroupIdApprovalInput]!
  ) {
    updateContentApprovals(
      content_id: $content_id
      content_approvals: { group_id_approvals: $group_id_approvals }
    ) {
      content_id
    }
  }
`;
export type UpdateContentApprovalsMutationFn = ApolloReactCommon.MutationFunction<
  UpdateContentApprovalsMutation,
  UpdateContentApprovalsMutationVariables
>;
export type UpdateContentApprovalsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateContentApprovalsMutation,
    UpdateContentApprovalsMutationVariables
  >,
  'mutation'
>;

export const UpdateContentApprovalsComponent = (props: UpdateContentApprovalsComponentProps) => (
  <ApolloReactComponents.Mutation<
    UpdateContentApprovalsMutation,
    UpdateContentApprovalsMutationVariables
  >
    mutation={UpdateContentApprovalsDocument}
    {...props}
  />
);

export type UpdateContentApprovalsProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  UpdateContentApprovalsMutation,
  UpdateContentApprovalsMutationVariables
> &
  TChildProps;
export function withUpdateContentApprovals<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UpdateContentApprovalsMutation,
    UpdateContentApprovalsMutationVariables,
    UpdateContentApprovalsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UpdateContentApprovalsMutation,
    UpdateContentApprovalsMutationVariables,
    UpdateContentApprovalsProps<TChildProps>
  >(UpdateContentApprovalsDocument, {
    alias: 'updateContentApprovals',
    ...operationOptions,
  });
}

/**
 * __useUpdateContentApprovalsMutation__
 *
 * To run a mutation, you first call `useUpdateContentApprovalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentApprovalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentApprovalsMutation, { data, loading, error }] = useUpdateContentApprovalsMutation({
 *   variables: {
 *      content_id: // value for 'content_id'
 *      group_id_approvals: // value for 'group_id_approvals'
 *   },
 * });
 */
export function useUpdateContentApprovalsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateContentApprovalsMutation,
    UpdateContentApprovalsMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateContentApprovalsMutation,
    UpdateContentApprovalsMutationVariables
  >(UpdateContentApprovalsDocument, baseOptions);
}
export type UpdateContentApprovalsMutationHookResult = ReturnType<
  typeof useUpdateContentApprovalsMutation
>;
export type UpdateContentApprovalsMutationResult = ApolloReactCommon.MutationResult<
  UpdateContentApprovalsMutation
>;
export type UpdateContentApprovalsMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateContentApprovalsMutation,
  UpdateContentApprovalsMutationVariables
>;
export const UpdateGroupDocument = gql`
  mutation UPDATE_GROUP($data: UpdateGroupInput!) {
    updateGroup(data: $data) {
      ...Group
    }
  }
  ${GroupFragmentDoc}
`;
export type UpdateGroupMutationFn = ApolloReactCommon.MutationFunction<
  UpdateGroupMutation,
  UpdateGroupMutationVariables
>;
export type UpdateGroupComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<UpdateGroupMutation, UpdateGroupMutationVariables>,
  'mutation'
>;

export const UpdateGroupComponent = (props: UpdateGroupComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateGroupMutation, UpdateGroupMutationVariables>
    mutation={UpdateGroupDocument}
    {...props}
  />
);

export type UpdateGroupProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  UpdateGroupMutation,
  UpdateGroupMutationVariables
> &
  TChildProps;
export function withUpdateGroup<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UpdateGroupMutation,
    UpdateGroupMutationVariables,
    UpdateGroupProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UpdateGroupMutation,
    UpdateGroupMutationVariables,
    UpdateGroupProps<TChildProps>
  >(UpdateGroupDocument, {
    alias: 'updateGroup',
    ...operationOptions,
  });
}

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGroupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateGroupMutation,
    UpdateGroupMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(
    UpdateGroupDocument,
    baseOptions,
  );
}
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = ApolloReactCommon.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateGroupMutation,
  UpdateGroupMutationVariables
>;
export const UpdateGroupSourceDocument = gql`
  mutation UPDATE_GROUP_SOURCE($data: ClientGroupSourceUpdate!) {
    clientGroupSourceUpdate(data: $data) {
      ...ClientGroupSource
    }
  }
  ${ClientGroupSourceFragmentDoc}
`;
export type UpdateGroupSourceMutationFn = ApolloReactCommon.MutationFunction<
  UpdateGroupSourceMutation,
  UpdateGroupSourceMutationVariables
>;
export type UpdateGroupSourceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateGroupSourceMutation,
    UpdateGroupSourceMutationVariables
  >,
  'mutation'
>;

export const UpdateGroupSourceComponent = (props: UpdateGroupSourceComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateGroupSourceMutation, UpdateGroupSourceMutationVariables>
    mutation={UpdateGroupSourceDocument}
    {...props}
  />
);

export type UpdateGroupSourceProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  UpdateGroupSourceMutation,
  UpdateGroupSourceMutationVariables
> &
  TChildProps;
export function withUpdateGroupSource<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UpdateGroupSourceMutation,
    UpdateGroupSourceMutationVariables,
    UpdateGroupSourceProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UpdateGroupSourceMutation,
    UpdateGroupSourceMutationVariables,
    UpdateGroupSourceProps<TChildProps>
  >(UpdateGroupSourceDocument, {
    alias: 'updateGroupSource',
    ...operationOptions,
  });
}

/**
 * __useUpdateGroupSourceMutation__
 *
 * To run a mutation, you first call `useUpdateGroupSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupSourceMutation, { data, loading, error }] = useUpdateGroupSourceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGroupSourceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateGroupSourceMutation,
    UpdateGroupSourceMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateGroupSourceMutation,
    UpdateGroupSourceMutationVariables
  >(UpdateGroupSourceDocument, baseOptions);
}
export type UpdateGroupSourceMutationHookResult = ReturnType<typeof useUpdateGroupSourceMutation>;
export type UpdateGroupSourceMutationResult = ApolloReactCommon.MutationResult<
  UpdateGroupSourceMutation
>;
export type UpdateGroupSourceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateGroupSourceMutation,
  UpdateGroupSourceMutationVariables
>;
export const UpdateManualNotificationDocument = gql`
  mutation UPDATE_MANUAL_NOTIFICATION($data: ManualNotificationsItemUpdateInput!) {
    updateManualNotification(data: $data) {
      ...ManualNotificationsItem
    }
  }
  ${ManualNotificationsItemFragmentDoc}
`;
export type UpdateManualNotificationMutationFn = ApolloReactCommon.MutationFunction<
  UpdateManualNotificationMutation,
  UpdateManualNotificationMutationVariables
>;
export type UpdateManualNotificationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateManualNotificationMutation,
    UpdateManualNotificationMutationVariables
  >,
  'mutation'
>;

export const UpdateManualNotificationComponent = (
  props: UpdateManualNotificationComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UpdateManualNotificationMutation,
    UpdateManualNotificationMutationVariables
  >
    mutation={UpdateManualNotificationDocument}
    {...props}
  />
);

export type UpdateManualNotificationProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  UpdateManualNotificationMutation,
  UpdateManualNotificationMutationVariables
> &
  TChildProps;
export function withUpdateManualNotification<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UpdateManualNotificationMutation,
    UpdateManualNotificationMutationVariables,
    UpdateManualNotificationProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UpdateManualNotificationMutation,
    UpdateManualNotificationMutationVariables,
    UpdateManualNotificationProps<TChildProps>
  >(UpdateManualNotificationDocument, {
    alias: 'updateManualNotification',
    ...operationOptions,
  });
}

/**
 * __useUpdateManualNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateManualNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManualNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManualNotificationMutation, { data, loading, error }] = useUpdateManualNotificationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateManualNotificationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateManualNotificationMutation,
    UpdateManualNotificationMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateManualNotificationMutation,
    UpdateManualNotificationMutationVariables
  >(UpdateManualNotificationDocument, baseOptions);
}
export type UpdateManualNotificationMutationHookResult = ReturnType<
  typeof useUpdateManualNotificationMutation
>;
export type UpdateManualNotificationMutationResult = ApolloReactCommon.MutationResult<
  UpdateManualNotificationMutation
>;
export type UpdateManualNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateManualNotificationMutation,
  UpdateManualNotificationMutationVariables
>;
export const UpdateScheduledSharesDocument = gql`
  mutation UPDATE_SCHEDULED_SHARES($data: ScheduledShareContentInput!) {
    updateScheduledShares(data: $data) {
      ...ScheduledShareItem
    }
  }
  ${ScheduledShareItemFragmentDoc}
`;
export type UpdateScheduledSharesMutationFn = ApolloReactCommon.MutationFunction<
  UpdateScheduledSharesMutation,
  UpdateScheduledSharesMutationVariables
>;
export type UpdateScheduledSharesComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateScheduledSharesMutation,
    UpdateScheduledSharesMutationVariables
  >,
  'mutation'
>;

export const UpdateScheduledSharesComponent = (props: UpdateScheduledSharesComponentProps) => (
  <ApolloReactComponents.Mutation<
    UpdateScheduledSharesMutation,
    UpdateScheduledSharesMutationVariables
  >
    mutation={UpdateScheduledSharesDocument}
    {...props}
  />
);

export type UpdateScheduledSharesProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  UpdateScheduledSharesMutation,
  UpdateScheduledSharesMutationVariables
> &
  TChildProps;
export function withUpdateScheduledShares<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UpdateScheduledSharesMutation,
    UpdateScheduledSharesMutationVariables,
    UpdateScheduledSharesProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UpdateScheduledSharesMutation,
    UpdateScheduledSharesMutationVariables,
    UpdateScheduledSharesProps<TChildProps>
  >(UpdateScheduledSharesDocument, {
    alias: 'updateScheduledShares',
    ...operationOptions,
  });
}

/**
 * __useUpdateScheduledSharesMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledSharesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledSharesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledSharesMutation, { data, loading, error }] = useUpdateScheduledSharesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateScheduledSharesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateScheduledSharesMutation,
    UpdateScheduledSharesMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateScheduledSharesMutation,
    UpdateScheduledSharesMutationVariables
  >(UpdateScheduledSharesDocument, baseOptions);
}
export type UpdateScheduledSharesMutationHookResult = ReturnType<
  typeof useUpdateScheduledSharesMutation
>;
export type UpdateScheduledSharesMutationResult = ApolloReactCommon.MutationResult<
  UpdateScheduledSharesMutation
>;
export type UpdateScheduledSharesMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateScheduledSharesMutation,
  UpdateScheduledSharesMutationVariables
>;
export const UpdateUserProfileDocument = gql`
  mutation UPDATE_USER_PROFILE($data: UserProfileInput!) {
    updateUserProfile(data: $data) {
      ...UserProfile
    }
  }
  ${UserProfileFragmentDoc}
`;
export type UpdateUserProfileMutationFn = ApolloReactCommon.MutationFunction<
  UpdateUserProfileMutation,
  UpdateUserProfileMutationVariables
>;
export type UpdateUserProfileComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateUserProfileMutation,
    UpdateUserProfileMutationVariables
  >,
  'mutation'
>;

export const UpdateUserProfileComponent = (props: UpdateUserProfileComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>
    mutation={UpdateUserProfileDocument}
    {...props}
  />
);

export type UpdateUserProfileProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  UpdateUserProfileMutation,
  UpdateUserProfileMutationVariables
> &
  TChildProps;
export function withUpdateUserProfile<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UpdateUserProfileMutation,
    UpdateUserProfileMutationVariables,
    UpdateUserProfileProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UpdateUserProfileMutation,
    UpdateUserProfileMutationVariables,
    UpdateUserProfileProps<TChildProps>
  >(UpdateUserProfileDocument, {
    alias: 'updateUserProfile',
    ...operationOptions,
  });
}

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateUserProfileMutation,
    UpdateUserProfileMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateUserProfileMutation,
    UpdateUserProfileMutationVariables
  >(UpdateUserProfileDocument, baseOptions);
}
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = ApolloReactCommon.MutationResult<
  UpdateUserProfileMutation
>;
export type UpdateUserProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateUserProfileMutation,
  UpdateUserProfileMutationVariables
>;
export const UpdateUserSegmentDocument = gql`
  mutation UPDATE_USER_SEGMENT($data: UpdateUserSegmentInput!) {
    updateUserSegment(data: $data) {
      ...UserSegment
    }
  }
  ${UserSegmentFragmentDoc}
`;
export type UpdateUserSegmentMutationFn = ApolloReactCommon.MutationFunction<
  UpdateUserSegmentMutation,
  UpdateUserSegmentMutationVariables
>;
export type UpdateUserSegmentComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateUserSegmentMutation,
    UpdateUserSegmentMutationVariables
  >,
  'mutation'
>;

export const UpdateUserSegmentComponent = (props: UpdateUserSegmentComponentProps) => (
  <ApolloReactComponents.Mutation<UpdateUserSegmentMutation, UpdateUserSegmentMutationVariables>
    mutation={UpdateUserSegmentDocument}
    {...props}
  />
);

export type UpdateUserSegmentProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  UpdateUserSegmentMutation,
  UpdateUserSegmentMutationVariables
> &
  TChildProps;
export function withUpdateUserSegment<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UpdateUserSegmentMutation,
    UpdateUserSegmentMutationVariables,
    UpdateUserSegmentProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UpdateUserSegmentMutation,
    UpdateUserSegmentMutationVariables,
    UpdateUserSegmentProps<TChildProps>
  >(UpdateUserSegmentDocument, {
    alias: 'updateUserSegment',
    ...operationOptions,
  });
}

/**
 * __useUpdateUserSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateUserSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSegmentMutation, { data, loading, error }] = useUpdateUserSegmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserSegmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateUserSegmentMutation,
    UpdateUserSegmentMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateUserSegmentMutation,
    UpdateUserSegmentMutationVariables
  >(UpdateUserSegmentDocument, baseOptions);
}
export type UpdateUserSegmentMutationHookResult = ReturnType<typeof useUpdateUserSegmentMutation>;
export type UpdateUserSegmentMutationResult = ApolloReactCommon.MutationResult<
  UpdateUserSegmentMutation
>;
export type UpdateUserSegmentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateUserSegmentMutation,
  UpdateUserSegmentMutationVariables
>;
export const ClientDailyStatsDocument = gql`
  query CLIENT_DAILY_STATS($client_id: ID!, $grouping: StatsGrouping!) {
    clientDailyStats(client_id: $client_id, grouping: $grouping) {
      total_posts
      total_shares
      total_clicks
      total_users
      data {
        posts
        clicks
        shares
        users
        calendar_day
      }
    }
  }
`;
export type ClientDailyStatsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ClientDailyStatsQuery,
    ClientDailyStatsQueryVariables
  >,
  'query'
> &
  ({ variables: ClientDailyStatsQueryVariables; skip?: boolean } | { skip: boolean });

export const ClientDailyStatsComponent = (props: ClientDailyStatsComponentProps) => (
  <ApolloReactComponents.Query<ClientDailyStatsQuery, ClientDailyStatsQueryVariables>
    query={ClientDailyStatsDocument}
    {...props}
  />
);

export type ClientDailyStatsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  ClientDailyStatsQuery,
  ClientDailyStatsQueryVariables
> &
  TChildProps;
export function withClientDailyStats<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    ClientDailyStatsQuery,
    ClientDailyStatsQueryVariables,
    ClientDailyStatsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    ClientDailyStatsQuery,
    ClientDailyStatsQueryVariables,
    ClientDailyStatsProps<TChildProps>
  >(ClientDailyStatsDocument, {
    alias: 'clientDailyStats',
    ...operationOptions,
  });
}

/**
 * __useClientDailyStatsQuery__
 *
 * To run a query within a React component, call `useClientDailyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDailyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDailyStatsQuery({
 *   variables: {
 *      client_id: // value for 'client_id'
 *      grouping: // value for 'grouping'
 *   },
 * });
 */
export function useClientDailyStatsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ClientDailyStatsQuery,
    ClientDailyStatsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<ClientDailyStatsQuery, ClientDailyStatsQueryVariables>(
    ClientDailyStatsDocument,
    baseOptions,
  );
}
export function useClientDailyStatsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ClientDailyStatsQuery,
    ClientDailyStatsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<ClientDailyStatsQuery, ClientDailyStatsQueryVariables>(
    ClientDailyStatsDocument,
    baseOptions,
  );
}
export type ClientDailyStatsQueryHookResult = ReturnType<typeof useClientDailyStatsQuery>;
export type ClientDailyStatsLazyQueryHookResult = ReturnType<typeof useClientDailyStatsLazyQuery>;
export type ClientDailyStatsQueryResult = ApolloReactCommon.QueryResult<
  ClientDailyStatsQuery,
  ClientDailyStatsQueryVariables
>;
export const ClientEngagementStatsDocument = gql`
  query CLIENT_ENGAGEMENT_STATS($client_id: ID!, $grouping: StatsGrouping!, $value: Int!) {
    clientEngagementStats(client_id: $client_id, grouping: $grouping, value: $value) {
      comments
      reactions
      posts
      groups
      users
    }
  }
`;
export type ClientEngagementStatsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ClientEngagementStatsQuery,
    ClientEngagementStatsQueryVariables
  >,
  'query'
> &
  ({ variables: ClientEngagementStatsQueryVariables; skip?: boolean } | { skip: boolean });

export const ClientEngagementStatsComponent = (props: ClientEngagementStatsComponentProps) => (
  <ApolloReactComponents.Query<ClientEngagementStatsQuery, ClientEngagementStatsQueryVariables>
    query={ClientEngagementStatsDocument}
    {...props}
  />
);

export type ClientEngagementStatsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  ClientEngagementStatsQuery,
  ClientEngagementStatsQueryVariables
> &
  TChildProps;
export function withClientEngagementStats<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    ClientEngagementStatsQuery,
    ClientEngagementStatsQueryVariables,
    ClientEngagementStatsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    ClientEngagementStatsQuery,
    ClientEngagementStatsQueryVariables,
    ClientEngagementStatsProps<TChildProps>
  >(ClientEngagementStatsDocument, {
    alias: 'clientEngagementStats',
    ...operationOptions,
  });
}

/**
 * __useClientEngagementStatsQuery__
 *
 * To run a query within a React component, call `useClientEngagementStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientEngagementStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientEngagementStatsQuery({
 *   variables: {
 *      client_id: // value for 'client_id'
 *      grouping: // value for 'grouping'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useClientEngagementStatsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ClientEngagementStatsQuery,
    ClientEngagementStatsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<ClientEngagementStatsQuery, ClientEngagementStatsQueryVariables>(
    ClientEngagementStatsDocument,
    baseOptions,
  );
}
export function useClientEngagementStatsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ClientEngagementStatsQuery,
    ClientEngagementStatsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    ClientEngagementStatsQuery,
    ClientEngagementStatsQueryVariables
  >(ClientEngagementStatsDocument, baseOptions);
}
export type ClientEngagementStatsQueryHookResult = ReturnType<typeof useClientEngagementStatsQuery>;
export type ClientEngagementStatsLazyQueryHookResult = ReturnType<
  typeof useClientEngagementStatsLazyQuery
>;
export type ClientEngagementStatsQueryResult = ApolloReactCommon.QueryResult<
  ClientEngagementStatsQuery,
  ClientEngagementStatsQueryVariables
>;
export const ClientReachStatsDocument = gql`
  query CLIENT_REACH_STATS($client_id: ID!, $grouping: StatsGrouping!, $value: Int!) {
    clientReachStats(client_id: $client_id, grouping: $grouping, value: $value) {
      reach
      previous_reach
      provider
      profile_identifier
    }
  }
`;
export type ClientReachStatsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ClientReachStatsQuery,
    ClientReachStatsQueryVariables
  >,
  'query'
> &
  ({ variables: ClientReachStatsQueryVariables; skip?: boolean } | { skip: boolean });

export const ClientReachStatsComponent = (props: ClientReachStatsComponentProps) => (
  <ApolloReactComponents.Query<ClientReachStatsQuery, ClientReachStatsQueryVariables>
    query={ClientReachStatsDocument}
    {...props}
  />
);

export type ClientReachStatsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  ClientReachStatsQuery,
  ClientReachStatsQueryVariables
> &
  TChildProps;
export function withClientReachStats<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    ClientReachStatsQuery,
    ClientReachStatsQueryVariables,
    ClientReachStatsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    ClientReachStatsQuery,
    ClientReachStatsQueryVariables,
    ClientReachStatsProps<TChildProps>
  >(ClientReachStatsDocument, {
    alias: 'clientReachStats',
    ...operationOptions,
  });
}

/**
 * __useClientReachStatsQuery__
 *
 * To run a query within a React component, call `useClientReachStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientReachStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientReachStatsQuery({
 *   variables: {
 *      client_id: // value for 'client_id'
 *      grouping: // value for 'grouping'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useClientReachStatsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ClientReachStatsQuery,
    ClientReachStatsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<ClientReachStatsQuery, ClientReachStatsQueryVariables>(
    ClientReachStatsDocument,
    baseOptions,
  );
}
export function useClientReachStatsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ClientReachStatsQuery,
    ClientReachStatsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<ClientReachStatsQuery, ClientReachStatsQueryVariables>(
    ClientReachStatsDocument,
    baseOptions,
  );
}
export type ClientReachStatsQueryHookResult = ReturnType<typeof useClientReachStatsQuery>;
export type ClientReachStatsLazyQueryHookResult = ReturnType<typeof useClientReachStatsLazyQuery>;
export type ClientReachStatsQueryResult = ApolloReactCommon.QueryResult<
  ClientReachStatsQuery,
  ClientReachStatsQueryVariables
>;
export const GetGroupFollowersDocument = gql`
  query GET_GROUP_FOLLOWERS($id: ID!, $limit: Int!) {
    feedFollowing(data: { id: $id, feed: group, limit: $limit }) {
      feed_follows {
        followed_by_user {
          ...PublicUserProfile
        }
      }
      id
      paginate
      count
    }
  }
  ${PublicUserProfileFragmentDoc}
`;
export type GetGroupFollowersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetGroupFollowersQuery,
    GetGroupFollowersQueryVariables
  >,
  'query'
> &
  ({ variables: GetGroupFollowersQueryVariables; skip?: boolean } | { skip: boolean });

export const GetGroupFollowersComponent = (props: GetGroupFollowersComponentProps) => (
  <ApolloReactComponents.Query<GetGroupFollowersQuery, GetGroupFollowersQueryVariables>
    query={GetGroupFollowersDocument}
    {...props}
  />
);

export type GetGroupFollowersProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetGroupFollowersQuery,
  GetGroupFollowersQueryVariables
> &
  TChildProps;
export function withGetGroupFollowers<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetGroupFollowersQuery,
    GetGroupFollowersQueryVariables,
    GetGroupFollowersProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetGroupFollowersQuery,
    GetGroupFollowersQueryVariables,
    GetGroupFollowersProps<TChildProps>
  >(GetGroupFollowersDocument, {
    alias: 'getGroupFollowers',
    ...operationOptions,
  });
}

/**
 * __useGetGroupFollowersQuery__
 *
 * To run a query within a React component, call `useGetGroupFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupFollowersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGroupFollowersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetGroupFollowersQuery,
    GetGroupFollowersQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetGroupFollowersQuery, GetGroupFollowersQueryVariables>(
    GetGroupFollowersDocument,
    baseOptions,
  );
}
export function useGetGroupFollowersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetGroupFollowersQuery,
    GetGroupFollowersQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetGroupFollowersQuery, GetGroupFollowersQueryVariables>(
    GetGroupFollowersDocument,
    baseOptions,
  );
}
export type GetGroupFollowersQueryHookResult = ReturnType<typeof useGetGroupFollowersQuery>;
export type GetGroupFollowersLazyQueryHookResult = ReturnType<typeof useGetGroupFollowersLazyQuery>;
export type GetGroupFollowersQueryResult = ApolloReactCommon.QueryResult<
  GetGroupFollowersQuery,
  GetGroupFollowersQueryVariables
>;
export const GetUserFollowersDocument = gql`
  query GET_USER_FOLLOWERS($id: ID!, $limit: Int!) {
    feedFollowing(data: { id: $id, feed: user, limit: $limit }) {
      feed_follows {
        followed_by_user {
          ...PublicUserProfile
        }
      }
      id
      paginate
      count
    }
  }
  ${PublicUserProfileFragmentDoc}
`;
export type GetUserFollowersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetUserFollowersQuery,
    GetUserFollowersQueryVariables
  >,
  'query'
> &
  ({ variables: GetUserFollowersQueryVariables; skip?: boolean } | { skip: boolean });

export const GetUserFollowersComponent = (props: GetUserFollowersComponentProps) => (
  <ApolloReactComponents.Query<GetUserFollowersQuery, GetUserFollowersQueryVariables>
    query={GetUserFollowersDocument}
    {...props}
  />
);

export type GetUserFollowersProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetUserFollowersQuery,
  GetUserFollowersQueryVariables
> &
  TChildProps;
export function withGetUserFollowers<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetUserFollowersQuery,
    GetUserFollowersQueryVariables,
    GetUserFollowersProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetUserFollowersQuery,
    GetUserFollowersQueryVariables,
    GetUserFollowersProps<TChildProps>
  >(GetUserFollowersDocument, {
    alias: 'getUserFollowers',
    ...operationOptions,
  });
}

/**
 * __useGetUserFollowersQuery__
 *
 * To run a query within a React component, call `useGetUserFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFollowersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserFollowersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetUserFollowersQuery,
    GetUserFollowersQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetUserFollowersQuery, GetUserFollowersQueryVariables>(
    GetUserFollowersDocument,
    baseOptions,
  );
}
export function useGetUserFollowersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetUserFollowersQuery,
    GetUserFollowersQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetUserFollowersQuery, GetUserFollowersQueryVariables>(
    GetUserFollowersDocument,
    baseOptions,
  );
}
export type GetUserFollowersQueryHookResult = ReturnType<typeof useGetUserFollowersQuery>;
export type GetUserFollowersLazyQueryHookResult = ReturnType<typeof useGetUserFollowersLazyQuery>;
export type GetUserFollowersQueryResult = ApolloReactCommon.QueryResult<
  GetUserFollowersQuery,
  GetUserFollowersQueryVariables
>;
export const GetActionsDocument = gql`
  query GET_ACTIONS($limit: Int!) {
    getActions(limit: $limit) {
      id_lt
      results {
        created_at
        id
        user_id
        group_id
        display {
          message
          substitutions {
            actor
            adjective
          }
          urls {
            actor
            adjective
          }
        }
      }
    }
  }
`;
export type GetActionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetActionsQuery, GetActionsQueryVariables>,
  'query'
> &
  ({ variables: GetActionsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetActionsComponent = (props: GetActionsComponentProps) => (
  <ApolloReactComponents.Query<GetActionsQuery, GetActionsQueryVariables>
    query={GetActionsDocument}
    {...props}
  />
);

export type GetActionsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetActionsQuery,
  GetActionsQueryVariables
> &
  TChildProps;
export function withGetActions<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetActionsQuery,
    GetActionsQueryVariables,
    GetActionsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetActionsQuery,
    GetActionsQueryVariables,
    GetActionsProps<TChildProps>
  >(GetActionsDocument, {
    alias: 'getActions',
    ...operationOptions,
  });
}

/**
 * __useGetActionsQuery__
 *
 * To run a query within a React component, call `useGetActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetActionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetActionsQuery, GetActionsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetActionsQuery, GetActionsQueryVariables>(
    GetActionsDocument,
    baseOptions,
  );
}
export function useGetActionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActionsQuery, GetActionsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetActionsQuery, GetActionsQueryVariables>(
    GetActionsDocument,
    baseOptions,
  );
}
export type GetActionsQueryHookResult = ReturnType<typeof useGetActionsQuery>;
export type GetActionsLazyQueryHookResult = ReturnType<typeof useGetActionsLazyQuery>;
export type GetActionsQueryResult = ApolloReactCommon.QueryResult<
  GetActionsQuery,
  GetActionsQueryVariables
>;
export const GetActiveCommentsDocument = gql`
  query GET_ACTIVE_COMMENTS($object_id: ID!, $created_at: Int, $id: ID) {
    getActiveComments(
      data: {
        created_at: $created_at
        id: $id
        object_type: content
        object_id: $object_id
        limit: 3
      }
    ) {
      id
      created_at
      paginate
      count
      comments {
        ...Comment
      }
    }
  }
  ${CommentFragmentDoc}
`;
export type GetActiveCommentsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetActiveCommentsQuery,
    GetActiveCommentsQueryVariables
  >,
  'query'
> &
  ({ variables: GetActiveCommentsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetActiveCommentsComponent = (props: GetActiveCommentsComponentProps) => (
  <ApolloReactComponents.Query<GetActiveCommentsQuery, GetActiveCommentsQueryVariables>
    query={GetActiveCommentsDocument}
    {...props}
  />
);

export type GetActiveCommentsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetActiveCommentsQuery,
  GetActiveCommentsQueryVariables
> &
  TChildProps;
export function withGetActiveComments<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetActiveCommentsQuery,
    GetActiveCommentsQueryVariables,
    GetActiveCommentsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetActiveCommentsQuery,
    GetActiveCommentsQueryVariables,
    GetActiveCommentsProps<TChildProps>
  >(GetActiveCommentsDocument, {
    alias: 'getActiveComments',
    ...operationOptions,
  });
}

/**
 * __useGetActiveCommentsQuery__
 *
 * To run a query within a React component, call `useGetActiveCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCommentsQuery({
 *   variables: {
 *      object_id: // value for 'object_id'
 *      created_at: // value for 'created_at'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetActiveCommentsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetActiveCommentsQuery,
    GetActiveCommentsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetActiveCommentsQuery, GetActiveCommentsQueryVariables>(
    GetActiveCommentsDocument,
    baseOptions,
  );
}
export function useGetActiveCommentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetActiveCommentsQuery,
    GetActiveCommentsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetActiveCommentsQuery, GetActiveCommentsQueryVariables>(
    GetActiveCommentsDocument,
    baseOptions,
  );
}
export type GetActiveCommentsQueryHookResult = ReturnType<typeof useGetActiveCommentsQuery>;
export type GetActiveCommentsLazyQueryHookResult = ReturnType<typeof useGetActiveCommentsLazyQuery>;
export type GetActiveCommentsQueryResult = ApolloReactCommon.QueryResult<
  GetActiveCommentsQuery,
  GetActiveCommentsQueryVariables
>;
export const GetAllClientFollowMappingsDocument = gql`
  query GET_ALL_CLIENT_FOLLOW_MAPPINGS {
    getAllClientFollowMappings(data: {}) {
      client_follow_mappings {
        ...ClientFollowMapping
      }
    }
  }
  ${ClientFollowMappingFragmentDoc}
`;
export type GetAllClientFollowMappingsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetAllClientFollowMappingsQuery,
    GetAllClientFollowMappingsQueryVariables
  >,
  'query'
>;

export const GetAllClientFollowMappingsComponent = (
  props: GetAllClientFollowMappingsComponentProps,
) => (
  <ApolloReactComponents.Query<
    GetAllClientFollowMappingsQuery,
    GetAllClientFollowMappingsQueryVariables
  >
    query={GetAllClientFollowMappingsDocument}
    {...props}
  />
);

export type GetAllClientFollowMappingsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetAllClientFollowMappingsQuery,
  GetAllClientFollowMappingsQueryVariables
> &
  TChildProps;
export function withGetAllClientFollowMappings<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetAllClientFollowMappingsQuery,
    GetAllClientFollowMappingsQueryVariables,
    GetAllClientFollowMappingsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetAllClientFollowMappingsQuery,
    GetAllClientFollowMappingsQueryVariables,
    GetAllClientFollowMappingsProps<TChildProps>
  >(GetAllClientFollowMappingsDocument, {
    alias: 'getAllClientFollowMappings',
    ...operationOptions,
  });
}

/**
 * __useGetAllClientFollowMappingsQuery__
 *
 * To run a query within a React component, call `useGetAllClientFollowMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientFollowMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientFollowMappingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllClientFollowMappingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllClientFollowMappingsQuery,
    GetAllClientFollowMappingsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetAllClientFollowMappingsQuery,
    GetAllClientFollowMappingsQueryVariables
  >(GetAllClientFollowMappingsDocument, baseOptions);
}
export function useGetAllClientFollowMappingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllClientFollowMappingsQuery,
    GetAllClientFollowMappingsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetAllClientFollowMappingsQuery,
    GetAllClientFollowMappingsQueryVariables
  >(GetAllClientFollowMappingsDocument, baseOptions);
}
export type GetAllClientFollowMappingsQueryHookResult = ReturnType<
  typeof useGetAllClientFollowMappingsQuery
>;
export type GetAllClientFollowMappingsLazyQueryHookResult = ReturnType<
  typeof useGetAllClientFollowMappingsLazyQuery
>;
export type GetAllClientFollowMappingsQueryResult = ApolloReactCommon.QueryResult<
  GetAllClientFollowMappingsQuery,
  GetAllClientFollowMappingsQueryVariables
>;
export const GetAllClientUrlParamsDocument = gql`
  query GET_ALL_CLIENT_URL_PARAMS {
    getAllClientUrlParams {
      ...ClientUrlParams
    }
  }
  ${ClientUrlParamsFragmentDoc}
`;
export type GetAllClientUrlParamsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetAllClientUrlParamsQuery,
    GetAllClientUrlParamsQueryVariables
  >,
  'query'
>;

export const GetAllClientUrlParamsComponent = (props: GetAllClientUrlParamsComponentProps) => (
  <ApolloReactComponents.Query<GetAllClientUrlParamsQuery, GetAllClientUrlParamsQueryVariables>
    query={GetAllClientUrlParamsDocument}
    {...props}
  />
);

export type GetAllClientUrlParamsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetAllClientUrlParamsQuery,
  GetAllClientUrlParamsQueryVariables
> &
  TChildProps;
export function withGetAllClientUrlParams<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetAllClientUrlParamsQuery,
    GetAllClientUrlParamsQueryVariables,
    GetAllClientUrlParamsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetAllClientUrlParamsQuery,
    GetAllClientUrlParamsQueryVariables,
    GetAllClientUrlParamsProps<TChildProps>
  >(GetAllClientUrlParamsDocument, {
    alias: 'getAllClientUrlParams',
    ...operationOptions,
  });
}

/**
 * __useGetAllClientUrlParamsQuery__
 *
 * To run a query within a React component, call `useGetAllClientUrlParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientUrlParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientUrlParamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllClientUrlParamsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllClientUrlParamsQuery,
    GetAllClientUrlParamsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetAllClientUrlParamsQuery, GetAllClientUrlParamsQueryVariables>(
    GetAllClientUrlParamsDocument,
    baseOptions,
  );
}
export function useGetAllClientUrlParamsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllClientUrlParamsQuery,
    GetAllClientUrlParamsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetAllClientUrlParamsQuery,
    GetAllClientUrlParamsQueryVariables
  >(GetAllClientUrlParamsDocument, baseOptions);
}
export type GetAllClientUrlParamsQueryHookResult = ReturnType<typeof useGetAllClientUrlParamsQuery>;
export type GetAllClientUrlParamsLazyQueryHookResult = ReturnType<
  typeof useGetAllClientUrlParamsLazyQuery
>;
export type GetAllClientUrlParamsQueryResult = ApolloReactCommon.QueryResult<
  GetAllClientUrlParamsQuery,
  GetAllClientUrlParamsQueryVariables
>;
export const GetAllUserSegmentsDocument = gql`
  query GET_ALL_USER_SEGMENTS {
    getUserSegments {
      ...UserSegment
    }
  }
  ${UserSegmentFragmentDoc}
`;
export type GetAllUserSegmentsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetAllUserSegmentsQuery,
    GetAllUserSegmentsQueryVariables
  >,
  'query'
>;

export const GetAllUserSegmentsComponent = (props: GetAllUserSegmentsComponentProps) => (
  <ApolloReactComponents.Query<GetAllUserSegmentsQuery, GetAllUserSegmentsQueryVariables>
    query={GetAllUserSegmentsDocument}
    {...props}
  />
);

export type GetAllUserSegmentsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetAllUserSegmentsQuery,
  GetAllUserSegmentsQueryVariables
> &
  TChildProps;
export function withGetAllUserSegments<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetAllUserSegmentsQuery,
    GetAllUserSegmentsQueryVariables,
    GetAllUserSegmentsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetAllUserSegmentsQuery,
    GetAllUserSegmentsQueryVariables,
    GetAllUserSegmentsProps<TChildProps>
  >(GetAllUserSegmentsDocument, {
    alias: 'getAllUserSegments',
    ...operationOptions,
  });
}

/**
 * __useGetAllUserSegmentsQuery__
 *
 * To run a query within a React component, call `useGetAllUserSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUserSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUserSegmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUserSegmentsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllUserSegmentsQuery,
    GetAllUserSegmentsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetAllUserSegmentsQuery, GetAllUserSegmentsQueryVariables>(
    GetAllUserSegmentsDocument,
    baseOptions,
  );
}
export function useGetAllUserSegmentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllUserSegmentsQuery,
    GetAllUserSegmentsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetAllUserSegmentsQuery, GetAllUserSegmentsQueryVariables>(
    GetAllUserSegmentsDocument,
    baseOptions,
  );
}
export type GetAllUserSegmentsQueryHookResult = ReturnType<typeof useGetAllUserSegmentsQuery>;
export type GetAllUserSegmentsLazyQueryHookResult = ReturnType<
  typeof useGetAllUserSegmentsLazyQuery
>;
export type GetAllUserSegmentsQueryResult = ApolloReactCommon.QueryResult<
  GetAllUserSegmentsQuery,
  GetAllUserSegmentsQueryVariables
>;
export const GetUserSegmentsByStatusDocument = gql`
  query GET_USER_SEGMENTS_BY_STATUS($segment_status: SegmentStatus!) {
    getUserSegments(segment_status: $segment_status) {
      ...UserSegment
    }
  }
  ${UserSegmentFragmentDoc}
`;
export type GetUserSegmentsByStatusComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetUserSegmentsByStatusQuery,
    GetUserSegmentsByStatusQueryVariables
  >,
  'query'
> &
  ({ variables: GetUserSegmentsByStatusQueryVariables; skip?: boolean } | { skip: boolean });

export const GetUserSegmentsByStatusComponent = (props: GetUserSegmentsByStatusComponentProps) => (
  <ApolloReactComponents.Query<GetUserSegmentsByStatusQuery, GetUserSegmentsByStatusQueryVariables>
    query={GetUserSegmentsByStatusDocument}
    {...props}
  />
);

export type GetUserSegmentsByStatusProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetUserSegmentsByStatusQuery,
  GetUserSegmentsByStatusQueryVariables
> &
  TChildProps;
export function withGetUserSegmentsByStatus<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetUserSegmentsByStatusQuery,
    GetUserSegmentsByStatusQueryVariables,
    GetUserSegmentsByStatusProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetUserSegmentsByStatusQuery,
    GetUserSegmentsByStatusQueryVariables,
    GetUserSegmentsByStatusProps<TChildProps>
  >(GetUserSegmentsByStatusDocument, {
    alias: 'getUserSegmentsByStatus',
    ...operationOptions,
  });
}

/**
 * __useGetUserSegmentsByStatusQuery__
 *
 * To run a query within a React component, call `useGetUserSegmentsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSegmentsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSegmentsByStatusQuery({
 *   variables: {
 *      segment_status: // value for 'segment_status'
 *   },
 * });
 */
export function useGetUserSegmentsByStatusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetUserSegmentsByStatusQuery,
    GetUserSegmentsByStatusQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetUserSegmentsByStatusQuery,
    GetUserSegmentsByStatusQueryVariables
  >(GetUserSegmentsByStatusDocument, baseOptions);
}
export function useGetUserSegmentsByStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetUserSegmentsByStatusQuery,
    GetUserSegmentsByStatusQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetUserSegmentsByStatusQuery,
    GetUserSegmentsByStatusQueryVariables
  >(GetUserSegmentsByStatusDocument, baseOptions);
}
export type GetUserSegmentsByStatusQueryHookResult = ReturnType<
  typeof useGetUserSegmentsByStatusQuery
>;
export type GetUserSegmentsByStatusLazyQueryHookResult = ReturnType<
  typeof useGetUserSegmentsByStatusLazyQuery
>;
export type GetUserSegmentsByStatusQueryResult = ApolloReactCommon.QueryResult<
  GetUserSegmentsByStatusQuery,
  GetUserSegmentsByStatusQueryVariables
>;
export const GetCurrentUserFeedDocument = gql`
  query GET_CURRENT_USER_FEED($user_id: ID!, $feed: FeedKey) {
    getByUserFeed(data: { user_id: $user_id, feed: $feed }) {
      client {
        ...ClientProtected
      }
      user {
        ... on UserProfile {
          ...UserProfile
        }
        ... on PublicUserProfile {
          ...PublicUserProfile
        }
      }
    }
  }
  ${ClientProtectedFragmentDoc}
  ${UserProfileFragmentDoc}
  ${PublicUserProfileFragmentDoc}
`;
export type GetCurrentUserFeedComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetCurrentUserFeedQuery,
    GetCurrentUserFeedQueryVariables
  >,
  'query'
> &
  ({ variables: GetCurrentUserFeedQueryVariables; skip?: boolean } | { skip: boolean });

export const GetCurrentUserFeedComponent = (props: GetCurrentUserFeedComponentProps) => (
  <ApolloReactComponents.Query<GetCurrentUserFeedQuery, GetCurrentUserFeedQueryVariables>
    query={GetCurrentUserFeedDocument}
    {...props}
  />
);

export type GetCurrentUserFeedProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetCurrentUserFeedQuery,
  GetCurrentUserFeedQueryVariables
> &
  TChildProps;
export function withGetCurrentUserFeed<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetCurrentUserFeedQuery,
    GetCurrentUserFeedQueryVariables,
    GetCurrentUserFeedProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetCurrentUserFeedQuery,
    GetCurrentUserFeedQueryVariables,
    GetCurrentUserFeedProps<TChildProps>
  >(GetCurrentUserFeedDocument, {
    alias: 'getCurrentUserFeed',
    ...operationOptions,
  });
}

/**
 * __useGetCurrentUserFeedQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserFeedQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      feed: // value for 'feed'
 *   },
 * });
 */
export function useGetCurrentUserFeedQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetCurrentUserFeedQuery,
    GetCurrentUserFeedQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetCurrentUserFeedQuery, GetCurrentUserFeedQueryVariables>(
    GetCurrentUserFeedDocument,
    baseOptions,
  );
}
export function useGetCurrentUserFeedLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCurrentUserFeedQuery,
    GetCurrentUserFeedQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetCurrentUserFeedQuery, GetCurrentUserFeedQueryVariables>(
    GetCurrentUserFeedDocument,
    baseOptions,
  );
}
export type GetCurrentUserFeedQueryHookResult = ReturnType<typeof useGetCurrentUserFeedQuery>;
export type GetCurrentUserFeedLazyQueryHookResult = ReturnType<
  typeof useGetCurrentUserFeedLazyQuery
>;
export type GetCurrentUserFeedQueryResult = ApolloReactCommon.QueryResult<
  GetCurrentUserFeedQuery,
  GetCurrentUserFeedQueryVariables
>;
export const GetProfileUserFeedDocument = gql`
  query GET_PROFILE_USER_FEED($user_id: ID!, $feed: FeedKey) {
    getByUserFeed(data: { user_id: $user_id, feed: $feed }) {
      user {
        ... on UserProfile {
          ...UserProfile
        }
        ... on PublicUserProfile {
          ...PublicUserProfile
        }
      }
    }
  }
  ${UserProfileFragmentDoc}
  ${PublicUserProfileFragmentDoc}
`;
export type GetProfileUserFeedComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetProfileUserFeedQuery,
    GetProfileUserFeedQueryVariables
  >,
  'query'
> &
  ({ variables: GetProfileUserFeedQueryVariables; skip?: boolean } | { skip: boolean });

export const GetProfileUserFeedComponent = (props: GetProfileUserFeedComponentProps) => (
  <ApolloReactComponents.Query<GetProfileUserFeedQuery, GetProfileUserFeedQueryVariables>
    query={GetProfileUserFeedDocument}
    {...props}
  />
);

export type GetProfileUserFeedProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetProfileUserFeedQuery,
  GetProfileUserFeedQueryVariables
> &
  TChildProps;
export function withGetProfileUserFeed<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetProfileUserFeedQuery,
    GetProfileUserFeedQueryVariables,
    GetProfileUserFeedProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetProfileUserFeedQuery,
    GetProfileUserFeedQueryVariables,
    GetProfileUserFeedProps<TChildProps>
  >(GetProfileUserFeedDocument, {
    alias: 'getProfileUserFeed',
    ...operationOptions,
  });
}

/**
 * __useGetProfileUserFeedQuery__
 *
 * To run a query within a React component, call `useGetProfileUserFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileUserFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileUserFeedQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      feed: // value for 'feed'
 *   },
 * });
 */
export function useGetProfileUserFeedQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetProfileUserFeedQuery,
    GetProfileUserFeedQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetProfileUserFeedQuery, GetProfileUserFeedQueryVariables>(
    GetProfileUserFeedDocument,
    baseOptions,
  );
}
export function useGetProfileUserFeedLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetProfileUserFeedQuery,
    GetProfileUserFeedQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetProfileUserFeedQuery, GetProfileUserFeedQueryVariables>(
    GetProfileUserFeedDocument,
    baseOptions,
  );
}
export type GetProfileUserFeedQueryHookResult = ReturnType<typeof useGetProfileUserFeedQuery>;
export type GetProfileUserFeedLazyQueryHookResult = ReturnType<
  typeof useGetProfileUserFeedLazyQuery
>;
export type GetProfileUserFeedQueryResult = ApolloReactCommon.QueryResult<
  GetProfileUserFeedQuery,
  GetProfileUserFeedQueryVariables
>;
export const GetClientDepartmentsByStatusDocument = gql`
  query GET_CLIENT_DEPARTMENTS_BY_STATUS {
    getClientDepartmentsByStatus(data: { department_status: active }) {
      client_departments {
        ...ClientDepartment
      }
      count
      paginate
      department_status
      title
      id
    }
  }
  ${ClientDepartmentFragmentDoc}
`;
export type GetClientDepartmentsByStatusComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetClientDepartmentsByStatusQuery,
    GetClientDepartmentsByStatusQueryVariables
  >,
  'query'
>;

export const GetClientDepartmentsByStatusComponent = (
  props: GetClientDepartmentsByStatusComponentProps,
) => (
  <ApolloReactComponents.Query<
    GetClientDepartmentsByStatusQuery,
    GetClientDepartmentsByStatusQueryVariables
  >
    query={GetClientDepartmentsByStatusDocument}
    {...props}
  />
);

export type GetClientDepartmentsByStatusProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetClientDepartmentsByStatusQuery,
  GetClientDepartmentsByStatusQueryVariables
> &
  TChildProps;
export function withGetClientDepartmentsByStatus<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetClientDepartmentsByStatusQuery,
    GetClientDepartmentsByStatusQueryVariables,
    GetClientDepartmentsByStatusProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetClientDepartmentsByStatusQuery,
    GetClientDepartmentsByStatusQueryVariables,
    GetClientDepartmentsByStatusProps<TChildProps>
  >(GetClientDepartmentsByStatusDocument, {
    alias: 'getClientDepartmentsByStatus',
    ...operationOptions,
  });
}

/**
 * __useGetClientDepartmentsByStatusQuery__
 *
 * To run a query within a React component, call `useGetClientDepartmentsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientDepartmentsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientDepartmentsByStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientDepartmentsByStatusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetClientDepartmentsByStatusQuery,
    GetClientDepartmentsByStatusQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetClientDepartmentsByStatusQuery,
    GetClientDepartmentsByStatusQueryVariables
  >(GetClientDepartmentsByStatusDocument, baseOptions);
}
export function useGetClientDepartmentsByStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetClientDepartmentsByStatusQuery,
    GetClientDepartmentsByStatusQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetClientDepartmentsByStatusQuery,
    GetClientDepartmentsByStatusQueryVariables
  >(GetClientDepartmentsByStatusDocument, baseOptions);
}
export type GetClientDepartmentsByStatusQueryHookResult = ReturnType<
  typeof useGetClientDepartmentsByStatusQuery
>;
export type GetClientDepartmentsByStatusLazyQueryHookResult = ReturnType<
  typeof useGetClientDepartmentsByStatusLazyQuery
>;
export type GetClientDepartmentsByStatusQueryResult = ApolloReactCommon.QueryResult<
  GetClientDepartmentsByStatusQuery,
  GetClientDepartmentsByStatusQueryVariables
>;
export const GetClientInvitationsByClientDocument = gql`
  query GET_CLIENT_INVITATIONS_BY_CLIENT(
    $count: Boolean
    $id: ID
    $limit: Int
    $created_at: Int
    $invitation_status: ClientInvitationStatus!
  ) {
    getClientInvitationsByClient(
      data: {
        count: $count
        id: $id
        created_at: $created_at
        invitation_status: $invitation_status
        limit: $limit
      }
    ) {
      client_invitations {
        id
        client_id
        email_address
        invitation_status
        created_at
        updated_at
        accepted_at
        accepted_by_user {
          id
          full_name
          email_address
        }
        added_by_user {
          id
          full_name
          email_address
        }
      }
      count
      paginate
      invitation_status
      created_at
      id
      client_id
    }
  }
`;
export type GetClientInvitationsByClientComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetClientInvitationsByClientQuery,
    GetClientInvitationsByClientQueryVariables
  >,
  'query'
> &
  ({ variables: GetClientInvitationsByClientQueryVariables; skip?: boolean } | { skip: boolean });

export const GetClientInvitationsByClientComponent = (
  props: GetClientInvitationsByClientComponentProps,
) => (
  <ApolloReactComponents.Query<
    GetClientInvitationsByClientQuery,
    GetClientInvitationsByClientQueryVariables
  >
    query={GetClientInvitationsByClientDocument}
    {...props}
  />
);

export type GetClientInvitationsByClientProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetClientInvitationsByClientQuery,
  GetClientInvitationsByClientQueryVariables
> &
  TChildProps;
export function withGetClientInvitationsByClient<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetClientInvitationsByClientQuery,
    GetClientInvitationsByClientQueryVariables,
    GetClientInvitationsByClientProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetClientInvitationsByClientQuery,
    GetClientInvitationsByClientQueryVariables,
    GetClientInvitationsByClientProps<TChildProps>
  >(GetClientInvitationsByClientDocument, {
    alias: 'getClientInvitationsByClient',
    ...operationOptions,
  });
}

/**
 * __useGetClientInvitationsByClientQuery__
 *
 * To run a query within a React component, call `useGetClientInvitationsByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientInvitationsByClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientInvitationsByClientQuery({
 *   variables: {
 *      count: // value for 'count'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      created_at: // value for 'created_at'
 *      invitation_status: // value for 'invitation_status'
 *   },
 * });
 */
export function useGetClientInvitationsByClientQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetClientInvitationsByClientQuery,
    GetClientInvitationsByClientQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetClientInvitationsByClientQuery,
    GetClientInvitationsByClientQueryVariables
  >(GetClientInvitationsByClientDocument, baseOptions);
}
export function useGetClientInvitationsByClientLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetClientInvitationsByClientQuery,
    GetClientInvitationsByClientQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetClientInvitationsByClientQuery,
    GetClientInvitationsByClientQueryVariables
  >(GetClientInvitationsByClientDocument, baseOptions);
}
export type GetClientInvitationsByClientQueryHookResult = ReturnType<
  typeof useGetClientInvitationsByClientQuery
>;
export type GetClientInvitationsByClientLazyQueryHookResult = ReturnType<
  typeof useGetClientInvitationsByClientLazyQuery
>;
export type GetClientInvitationsByClientQueryResult = ApolloReactCommon.QueryResult<
  GetClientInvitationsByClientQuery,
  GetClientInvitationsByClientQueryVariables
>;
export const GetClientLocationsByStatusDocument = gql`
  query GET_CLIENT_LOCATIONS_BY_STATUS {
    getClientLocationsByStatus(data: { location_status: active }) {
      client_locations {
        ...ClientLocation
      }
      count
      paginate
      location_status
      title
      id
    }
  }
  ${ClientLocationFragmentDoc}
`;
export type GetClientLocationsByStatusComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetClientLocationsByStatusQuery,
    GetClientLocationsByStatusQueryVariables
  >,
  'query'
>;

export const GetClientLocationsByStatusComponent = (
  props: GetClientLocationsByStatusComponentProps,
) => (
  <ApolloReactComponents.Query<
    GetClientLocationsByStatusQuery,
    GetClientLocationsByStatusQueryVariables
  >
    query={GetClientLocationsByStatusDocument}
    {...props}
  />
);

export type GetClientLocationsByStatusProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetClientLocationsByStatusQuery,
  GetClientLocationsByStatusQueryVariables
> &
  TChildProps;
export function withGetClientLocationsByStatus<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetClientLocationsByStatusQuery,
    GetClientLocationsByStatusQueryVariables,
    GetClientLocationsByStatusProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetClientLocationsByStatusQuery,
    GetClientLocationsByStatusQueryVariables,
    GetClientLocationsByStatusProps<TChildProps>
  >(GetClientLocationsByStatusDocument, {
    alias: 'getClientLocationsByStatus',
    ...operationOptions,
  });
}

/**
 * __useGetClientLocationsByStatusQuery__
 *
 * To run a query within a React component, call `useGetClientLocationsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientLocationsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientLocationsByStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientLocationsByStatusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetClientLocationsByStatusQuery,
    GetClientLocationsByStatusQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetClientLocationsByStatusQuery,
    GetClientLocationsByStatusQueryVariables
  >(GetClientLocationsByStatusDocument, baseOptions);
}
export function useGetClientLocationsByStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetClientLocationsByStatusQuery,
    GetClientLocationsByStatusQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetClientLocationsByStatusQuery,
    GetClientLocationsByStatusQueryVariables
  >(GetClientLocationsByStatusDocument, baseOptions);
}
export type GetClientLocationsByStatusQueryHookResult = ReturnType<
  typeof useGetClientLocationsByStatusQuery
>;
export type GetClientLocationsByStatusLazyQueryHookResult = ReturnType<
  typeof useGetClientLocationsByStatusLazyQuery
>;
export type GetClientLocationsByStatusQueryResult = ApolloReactCommon.QueryResult<
  GetClientLocationsByStatusQuery,
  GetClientLocationsByStatusQueryVariables
>;
export const GetContentDocument = gql`
  query GET_CONTENT($content_id: String!) {
    getContent(content_id: $content_id) {
      ...Content
    }
  }
  ${ContentFragmentDoc}
`;
export type GetContentComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetContentQuery, GetContentQueryVariables>,
  'query'
> &
  ({ variables: GetContentQueryVariables; skip?: boolean } | { skip: boolean });

export const GetContentComponent = (props: GetContentComponentProps) => (
  <ApolloReactComponents.Query<GetContentQuery, GetContentQueryVariables>
    query={GetContentDocument}
    {...props}
  />
);

export type GetContentProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetContentQuery,
  GetContentQueryVariables
> &
  TChildProps;
export function withGetContent<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetContentQuery,
    GetContentQueryVariables,
    GetContentProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetContentQuery,
    GetContentQueryVariables,
    GetContentProps<TChildProps>
  >(GetContentDocument, {
    alias: 'getContent',
    ...operationOptions,
  });
}

/**
 * __useGetContentQuery__
 *
 * To run a query within a React component, call `useGetContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentQuery({
 *   variables: {
 *      content_id: // value for 'content_id'
 *   },
 * });
 */
export function useGetContentQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetContentQuery, GetContentQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetContentQuery, GetContentQueryVariables>(
    GetContentDocument,
    baseOptions,
  );
}
export function useGetContentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContentQuery, GetContentQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetContentQuery, GetContentQueryVariables>(
    GetContentDocument,
    baseOptions,
  );
}
export type GetContentQueryHookResult = ReturnType<typeof useGetContentQuery>;
export type GetContentLazyQueryHookResult = ReturnType<typeof useGetContentLazyQuery>;
export type GetContentQueryResult = ApolloReactCommon.QueryResult<
  GetContentQuery,
  GetContentQueryVariables
>;
export const GetContentUrlParamOptionsDocument = gql`
  query GET_CONTENT_URL_PARAM_OPTIONS($url: String!) {
    getContentUrlParamOptions(url: $url) {
      key
      options
      default_option_value
    }
  }
`;
export type GetContentUrlParamOptionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetContentUrlParamOptionsQuery,
    GetContentUrlParamOptionsQueryVariables
  >,
  'query'
> &
  ({ variables: GetContentUrlParamOptionsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetContentUrlParamOptionsComponent = (
  props: GetContentUrlParamOptionsComponentProps,
) => (
  <ApolloReactComponents.Query<
    GetContentUrlParamOptionsQuery,
    GetContentUrlParamOptionsQueryVariables
  >
    query={GetContentUrlParamOptionsDocument}
    {...props}
  />
);

export type GetContentUrlParamOptionsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetContentUrlParamOptionsQuery,
  GetContentUrlParamOptionsQueryVariables
> &
  TChildProps;
export function withGetContentUrlParamOptions<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetContentUrlParamOptionsQuery,
    GetContentUrlParamOptionsQueryVariables,
    GetContentUrlParamOptionsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetContentUrlParamOptionsQuery,
    GetContentUrlParamOptionsQueryVariables,
    GetContentUrlParamOptionsProps<TChildProps>
  >(GetContentUrlParamOptionsDocument, {
    alias: 'getContentUrlParamOptions',
    ...operationOptions,
  });
}

/**
 * __useGetContentUrlParamOptionsQuery__
 *
 * To run a query within a React component, call `useGetContentUrlParamOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentUrlParamOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentUrlParamOptionsQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetContentUrlParamOptionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetContentUrlParamOptionsQuery,
    GetContentUrlParamOptionsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetContentUrlParamOptionsQuery,
    GetContentUrlParamOptionsQueryVariables
  >(GetContentUrlParamOptionsDocument, baseOptions);
}
export function useGetContentUrlParamOptionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetContentUrlParamOptionsQuery,
    GetContentUrlParamOptionsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetContentUrlParamOptionsQuery,
    GetContentUrlParamOptionsQueryVariables
  >(GetContentUrlParamOptionsDocument, baseOptions);
}
export type GetContentUrlParamOptionsQueryHookResult = ReturnType<
  typeof useGetContentUrlParamOptionsQuery
>;
export type GetContentUrlParamOptionsLazyQueryHookResult = ReturnType<
  typeof useGetContentUrlParamOptionsLazyQuery
>;
export type GetContentUrlParamOptionsQueryResult = ApolloReactCommon.QueryResult<
  GetContentUrlParamOptionsQuery,
  GetContentUrlParamOptionsQueryVariables
>;
export const GetFeedDocument = gql`
  query GET_FEED(
    $key: String!
    $id: String!
    $limit: Int!
    $id_lt: String
    $offset: Int
    $sort: Boolean!
  ) {
    getFeed(key: $key, id: $id, limit: $limit, id_lt: $id_lt, offset: $offset, sort: $sort) {
      id_lt
      offset
      results {
        ...Content
      }
    }
  }
  ${ContentFragmentDoc}
`;
export type GetFeedComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetFeedQuery, GetFeedQueryVariables>,
  'query'
> &
  ({ variables: GetFeedQueryVariables; skip?: boolean } | { skip: boolean });

export const GetFeedComponent = (props: GetFeedComponentProps) => (
  <ApolloReactComponents.Query<GetFeedQuery, GetFeedQueryVariables>
    query={GetFeedDocument}
    {...props}
  />
);

export type GetFeedProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetFeedQuery,
  GetFeedQueryVariables
> &
  TChildProps;
export function withGetFeed<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetFeedQuery,
    GetFeedQueryVariables,
    GetFeedProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetFeedQuery,
    GetFeedQueryVariables,
    GetFeedProps<TChildProps>
  >(GetFeedDocument, {
    alias: 'getFeed',
    ...operationOptions,
  });
}

/**
 * __useGetFeedQuery__
 *
 * To run a query within a React component, call `useGetFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedQuery({
 *   variables: {
 *      key: // value for 'key'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      id_lt: // value for 'id_lt'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetFeedQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeedQuery, GetFeedQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetFeedQuery, GetFeedQueryVariables>(
    GetFeedDocument,
    baseOptions,
  );
}
export function useGetFeedLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedQuery, GetFeedQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetFeedQuery, GetFeedQueryVariables>(
    GetFeedDocument,
    baseOptions,
  );
}
export type GetFeedQueryHookResult = ReturnType<typeof useGetFeedQuery>;
export type GetFeedLazyQueryHookResult = ReturnType<typeof useGetFeedLazyQuery>;
export type GetFeedQueryResult = ApolloReactCommon.QueryResult<GetFeedQuery, GetFeedQueryVariables>;
export const GetFollowedDocument = gql`
  query GET_FOLLOWED($data: PaginatedUserFeedFollowsInput) {
    getPaginatedUserFeedFollows(data: $data) {
      count
      title_lower
      client_id__feed__id
      feed_follows {
        ...UserFeedFollow
      }
    }
  }
  ${UserFeedFollowFragmentDoc}
`;
export type GetFollowedComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetFollowedQuery, GetFollowedQueryVariables>,
  'query'
>;

export const GetFollowedComponent = (props: GetFollowedComponentProps) => (
  <ApolloReactComponents.Query<GetFollowedQuery, GetFollowedQueryVariables>
    query={GetFollowedDocument}
    {...props}
  />
);

export type GetFollowedProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetFollowedQuery,
  GetFollowedQueryVariables
> &
  TChildProps;
export function withGetFollowed<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetFollowedQuery,
    GetFollowedQueryVariables,
    GetFollowedProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetFollowedQuery,
    GetFollowedQueryVariables,
    GetFollowedProps<TChildProps>
  >(GetFollowedDocument, {
    alias: 'getFollowed',
    ...operationOptions,
  });
}

/**
 * __useGetFollowedQuery__
 *
 * To run a query within a React component, call `useGetFollowedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFollowedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFollowedQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetFollowedQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetFollowedQuery, GetFollowedQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetFollowedQuery, GetFollowedQueryVariables>(
    GetFollowedDocument,
    baseOptions,
  );
}
export function useGetFollowedLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFollowedQuery, GetFollowedQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetFollowedQuery, GetFollowedQueryVariables>(
    GetFollowedDocument,
    baseOptions,
  );
}
export type GetFollowedQueryHookResult = ReturnType<typeof useGetFollowedQuery>;
export type GetFollowedLazyQueryHookResult = ReturnType<typeof useGetFollowedLazyQuery>;
export type GetFollowedQueryResult = ApolloReactCommon.QueryResult<
  GetFollowedQuery,
  GetFollowedQueryVariables
>;
export const GetFollowersDocument = gql`
  query GET_FOLLOWERS($data: PaginatedFollowedByUsersInput) {
    getPaginatedFollowedByUsers(data: $data) {
      count
      username
      followed_by_user_id
      followed_by_users {
        ...PublicUserProfile
      }
    }
  }
  ${PublicUserProfileFragmentDoc}
`;
export type GetFollowersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetFollowersQuery, GetFollowersQueryVariables>,
  'query'
>;

export const GetFollowersComponent = (props: GetFollowersComponentProps) => (
  <ApolloReactComponents.Query<GetFollowersQuery, GetFollowersQueryVariables>
    query={GetFollowersDocument}
    {...props}
  />
);

export type GetFollowersProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetFollowersQuery,
  GetFollowersQueryVariables
> &
  TChildProps;
export function withGetFollowers<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetFollowersQuery,
    GetFollowersQueryVariables,
    GetFollowersProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetFollowersQuery,
    GetFollowersQueryVariables,
    GetFollowersProps<TChildProps>
  >(GetFollowersDocument, {
    alias: 'getFollowers',
    ...operationOptions,
  });
}

/**
 * __useGetFollowersQuery__
 *
 * To run a query within a React component, call `useGetFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFollowersQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetFollowersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetFollowersQuery, GetFollowersQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetFollowersQuery, GetFollowersQueryVariables>(
    GetFollowersDocument,
    baseOptions,
  );
}
export function useGetFollowersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetFollowersQuery,
    GetFollowersQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetFollowersQuery, GetFollowersQueryVariables>(
    GetFollowersDocument,
    baseOptions,
  );
}
export type GetFollowersQueryHookResult = ReturnType<typeof useGetFollowersQuery>;
export type GetFollowersLazyQueryHookResult = ReturnType<typeof useGetFollowersLazyQuery>;
export type GetFollowersQueryResult = ApolloReactCommon.QueryResult<
  GetFollowersQuery,
  GetFollowersQueryVariables
>;
export const GetGroupDocument = gql`
  query GET_GROUP($id: ID!) {
    getGroup(id: $id) {
      ...Group
    }
  }
  ${GroupFragmentDoc}
`;
export type GetGroupComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetGroupQuery, GetGroupQueryVariables>,
  'query'
> &
  ({ variables: GetGroupQueryVariables; skip?: boolean } | { skip: boolean });

export const GetGroupComponent = (props: GetGroupComponentProps) => (
  <ApolloReactComponents.Query<GetGroupQuery, GetGroupQueryVariables>
    query={GetGroupDocument}
    {...props}
  />
);

export type GetGroupProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetGroupQuery,
  GetGroupQueryVariables
> &
  TChildProps;
export function withGetGroup<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetGroupQuery,
    GetGroupQueryVariables,
    GetGroupProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetGroupQuery,
    GetGroupQueryVariables,
    GetGroupProps<TChildProps>
  >(GetGroupDocument, {
    alias: 'getGroup',
    ...operationOptions,
  });
}

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetGroupQuery, GetGroupQueryVariables>(
    GetGroupDocument,
    baseOptions,
  );
}
export function useGetGroupLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(
    GetGroupDocument,
    baseOptions,
  );
}
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupQueryResult = ApolloReactCommon.QueryResult<
  GetGroupQuery,
  GetGroupQueryVariables
>;
export const GetGroupColorsDocument = gql`
  query GET_GROUP_COLORS {
    getGroupColors {
      label
      hex
      group_color
    }
  }
`;
export type GetGroupColorsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetGroupColorsQuery, GetGroupColorsQueryVariables>,
  'query'
>;

export const GetGroupColorsComponent = (props: GetGroupColorsComponentProps) => (
  <ApolloReactComponents.Query<GetGroupColorsQuery, GetGroupColorsQueryVariables>
    query={GetGroupColorsDocument}
    {...props}
  />
);

export type GetGroupColorsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetGroupColorsQuery,
  GetGroupColorsQueryVariables
> &
  TChildProps;
export function withGetGroupColors<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetGroupColorsQuery,
    GetGroupColorsQueryVariables,
    GetGroupColorsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetGroupColorsQuery,
    GetGroupColorsQueryVariables,
    GetGroupColorsProps<TChildProps>
  >(GetGroupColorsDocument, {
    alias: 'getGroupColors',
    ...operationOptions,
  });
}

/**
 * __useGetGroupColorsQuery__
 *
 * To run a query within a React component, call `useGetGroupColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupColorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupColorsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetGroupColorsQuery,
    GetGroupColorsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetGroupColorsQuery, GetGroupColorsQueryVariables>(
    GetGroupColorsDocument,
    baseOptions,
  );
}
export function useGetGroupColorsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetGroupColorsQuery,
    GetGroupColorsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetGroupColorsQuery, GetGroupColorsQueryVariables>(
    GetGroupColorsDocument,
    baseOptions,
  );
}
export type GetGroupColorsQueryHookResult = ReturnType<typeof useGetGroupColorsQuery>;
export type GetGroupColorsLazyQueryHookResult = ReturnType<typeof useGetGroupColorsLazyQuery>;
export type GetGroupColorsQueryResult = ApolloReactCommon.QueryResult<
  GetGroupColorsQuery,
  GetGroupColorsQueryVariables
>;
export const GetGroupIconsDocument = gql`
  query GET_GROUP_ICONS {
    getGroupIcons {
      bucket
      file_key
      width
      height
      group_icon
    }
  }
`;
export type GetGroupIconsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetGroupIconsQuery, GetGroupIconsQueryVariables>,
  'query'
>;

export const GetGroupIconsComponent = (props: GetGroupIconsComponentProps) => (
  <ApolloReactComponents.Query<GetGroupIconsQuery, GetGroupIconsQueryVariables>
    query={GetGroupIconsDocument}
    {...props}
  />
);

export type GetGroupIconsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetGroupIconsQuery,
  GetGroupIconsQueryVariables
> &
  TChildProps;
export function withGetGroupIcons<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetGroupIconsQuery,
    GetGroupIconsQueryVariables,
    GetGroupIconsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetGroupIconsQuery,
    GetGroupIconsQueryVariables,
    GetGroupIconsProps<TChildProps>
  >(GetGroupIconsDocument, {
    alias: 'getGroupIcons',
    ...operationOptions,
  });
}

/**
 * __useGetGroupIconsQuery__
 *
 * To run a query within a React component, call `useGetGroupIconsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupIconsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupIconsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupIconsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetGroupIconsQuery, GetGroupIconsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetGroupIconsQuery, GetGroupIconsQueryVariables>(
    GetGroupIconsDocument,
    baseOptions,
  );
}
export function useGetGroupIconsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetGroupIconsQuery,
    GetGroupIconsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetGroupIconsQuery, GetGroupIconsQueryVariables>(
    GetGroupIconsDocument,
    baseOptions,
  );
}
export type GetGroupIconsQueryHookResult = ReturnType<typeof useGetGroupIconsQuery>;
export type GetGroupIconsLazyQueryHookResult = ReturnType<typeof useGetGroupIconsLazyQuery>;
export type GetGroupIconsQueryResult = ApolloReactCommon.QueryResult<
  GetGroupIconsQuery,
  GetGroupIconsQueryVariables
>;
export const GetGroupModeratorsDocument = gql`
  query GET_GROUP_MODERATORS($group_id: ID!) {
    getModeratorsByGroup(group_id: $group_id) {
      ...GroupModerator
    }
  }
  ${GroupModeratorFragmentDoc}
`;
export type GetGroupModeratorsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetGroupModeratorsQuery,
    GetGroupModeratorsQueryVariables
  >,
  'query'
> &
  ({ variables: GetGroupModeratorsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetGroupModeratorsComponent = (props: GetGroupModeratorsComponentProps) => (
  <ApolloReactComponents.Query<GetGroupModeratorsQuery, GetGroupModeratorsQueryVariables>
    query={GetGroupModeratorsDocument}
    {...props}
  />
);

export type GetGroupModeratorsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetGroupModeratorsQuery,
  GetGroupModeratorsQueryVariables
> &
  TChildProps;
export function withGetGroupModerators<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetGroupModeratorsQuery,
    GetGroupModeratorsQueryVariables,
    GetGroupModeratorsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetGroupModeratorsQuery,
    GetGroupModeratorsQueryVariables,
    GetGroupModeratorsProps<TChildProps>
  >(GetGroupModeratorsDocument, {
    alias: 'getGroupModerators',
    ...operationOptions,
  });
}

/**
 * __useGetGroupModeratorsQuery__
 *
 * To run a query within a React component, call `useGetGroupModeratorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupModeratorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupModeratorsQuery({
 *   variables: {
 *      group_id: // value for 'group_id'
 *   },
 * });
 */
export function useGetGroupModeratorsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetGroupModeratorsQuery,
    GetGroupModeratorsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetGroupModeratorsQuery, GetGroupModeratorsQueryVariables>(
    GetGroupModeratorsDocument,
    baseOptions,
  );
}
export function useGetGroupModeratorsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetGroupModeratorsQuery,
    GetGroupModeratorsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetGroupModeratorsQuery, GetGroupModeratorsQueryVariables>(
    GetGroupModeratorsDocument,
    baseOptions,
  );
}
export type GetGroupModeratorsQueryHookResult = ReturnType<typeof useGetGroupModeratorsQuery>;
export type GetGroupModeratorsLazyQueryHookResult = ReturnType<
  typeof useGetGroupModeratorsLazyQuery
>;
export type GetGroupModeratorsQueryResult = ApolloReactCommon.QueryResult<
  GetGroupModeratorsQuery,
  GetGroupModeratorsQueryVariables
>;
export const GetGroupSourcesDocument = gql`
  query GET_GROUP_SOURCES($group_id: ID!) {
    getClientGroupSourcesByGroup(group_id: $group_id) {
      ...ClientGroupSource
    }
  }
  ${ClientGroupSourceFragmentDoc}
`;
export type GetGroupSourcesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetGroupSourcesQuery, GetGroupSourcesQueryVariables>,
  'query'
> &
  ({ variables: GetGroupSourcesQueryVariables; skip?: boolean } | { skip: boolean });

export const GetGroupSourcesComponent = (props: GetGroupSourcesComponentProps) => (
  <ApolloReactComponents.Query<GetGroupSourcesQuery, GetGroupSourcesQueryVariables>
    query={GetGroupSourcesDocument}
    {...props}
  />
);

export type GetGroupSourcesProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetGroupSourcesQuery,
  GetGroupSourcesQueryVariables
> &
  TChildProps;
export function withGetGroupSources<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetGroupSourcesQuery,
    GetGroupSourcesQueryVariables,
    GetGroupSourcesProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetGroupSourcesQuery,
    GetGroupSourcesQueryVariables,
    GetGroupSourcesProps<TChildProps>
  >(GetGroupSourcesDocument, {
    alias: 'getGroupSources',
    ...operationOptions,
  });
}

/**
 * __useGetGroupSourcesQuery__
 *
 * To run a query within a React component, call `useGetGroupSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupSourcesQuery({
 *   variables: {
 *      group_id: // value for 'group_id'
 *   },
 * });
 */
export function useGetGroupSourcesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetGroupSourcesQuery,
    GetGroupSourcesQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetGroupSourcesQuery, GetGroupSourcesQueryVariables>(
    GetGroupSourcesDocument,
    baseOptions,
  );
}
export function useGetGroupSourcesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetGroupSourcesQuery,
    GetGroupSourcesQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetGroupSourcesQuery, GetGroupSourcesQueryVariables>(
    GetGroupSourcesDocument,
    baseOptions,
  );
}
export type GetGroupSourcesQueryHookResult = ReturnType<typeof useGetGroupSourcesQuery>;
export type GetGroupSourcesLazyQueryHookResult = ReturnType<typeof useGetGroupSourcesLazyQuery>;
export type GetGroupSourcesQueryResult = ApolloReactCommon.QueryResult<
  GetGroupSourcesQuery,
  GetGroupSourcesQueryVariables
>;
export const GetInboxItemsDocument = gql`
  query GET_INBOX_ITEMS($limit: Int, $created_at: Int, $id: ID) {
    getInboxItems(data: { limit: $limit, created_at: $created_at, id: $id }) {
      count
      limit
      paginate
      created_at
      id
      inbox {
        ...Inbox
      }
    }
  }
  ${InboxFragmentDoc}
`;
export type GetInboxItemsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetInboxItemsQuery, GetInboxItemsQueryVariables>,
  'query'
>;

export const GetInboxItemsComponent = (props: GetInboxItemsComponentProps) => (
  <ApolloReactComponents.Query<GetInboxItemsQuery, GetInboxItemsQueryVariables>
    query={GetInboxItemsDocument}
    {...props}
  />
);

export type GetInboxItemsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetInboxItemsQuery,
  GetInboxItemsQueryVariables
> &
  TChildProps;
export function withGetInboxItems<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetInboxItemsQuery,
    GetInboxItemsQueryVariables,
    GetInboxItemsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetInboxItemsQuery,
    GetInboxItemsQueryVariables,
    GetInboxItemsProps<TChildProps>
  >(GetInboxItemsDocument, {
    alias: 'getInboxItems',
    ...operationOptions,
  });
}

/**
 * __useGetInboxItemsQuery__
 *
 * To run a query within a React component, call `useGetInboxItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInboxItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInboxItemsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      created_at: // value for 'created_at'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInboxItemsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetInboxItemsQuery, GetInboxItemsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetInboxItemsQuery, GetInboxItemsQueryVariables>(
    GetInboxItemsDocument,
    baseOptions,
  );
}
export function useGetInboxItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetInboxItemsQuery,
    GetInboxItemsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetInboxItemsQuery, GetInboxItemsQueryVariables>(
    GetInboxItemsDocument,
    baseOptions,
  );
}
export type GetInboxItemsQueryHookResult = ReturnType<typeof useGetInboxItemsQuery>;
export type GetInboxItemsLazyQueryHookResult = ReturnType<typeof useGetInboxItemsLazyQuery>;
export type GetInboxItemsQueryResult = ApolloReactCommon.QueryResult<
  GetInboxItemsQuery,
  GetInboxItemsQueryVariables
>;
export const GetLeaderboardConfigsDocument = gql`
  query GET_LEADERBOARD_CONFIGS {
    getLeaderboardConfigs {
      ...LeaderboardConfig
    }
  }
  ${LeaderboardConfigFragmentDoc}
`;
export type GetLeaderboardConfigsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetLeaderboardConfigsQuery,
    GetLeaderboardConfigsQueryVariables
  >,
  'query'
>;

export const GetLeaderboardConfigsComponent = (props: GetLeaderboardConfigsComponentProps) => (
  <ApolloReactComponents.Query<GetLeaderboardConfigsQuery, GetLeaderboardConfigsQueryVariables>
    query={GetLeaderboardConfigsDocument}
    {...props}
  />
);

export type GetLeaderboardConfigsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetLeaderboardConfigsQuery,
  GetLeaderboardConfigsQueryVariables
> &
  TChildProps;
export function withGetLeaderboardConfigs<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetLeaderboardConfigsQuery,
    GetLeaderboardConfigsQueryVariables,
    GetLeaderboardConfigsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetLeaderboardConfigsQuery,
    GetLeaderboardConfigsQueryVariables,
    GetLeaderboardConfigsProps<TChildProps>
  >(GetLeaderboardConfigsDocument, {
    alias: 'getLeaderboardConfigs',
    ...operationOptions,
  });
}

/**
 * __useGetLeaderboardConfigsQuery__
 *
 * To run a query within a React component, call `useGetLeaderboardConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaderboardConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaderboardConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeaderboardConfigsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetLeaderboardConfigsQuery,
    GetLeaderboardConfigsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetLeaderboardConfigsQuery, GetLeaderboardConfigsQueryVariables>(
    GetLeaderboardConfigsDocument,
    baseOptions,
  );
}
export function useGetLeaderboardConfigsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetLeaderboardConfigsQuery,
    GetLeaderboardConfigsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetLeaderboardConfigsQuery,
    GetLeaderboardConfigsQueryVariables
  >(GetLeaderboardConfigsDocument, baseOptions);
}
export type GetLeaderboardConfigsQueryHookResult = ReturnType<typeof useGetLeaderboardConfigsQuery>;
export type GetLeaderboardConfigsLazyQueryHookResult = ReturnType<
  typeof useGetLeaderboardConfigsLazyQuery
>;
export type GetLeaderboardConfigsQueryResult = ApolloReactCommon.QueryResult<
  GetLeaderboardConfigsQuery,
  GetLeaderboardConfigsQueryVariables
>;
export const GetLeaderboardConfigScoresDocument = gql`
  query GET_LEADERBOARD_CONFIG_SCORES($id: ID!) {
    getLeaderboardConfigScores(id: $id) {
      event
      score
    }
  }
`;
export type GetLeaderboardConfigScoresComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetLeaderboardConfigScoresQuery,
    GetLeaderboardConfigScoresQueryVariables
  >,
  'query'
> &
  ({ variables: GetLeaderboardConfigScoresQueryVariables; skip?: boolean } | { skip: boolean });

export const GetLeaderboardConfigScoresComponent = (
  props: GetLeaderboardConfigScoresComponentProps,
) => (
  <ApolloReactComponents.Query<
    GetLeaderboardConfigScoresQuery,
    GetLeaderboardConfigScoresQueryVariables
  >
    query={GetLeaderboardConfigScoresDocument}
    {...props}
  />
);

export type GetLeaderboardConfigScoresProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetLeaderboardConfigScoresQuery,
  GetLeaderboardConfigScoresQueryVariables
> &
  TChildProps;
export function withGetLeaderboardConfigScores<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetLeaderboardConfigScoresQuery,
    GetLeaderboardConfigScoresQueryVariables,
    GetLeaderboardConfigScoresProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetLeaderboardConfigScoresQuery,
    GetLeaderboardConfigScoresQueryVariables,
    GetLeaderboardConfigScoresProps<TChildProps>
  >(GetLeaderboardConfigScoresDocument, {
    alias: 'getLeaderboardConfigScores',
    ...operationOptions,
  });
}

/**
 * __useGetLeaderboardConfigScoresQuery__
 *
 * To run a query within a React component, call `useGetLeaderboardConfigScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaderboardConfigScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaderboardConfigScoresQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLeaderboardConfigScoresQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetLeaderboardConfigScoresQuery,
    GetLeaderboardConfigScoresQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetLeaderboardConfigScoresQuery,
    GetLeaderboardConfigScoresQueryVariables
  >(GetLeaderboardConfigScoresDocument, baseOptions);
}
export function useGetLeaderboardConfigScoresLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetLeaderboardConfigScoresQuery,
    GetLeaderboardConfigScoresQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetLeaderboardConfigScoresQuery,
    GetLeaderboardConfigScoresQueryVariables
  >(GetLeaderboardConfigScoresDocument, baseOptions);
}
export type GetLeaderboardConfigScoresQueryHookResult = ReturnType<
  typeof useGetLeaderboardConfigScoresQuery
>;
export type GetLeaderboardConfigScoresLazyQueryHookResult = ReturnType<
  typeof useGetLeaderboardConfigScoresLazyQuery
>;
export type GetLeaderboardConfigScoresQueryResult = ApolloReactCommon.QueryResult<
  GetLeaderboardConfigScoresQuery,
  GetLeaderboardConfigScoresQueryVariables
>;
export const GetUserLeaderboardsDocument = gql`
  query GET_USER_LEADERBOARDS($user_id: ID) {
    getLeaderboardForUser(user_id: $user_id) {
      leaderboard_configs {
        ...LeaderboardConfig
      }
    }
  }
  ${LeaderboardConfigFragmentDoc}
`;
export type GetUserLeaderboardsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetUserLeaderboardsQuery,
    GetUserLeaderboardsQueryVariables
  >,
  'query'
>;

export const GetUserLeaderboardsComponent = (props: GetUserLeaderboardsComponentProps) => (
  <ApolloReactComponents.Query<GetUserLeaderboardsQuery, GetUserLeaderboardsQueryVariables>
    query={GetUserLeaderboardsDocument}
    {...props}
  />
);

export type GetUserLeaderboardsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetUserLeaderboardsQuery,
  GetUserLeaderboardsQueryVariables
> &
  TChildProps;
export function withGetUserLeaderboards<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetUserLeaderboardsQuery,
    GetUserLeaderboardsQueryVariables,
    GetUserLeaderboardsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetUserLeaderboardsQuery,
    GetUserLeaderboardsQueryVariables,
    GetUserLeaderboardsProps<TChildProps>
  >(GetUserLeaderboardsDocument, {
    alias: 'getUserLeaderboards',
    ...operationOptions,
  });
}

/**
 * __useGetUserLeaderboardsQuery__
 *
 * To run a query within a React component, call `useGetUserLeaderboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLeaderboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLeaderboardsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetUserLeaderboardsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetUserLeaderboardsQuery,
    GetUserLeaderboardsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetUserLeaderboardsQuery, GetUserLeaderboardsQueryVariables>(
    GetUserLeaderboardsDocument,
    baseOptions,
  );
}
export function useGetUserLeaderboardsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetUserLeaderboardsQuery,
    GetUserLeaderboardsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetUserLeaderboardsQuery, GetUserLeaderboardsQueryVariables>(
    GetUserLeaderboardsDocument,
    baseOptions,
  );
}
export type GetUserLeaderboardsQueryHookResult = ReturnType<typeof useGetUserLeaderboardsQuery>;
export type GetUserLeaderboardsLazyQueryHookResult = ReturnType<
  typeof useGetUserLeaderboardsLazyQuery
>;
export type GetUserLeaderboardsQueryResult = ApolloReactCommon.QueryResult<
  GetUserLeaderboardsQuery,
  GetUserLeaderboardsQueryVariables
>;
export const GetUserLeaderboardDocument = gql`
  query GET_USER_LEADERBOARD($user_id: ID, $leaderboard_config_id: ID, $limit: Int) {
    getLeaderboardForUser(
      user_id: $user_id
      leaderboard_config_id: $leaderboard_config_id
      limit: $limit
    ) {
      leaderboard_scores {
        paginate
        leaderboard_config_id
        ranking
        user_id
        items {
          ...LeaderboardScore
        }
      }
      user_score {
        ...LeaderboardScore
      }
    }
  }
  ${LeaderboardScoreFragmentDoc}
`;
export type GetUserLeaderboardComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetUserLeaderboardQuery,
    GetUserLeaderboardQueryVariables
  >,
  'query'
>;

export const GetUserLeaderboardComponent = (props: GetUserLeaderboardComponentProps) => (
  <ApolloReactComponents.Query<GetUserLeaderboardQuery, GetUserLeaderboardQueryVariables>
    query={GetUserLeaderboardDocument}
    {...props}
  />
);

export type GetUserLeaderboardProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetUserLeaderboardQuery,
  GetUserLeaderboardQueryVariables
> &
  TChildProps;
export function withGetUserLeaderboard<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetUserLeaderboardQuery,
    GetUserLeaderboardQueryVariables,
    GetUserLeaderboardProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetUserLeaderboardQuery,
    GetUserLeaderboardQueryVariables,
    GetUserLeaderboardProps<TChildProps>
  >(GetUserLeaderboardDocument, {
    alias: 'getUserLeaderboard',
    ...operationOptions,
  });
}

/**
 * __useGetUserLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetUserLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLeaderboardQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      leaderboard_config_id: // value for 'leaderboard_config_id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserLeaderboardQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetUserLeaderboardQuery,
    GetUserLeaderboardQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetUserLeaderboardQuery, GetUserLeaderboardQueryVariables>(
    GetUserLeaderboardDocument,
    baseOptions,
  );
}
export function useGetUserLeaderboardLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetUserLeaderboardQuery,
    GetUserLeaderboardQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetUserLeaderboardQuery, GetUserLeaderboardQueryVariables>(
    GetUserLeaderboardDocument,
    baseOptions,
  );
}
export type GetUserLeaderboardQueryHookResult = ReturnType<typeof useGetUserLeaderboardQuery>;
export type GetUserLeaderboardLazyQueryHookResult = ReturnType<
  typeof useGetUserLeaderboardLazyQuery
>;
export type GetUserLeaderboardQueryResult = ApolloReactCommon.QueryResult<
  GetUserLeaderboardQuery,
  GetUserLeaderboardQueryVariables
>;
export const GetLeaderboardScoresDocument = gql`
  query GET_LEADERBOARD_SCORES(
    $leaderboard_config_id: ID!
    $limit: Int
    $ranking: Int
    $user_id: ID
  ) {
    getLeaderboardScores(
      leaderboard_config_id: $leaderboard_config_id
      limit: $limit
      ranking: $ranking
      user_id: $user_id
    ) {
      paginate
      leaderboard_config_id
      ranking
      user_id
      items {
        ...LeaderboardScore
      }
    }
  }
  ${LeaderboardScoreFragmentDoc}
`;
export type GetLeaderboardScoresComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetLeaderboardScoresQuery,
    GetLeaderboardScoresQueryVariables
  >,
  'query'
> &
  ({ variables: GetLeaderboardScoresQueryVariables; skip?: boolean } | { skip: boolean });

export const GetLeaderboardScoresComponent = (props: GetLeaderboardScoresComponentProps) => (
  <ApolloReactComponents.Query<GetLeaderboardScoresQuery, GetLeaderboardScoresQueryVariables>
    query={GetLeaderboardScoresDocument}
    {...props}
  />
);

export type GetLeaderboardScoresProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetLeaderboardScoresQuery,
  GetLeaderboardScoresQueryVariables
> &
  TChildProps;
export function withGetLeaderboardScores<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetLeaderboardScoresQuery,
    GetLeaderboardScoresQueryVariables,
    GetLeaderboardScoresProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetLeaderboardScoresQuery,
    GetLeaderboardScoresQueryVariables,
    GetLeaderboardScoresProps<TChildProps>
  >(GetLeaderboardScoresDocument, {
    alias: 'getLeaderboardScores',
    ...operationOptions,
  });
}

/**
 * __useGetLeaderboardScoresQuery__
 *
 * To run a query within a React component, call `useGetLeaderboardScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaderboardScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaderboardScoresQuery({
 *   variables: {
 *      leaderboard_config_id: // value for 'leaderboard_config_id'
 *      limit: // value for 'limit'
 *      ranking: // value for 'ranking'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetLeaderboardScoresQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetLeaderboardScoresQuery,
    GetLeaderboardScoresQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetLeaderboardScoresQuery, GetLeaderboardScoresQueryVariables>(
    GetLeaderboardScoresDocument,
    baseOptions,
  );
}
export function useGetLeaderboardScoresLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetLeaderboardScoresQuery,
    GetLeaderboardScoresQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetLeaderboardScoresQuery,
    GetLeaderboardScoresQueryVariables
  >(GetLeaderboardScoresDocument, baseOptions);
}
export type GetLeaderboardScoresQueryHookResult = ReturnType<typeof useGetLeaderboardScoresQuery>;
export type GetLeaderboardScoresLazyQueryHookResult = ReturnType<
  typeof useGetLeaderboardScoresLazyQuery
>;
export type GetLeaderboardScoresQueryResult = ApolloReactCommon.QueryResult<
  GetLeaderboardScoresQuery,
  GetLeaderboardScoresQueryVariables
>;
export const GetLeaderboardScoreForUserDocument = gql`
  query GET_LEADERBOARD_SCORE_FOR_USER($leaderboard_config_id: ID!, $user_id: ID) {
    getLeaderboardScoreForUser(leaderboard_config_id: $leaderboard_config_id, user_id: $user_id) {
      ...LeaderboardScore
    }
  }
  ${LeaderboardScoreFragmentDoc}
`;
export type GetLeaderboardScoreForUserComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetLeaderboardScoreForUserQuery,
    GetLeaderboardScoreForUserQueryVariables
  >,
  'query'
> &
  ({ variables: GetLeaderboardScoreForUserQueryVariables; skip?: boolean } | { skip: boolean });

export const GetLeaderboardScoreForUserComponent = (
  props: GetLeaderboardScoreForUserComponentProps,
) => (
  <ApolloReactComponents.Query<
    GetLeaderboardScoreForUserQuery,
    GetLeaderboardScoreForUserQueryVariables
  >
    query={GetLeaderboardScoreForUserDocument}
    {...props}
  />
);

export type GetLeaderboardScoreForUserProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetLeaderboardScoreForUserQuery,
  GetLeaderboardScoreForUserQueryVariables
> &
  TChildProps;
export function withGetLeaderboardScoreForUser<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetLeaderboardScoreForUserQuery,
    GetLeaderboardScoreForUserQueryVariables,
    GetLeaderboardScoreForUserProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetLeaderboardScoreForUserQuery,
    GetLeaderboardScoreForUserQueryVariables,
    GetLeaderboardScoreForUserProps<TChildProps>
  >(GetLeaderboardScoreForUserDocument, {
    alias: 'getLeaderboardScoreForUser',
    ...operationOptions,
  });
}

/**
 * __useGetLeaderboardScoreForUserQuery__
 *
 * To run a query within a React component, call `useGetLeaderboardScoreForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaderboardScoreForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaderboardScoreForUserQuery({
 *   variables: {
 *      leaderboard_config_id: // value for 'leaderboard_config_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetLeaderboardScoreForUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetLeaderboardScoreForUserQuery,
    GetLeaderboardScoreForUserQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetLeaderboardScoreForUserQuery,
    GetLeaderboardScoreForUserQueryVariables
  >(GetLeaderboardScoreForUserDocument, baseOptions);
}
export function useGetLeaderboardScoreForUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetLeaderboardScoreForUserQuery,
    GetLeaderboardScoreForUserQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetLeaderboardScoreForUserQuery,
    GetLeaderboardScoreForUserQueryVariables
  >(GetLeaderboardScoreForUserDocument, baseOptions);
}
export type GetLeaderboardScoreForUserQueryHookResult = ReturnType<
  typeof useGetLeaderboardScoreForUserQuery
>;
export type GetLeaderboardScoreForUserLazyQueryHookResult = ReturnType<
  typeof useGetLeaderboardScoreForUserLazyQuery
>;
export type GetLeaderboardScoreForUserQueryResult = ApolloReactCommon.QueryResult<
  GetLeaderboardScoreForUserQuery,
  GetLeaderboardScoreForUserQueryVariables
>;
export const GetManualNotificationsDocument = gql`
  query GET_MANUAL_NOTIFICATIONS($data: ItemsListInput!, $scheduled: Boolean) {
    getManualNotificationItems(data: $data, scheduled: $scheduled) {
      count
      paginate
      created_at
      id
      items {
        ...ManualNotificationsItem
      }
    }
  }
  ${ManualNotificationsItemFragmentDoc}
`;
export type GetManualNotificationsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetManualNotificationsQuery,
    GetManualNotificationsQueryVariables
  >,
  'query'
> &
  ({ variables: GetManualNotificationsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetManualNotificationsComponent = (props: GetManualNotificationsComponentProps) => (
  <ApolloReactComponents.Query<GetManualNotificationsQuery, GetManualNotificationsQueryVariables>
    query={GetManualNotificationsDocument}
    {...props}
  />
);

export type GetManualNotificationsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetManualNotificationsQuery,
  GetManualNotificationsQueryVariables
> &
  TChildProps;
export function withGetManualNotifications<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetManualNotificationsQuery,
    GetManualNotificationsQueryVariables,
    GetManualNotificationsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetManualNotificationsQuery,
    GetManualNotificationsQueryVariables,
    GetManualNotificationsProps<TChildProps>
  >(GetManualNotificationsDocument, {
    alias: 'getManualNotifications',
    ...operationOptions,
  });
}

/**
 * __useGetManualNotificationsQuery__
 *
 * To run a query within a React component, call `useGetManualNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManualNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManualNotificationsQuery({
 *   variables: {
 *      data: // value for 'data'
 *      scheduled: // value for 'scheduled'
 *   },
 * });
 */
export function useGetManualNotificationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetManualNotificationsQuery,
    GetManualNotificationsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetManualNotificationsQuery,
    GetManualNotificationsQueryVariables
  >(GetManualNotificationsDocument, baseOptions);
}
export function useGetManualNotificationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetManualNotificationsQuery,
    GetManualNotificationsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetManualNotificationsQuery,
    GetManualNotificationsQueryVariables
  >(GetManualNotificationsDocument, baseOptions);
}
export type GetManualNotificationsQueryHookResult = ReturnType<
  typeof useGetManualNotificationsQuery
>;
export type GetManualNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetManualNotificationsLazyQuery
>;
export type GetManualNotificationsQueryResult = ApolloReactCommon.QueryResult<
  GetManualNotificationsQuery,
  GetManualNotificationsQueryVariables
>;
export const GetPostedToGroupsDocument = gql`
  query GET_POSTED_TO_GROUPS {
    contextGetPostedToGroups {
      group_id
      score
    }
  }
`;
export type GetPostedToGroupsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetPostedToGroupsQuery,
    GetPostedToGroupsQueryVariables
  >,
  'query'
>;

export const GetPostedToGroupsComponent = (props: GetPostedToGroupsComponentProps) => (
  <ApolloReactComponents.Query<GetPostedToGroupsQuery, GetPostedToGroupsQueryVariables>
    query={GetPostedToGroupsDocument}
    {...props}
  />
);

export type GetPostedToGroupsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetPostedToGroupsQuery,
  GetPostedToGroupsQueryVariables
> &
  TChildProps;
export function withGetPostedToGroups<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetPostedToGroupsQuery,
    GetPostedToGroupsQueryVariables,
    GetPostedToGroupsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetPostedToGroupsQuery,
    GetPostedToGroupsQueryVariables,
    GetPostedToGroupsProps<TChildProps>
  >(GetPostedToGroupsDocument, {
    alias: 'getPostedToGroups',
    ...operationOptions,
  });
}

/**
 * __useGetPostedToGroupsQuery__
 *
 * To run a query within a React component, call `useGetPostedToGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostedToGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostedToGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPostedToGroupsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetPostedToGroupsQuery,
    GetPostedToGroupsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetPostedToGroupsQuery, GetPostedToGroupsQueryVariables>(
    GetPostedToGroupsDocument,
    baseOptions,
  );
}
export function useGetPostedToGroupsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPostedToGroupsQuery,
    GetPostedToGroupsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetPostedToGroupsQuery, GetPostedToGroupsQueryVariables>(
    GetPostedToGroupsDocument,
    baseOptions,
  );
}
export type GetPostedToGroupsQueryHookResult = ReturnType<typeof useGetPostedToGroupsQuery>;
export type GetPostedToGroupsLazyQueryHookResult = ReturnType<typeof useGetPostedToGroupsLazyQuery>;
export type GetPostedToGroupsQueryResult = ApolloReactCommon.QueryResult<
  GetPostedToGroupsQuery,
  GetPostedToGroupsQueryVariables
>;
export const GetProfilesByClientIdFullNameDocument = gql`
  query GET_PROFILES_BY_CLIENT_ID_FULL_NAME($full_name: String!) {
    getProfilesByClientIdFullName(full_name: $full_name, limit: 10) {
      id
      full_name
      job_title
      follower_count
      department_title
      location_title
      email_address
      user_type
      image {
        bucket
        key
        width
        height
      }
    }
  }
`;
export type GetProfilesByClientIdFullNameComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetProfilesByClientIdFullNameQuery,
    GetProfilesByClientIdFullNameQueryVariables
  >,
  'query'
> &
  ({ variables: GetProfilesByClientIdFullNameQueryVariables; skip?: boolean } | { skip: boolean });

export const GetProfilesByClientIdFullNameComponent = (
  props: GetProfilesByClientIdFullNameComponentProps,
) => (
  <ApolloReactComponents.Query<
    GetProfilesByClientIdFullNameQuery,
    GetProfilesByClientIdFullNameQueryVariables
  >
    query={GetProfilesByClientIdFullNameDocument}
    {...props}
  />
);

export type GetProfilesByClientIdFullNameProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetProfilesByClientIdFullNameQuery,
  GetProfilesByClientIdFullNameQueryVariables
> &
  TChildProps;
export function withGetProfilesByClientIdFullName<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetProfilesByClientIdFullNameQuery,
    GetProfilesByClientIdFullNameQueryVariables,
    GetProfilesByClientIdFullNameProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetProfilesByClientIdFullNameQuery,
    GetProfilesByClientIdFullNameQueryVariables,
    GetProfilesByClientIdFullNameProps<TChildProps>
  >(GetProfilesByClientIdFullNameDocument, {
    alias: 'getProfilesByClientIdFullName',
    ...operationOptions,
  });
}

/**
 * __useGetProfilesByClientIdFullNameQuery__
 *
 * To run a query within a React component, call `useGetProfilesByClientIdFullNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilesByClientIdFullNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilesByClientIdFullNameQuery({
 *   variables: {
 *      full_name: // value for 'full_name'
 *   },
 * });
 */
export function useGetProfilesByClientIdFullNameQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetProfilesByClientIdFullNameQuery,
    GetProfilesByClientIdFullNameQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetProfilesByClientIdFullNameQuery,
    GetProfilesByClientIdFullNameQueryVariables
  >(GetProfilesByClientIdFullNameDocument, baseOptions);
}
export function useGetProfilesByClientIdFullNameLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetProfilesByClientIdFullNameQuery,
    GetProfilesByClientIdFullNameQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetProfilesByClientIdFullNameQuery,
    GetProfilesByClientIdFullNameQueryVariables
  >(GetProfilesByClientIdFullNameDocument, baseOptions);
}
export type GetProfilesByClientIdFullNameQueryHookResult = ReturnType<
  typeof useGetProfilesByClientIdFullNameQuery
>;
export type GetProfilesByClientIdFullNameLazyQueryHookResult = ReturnType<
  typeof useGetProfilesByClientIdFullNameLazyQuery
>;
export type GetProfilesByClientIdFullNameQueryResult = ApolloReactCommon.QueryResult<
  GetProfilesByClientIdFullNameQuery,
  GetProfilesByClientIdFullNameQueryVariables
>;
export const GetProfilesByUserStatusDocument = gql`
  query GET_PROFILES_BY_USER_STATUS(
    $user_status: UserStatus!
    $id: ID
    $limit: Int
    $full_name_lower: String
  ) {
    getProfilesByUserStatus(
      data: { user_status: $user_status, id: $id, limit: $limit, full_name_lower: $full_name_lower }
    ) {
      id
      count
      paginate
      full_name_lower
      profiles {
        ...UserProfile
      }
    }
  }
  ${UserProfileFragmentDoc}
`;
export type GetProfilesByUserStatusComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetProfilesByUserStatusQuery,
    GetProfilesByUserStatusQueryVariables
  >,
  'query'
> &
  ({ variables: GetProfilesByUserStatusQueryVariables; skip?: boolean } | { skip: boolean });

export const GetProfilesByUserStatusComponent = (props: GetProfilesByUserStatusComponentProps) => (
  <ApolloReactComponents.Query<GetProfilesByUserStatusQuery, GetProfilesByUserStatusQueryVariables>
    query={GetProfilesByUserStatusDocument}
    {...props}
  />
);

export type GetProfilesByUserStatusProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetProfilesByUserStatusQuery,
  GetProfilesByUserStatusQueryVariables
> &
  TChildProps;
export function withGetProfilesByUserStatus<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetProfilesByUserStatusQuery,
    GetProfilesByUserStatusQueryVariables,
    GetProfilesByUserStatusProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetProfilesByUserStatusQuery,
    GetProfilesByUserStatusQueryVariables,
    GetProfilesByUserStatusProps<TChildProps>
  >(GetProfilesByUserStatusDocument, {
    alias: 'getProfilesByUserStatus',
    ...operationOptions,
  });
}

/**
 * __useGetProfilesByUserStatusQuery__
 *
 * To run a query within a React component, call `useGetProfilesByUserStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilesByUserStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilesByUserStatusQuery({
 *   variables: {
 *      user_status: // value for 'user_status'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      full_name_lower: // value for 'full_name_lower'
 *   },
 * });
 */
export function useGetProfilesByUserStatusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetProfilesByUserStatusQuery,
    GetProfilesByUserStatusQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetProfilesByUserStatusQuery,
    GetProfilesByUserStatusQueryVariables
  >(GetProfilesByUserStatusDocument, baseOptions);
}
export function useGetProfilesByUserStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetProfilesByUserStatusQuery,
    GetProfilesByUserStatusQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetProfilesByUserStatusQuery,
    GetProfilesByUserStatusQueryVariables
  >(GetProfilesByUserStatusDocument, baseOptions);
}
export type GetProfilesByUserStatusQueryHookResult = ReturnType<
  typeof useGetProfilesByUserStatusQuery
>;
export type GetProfilesByUserStatusLazyQueryHookResult = ReturnType<
  typeof useGetProfilesByUserStatusLazyQuery
>;
export type GetProfilesByUserStatusQueryResult = ApolloReactCommon.QueryResult<
  GetProfilesByUserStatusQuery,
  GetProfilesByUserStatusQueryVariables
>;
export const GetReportsDocument = gql`
  query GET_REPORTS {
    getReports {
      ...Report
    }
  }
  ${ReportFragmentDoc}
`;
export type GetReportsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetReportsQuery, GetReportsQueryVariables>,
  'query'
>;

export const GetReportsComponent = (props: GetReportsComponentProps) => (
  <ApolloReactComponents.Query<GetReportsQuery, GetReportsQueryVariables>
    query={GetReportsDocument}
    {...props}
  />
);

export type GetReportsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetReportsQuery,
  GetReportsQueryVariables
> &
  TChildProps;
export function withGetReports<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetReportsQuery,
    GetReportsQueryVariables,
    GetReportsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetReportsQuery,
    GetReportsQueryVariables,
    GetReportsProps<TChildProps>
  >(GetReportsDocument, {
    alias: 'getReports',
    ...operationOptions,
  });
}

/**
 * __useGetReportsQuery__
 *
 * To run a query within a React component, call `useGetReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetReportsQuery, GetReportsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetReportsQuery, GetReportsQueryVariables>(
    GetReportsDocument,
    baseOptions,
  );
}
export function useGetReportsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportsQuery, GetReportsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetReportsQuery, GetReportsQueryVariables>(
    GetReportsDocument,
    baseOptions,
  );
}
export type GetReportsQueryHookResult = ReturnType<typeof useGetReportsQuery>;
export type GetReportsLazyQueryHookResult = ReturnType<typeof useGetReportsLazyQuery>;
export type GetReportsQueryResult = ApolloReactCommon.QueryResult<
  GetReportsQuery,
  GetReportsQueryVariables
>;
export const GetReportRequestsDocument = gql`
  query GET_REPORT_REQUESTS($data: ReportRequestListInput!) {
    getReportRequests(data: $data) {
      report_requests {
        ...ReportRequest
      }
      count
      paginate
    }
  }
  ${ReportRequestFragmentDoc}
`;
export type GetReportRequestsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetReportRequestsQuery,
    GetReportRequestsQueryVariables
  >,
  'query'
> &
  ({ variables: GetReportRequestsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetReportRequestsComponent = (props: GetReportRequestsComponentProps) => (
  <ApolloReactComponents.Query<GetReportRequestsQuery, GetReportRequestsQueryVariables>
    query={GetReportRequestsDocument}
    {...props}
  />
);

export type GetReportRequestsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetReportRequestsQuery,
  GetReportRequestsQueryVariables
> &
  TChildProps;
export function withGetReportRequests<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetReportRequestsQuery,
    GetReportRequestsQueryVariables,
    GetReportRequestsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetReportRequestsQuery,
    GetReportRequestsQueryVariables,
    GetReportRequestsProps<TChildProps>
  >(GetReportRequestsDocument, {
    alias: 'getReportRequests',
    ...operationOptions,
  });
}

/**
 * __useGetReportRequestsQuery__
 *
 * To run a query within a React component, call `useGetReportRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportRequestsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetReportRequestsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetReportRequestsQuery,
    GetReportRequestsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetReportRequestsQuery, GetReportRequestsQueryVariables>(
    GetReportRequestsDocument,
    baseOptions,
  );
}
export function useGetReportRequestsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetReportRequestsQuery,
    GetReportRequestsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetReportRequestsQuery, GetReportRequestsQueryVariables>(
    GetReportRequestsDocument,
    baseOptions,
  );
}
export type GetReportRequestsQueryHookResult = ReturnType<typeof useGetReportRequestsQuery>;
export type GetReportRequestsLazyQueryHookResult = ReturnType<typeof useGetReportRequestsLazyQuery>;
export type GetReportRequestsQueryResult = ApolloReactCommon.QueryResult<
  GetReportRequestsQuery,
  GetReportRequestsQueryVariables
>;
export const GetSharesItemsDocument = gql`
  query GET_SHARES_ITEMS($data: ItemsListInput!, $group_by_session: Boolean, $scheduled: Boolean) {
    getSharesItems(data: $data, group_by_session: $group_by_session, scheduled: $scheduled) {
      count
      paginate
      created_at
      id
      items_by_session {
        ...SharesItem
      }
      items {
        ...SharesItem
      }
    }
  }
  ${SharesItemFragmentDoc}
`;
export type GetSharesItemsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetSharesItemsQuery, GetSharesItemsQueryVariables>,
  'query'
> &
  ({ variables: GetSharesItemsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetSharesItemsComponent = (props: GetSharesItemsComponentProps) => (
  <ApolloReactComponents.Query<GetSharesItemsQuery, GetSharesItemsQueryVariables>
    query={GetSharesItemsDocument}
    {...props}
  />
);

export type GetSharesItemsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetSharesItemsQuery,
  GetSharesItemsQueryVariables
> &
  TChildProps;
export function withGetSharesItems<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetSharesItemsQuery,
    GetSharesItemsQueryVariables,
    GetSharesItemsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetSharesItemsQuery,
    GetSharesItemsQueryVariables,
    GetSharesItemsProps<TChildProps>
  >(GetSharesItemsDocument, {
    alias: 'getSharesItems',
    ...operationOptions,
  });
}

/**
 * __useGetSharesItemsQuery__
 *
 * To run a query within a React component, call `useGetSharesItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharesItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharesItemsQuery({
 *   variables: {
 *      data: // value for 'data'
 *      group_by_session: // value for 'group_by_session'
 *      scheduled: // value for 'scheduled'
 *   },
 * });
 */
export function useGetSharesItemsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetSharesItemsQuery,
    GetSharesItemsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetSharesItemsQuery, GetSharesItemsQueryVariables>(
    GetSharesItemsDocument,
    baseOptions,
  );
}
export function useGetSharesItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetSharesItemsQuery,
    GetSharesItemsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetSharesItemsQuery, GetSharesItemsQueryVariables>(
    GetSharesItemsDocument,
    baseOptions,
  );
}
export type GetSharesItemsQueryHookResult = ReturnType<typeof useGetSharesItemsQuery>;
export type GetSharesItemsLazyQueryHookResult = ReturnType<typeof useGetSharesItemsLazyQuery>;
export type GetSharesItemsQueryResult = ApolloReactCommon.QueryResult<
  GetSharesItemsQuery,
  GetSharesItemsQueryVariables
>;
export const GetSharePreviewInfoDocument = gql`
  query GET_SHARE_PREVIEW_INFO($content_id: String!) {
    getSharePreviewInfo(content_id: $content_id) {
      allowed_counts {
        twitter
        linkedin
        facebook
      }
      suggested_share_time
      suggested_commentary {
        network
        commentary
      }
      shortened_urls {
        email {
          short_link
        }
        direct {
          short_link
        }
      }
    }
  }
`;
export type GetSharePreviewInfoComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetSharePreviewInfoQuery,
    GetSharePreviewInfoQueryVariables
  >,
  'query'
> &
  ({ variables: GetSharePreviewInfoQueryVariables; skip?: boolean } | { skip: boolean });

export const GetSharePreviewInfoComponent = (props: GetSharePreviewInfoComponentProps) => (
  <ApolloReactComponents.Query<GetSharePreviewInfoQuery, GetSharePreviewInfoQueryVariables>
    query={GetSharePreviewInfoDocument}
    {...props}
  />
);

export type GetSharePreviewInfoProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetSharePreviewInfoQuery,
  GetSharePreviewInfoQueryVariables
> &
  TChildProps;
export function withGetSharePreviewInfo<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetSharePreviewInfoQuery,
    GetSharePreviewInfoQueryVariables,
    GetSharePreviewInfoProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetSharePreviewInfoQuery,
    GetSharePreviewInfoQueryVariables,
    GetSharePreviewInfoProps<TChildProps>
  >(GetSharePreviewInfoDocument, {
    alias: 'getSharePreviewInfo',
    ...operationOptions,
  });
}

/**
 * __useGetSharePreviewInfoQuery__
 *
 * To run a query within a React component, call `useGetSharePreviewInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharePreviewInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharePreviewInfoQuery({
 *   variables: {
 *      content_id: // value for 'content_id'
 *   },
 * });
 */
export function useGetSharePreviewInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetSharePreviewInfoQuery,
    GetSharePreviewInfoQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetSharePreviewInfoQuery, GetSharePreviewInfoQueryVariables>(
    GetSharePreviewInfoDocument,
    baseOptions,
  );
}
export function useGetSharePreviewInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetSharePreviewInfoQuery,
    GetSharePreviewInfoQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetSharePreviewInfoQuery, GetSharePreviewInfoQueryVariables>(
    GetSharePreviewInfoDocument,
    baseOptions,
  );
}
export type GetSharePreviewInfoQueryHookResult = ReturnType<typeof useGetSharePreviewInfoQuery>;
export type GetSharePreviewInfoLazyQueryHookResult = ReturnType<
  typeof useGetSharePreviewInfoLazyQuery
>;
export type GetSharePreviewInfoQueryResult = ApolloReactCommon.QueryResult<
  GetSharePreviewInfoQuery,
  GetSharePreviewInfoQueryVariables
>;
export const GetUserClientFollowMappingsDocument = gql`
  query GET_USER_CLIENT_FOLLOW_MAPPINGS {
    getUserClientFollowMappings {
      suggested_groups {
        ...Group
      }
      suggested_users {
        ...PublicUserProfile
      }
    }
  }
  ${GroupFragmentDoc}
  ${PublicUserProfileFragmentDoc}
`;
export type GetUserClientFollowMappingsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetUserClientFollowMappingsQuery,
    GetUserClientFollowMappingsQueryVariables
  >,
  'query'
>;

export const GetUserClientFollowMappingsComponent = (
  props: GetUserClientFollowMappingsComponentProps,
) => (
  <ApolloReactComponents.Query<
    GetUserClientFollowMappingsQuery,
    GetUserClientFollowMappingsQueryVariables
  >
    query={GetUserClientFollowMappingsDocument}
    {...props}
  />
);

export type GetUserClientFollowMappingsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetUserClientFollowMappingsQuery,
  GetUserClientFollowMappingsQueryVariables
> &
  TChildProps;
export function withGetUserClientFollowMappings<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetUserClientFollowMappingsQuery,
    GetUserClientFollowMappingsQueryVariables,
    GetUserClientFollowMappingsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetUserClientFollowMappingsQuery,
    GetUserClientFollowMappingsQueryVariables,
    GetUserClientFollowMappingsProps<TChildProps>
  >(GetUserClientFollowMappingsDocument, {
    alias: 'getUserClientFollowMappings',
    ...operationOptions,
  });
}

/**
 * __useGetUserClientFollowMappingsQuery__
 *
 * To run a query within a React component, call `useGetUserClientFollowMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserClientFollowMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserClientFollowMappingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserClientFollowMappingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetUserClientFollowMappingsQuery,
    GetUserClientFollowMappingsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetUserClientFollowMappingsQuery,
    GetUserClientFollowMappingsQueryVariables
  >(GetUserClientFollowMappingsDocument, baseOptions);
}
export function useGetUserClientFollowMappingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetUserClientFollowMappingsQuery,
    GetUserClientFollowMappingsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetUserClientFollowMappingsQuery,
    GetUserClientFollowMappingsQueryVariables
  >(GetUserClientFollowMappingsDocument, baseOptions);
}
export type GetUserClientFollowMappingsQueryHookResult = ReturnType<
  typeof useGetUserClientFollowMappingsQuery
>;
export type GetUserClientFollowMappingsLazyQueryHookResult = ReturnType<
  typeof useGetUserClientFollowMappingsLazyQuery
>;
export type GetUserClientFollowMappingsQueryResult = ApolloReactCommon.QueryResult<
  GetUserClientFollowMappingsQuery,
  GetUserClientFollowMappingsQueryVariables
>;
export const GetUserSearchesDocument = gql`
  query GET_USER_SEARCHES($limit: Int!) {
    getUserSearches(limit: $limit)
  }
`;
export type GetUserSearchesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetUserSearchesQuery, GetUserSearchesQueryVariables>,
  'query'
> &
  ({ variables: GetUserSearchesQueryVariables; skip?: boolean } | { skip: boolean });

export const GetUserSearchesComponent = (props: GetUserSearchesComponentProps) => (
  <ApolloReactComponents.Query<GetUserSearchesQuery, GetUserSearchesQueryVariables>
    query={GetUserSearchesDocument}
    {...props}
  />
);

export type GetUserSearchesProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetUserSearchesQuery,
  GetUserSearchesQueryVariables
> &
  TChildProps;
export function withGetUserSearches<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetUserSearchesQuery,
    GetUserSearchesQueryVariables,
    GetUserSearchesProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetUserSearchesQuery,
    GetUserSearchesQueryVariables,
    GetUserSearchesProps<TChildProps>
  >(GetUserSearchesDocument, {
    alias: 'getUserSearches',
    ...operationOptions,
  });
}

/**
 * __useGetUserSearchesQuery__
 *
 * To run a query within a React component, call `useGetUserSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSearchesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserSearchesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetUserSearchesQuery,
    GetUserSearchesQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<GetUserSearchesQuery, GetUserSearchesQueryVariables>(
    GetUserSearchesDocument,
    baseOptions,
  );
}
export function useGetUserSearchesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetUserSearchesQuery,
    GetUserSearchesQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GetUserSearchesQuery, GetUserSearchesQueryVariables>(
    GetUserSearchesDocument,
    baseOptions,
  );
}
export type GetUserSearchesQueryHookResult = ReturnType<typeof useGetUserSearchesQuery>;
export type GetUserSearchesLazyQueryHookResult = ReturnType<typeof useGetUserSearchesLazyQuery>;
export type GetUserSearchesQueryResult = ApolloReactCommon.QueryResult<
  GetUserSearchesQuery,
  GetUserSearchesQueryVariables
>;
export const GetUserSocialConnectionsDocument = gql`
  query GET_USER_SOCIAL_CONNECTIONS($user_id: String!) {
    getUserSocialConnections(user_id: $user_id) {
      count
      items {
        id
        provider
        identifier
        profile_name
        reach
        expires_soon
        profile_url
      }
    }
  }
`;
export type GetUserSocialConnectionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    GetUserSocialConnectionsQuery,
    GetUserSocialConnectionsQueryVariables
  >,
  'query'
> &
  ({ variables: GetUserSocialConnectionsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetUserSocialConnectionsComponent = (
  props: GetUserSocialConnectionsComponentProps,
) => (
  <ApolloReactComponents.Query<
    GetUserSocialConnectionsQuery,
    GetUserSocialConnectionsQueryVariables
  >
    query={GetUserSocialConnectionsDocument}
    {...props}
  />
);

export type GetUserSocialConnectionsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetUserSocialConnectionsQuery,
  GetUserSocialConnectionsQueryVariables
> &
  TChildProps;
export function withGetUserSocialConnections<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetUserSocialConnectionsQuery,
    GetUserSocialConnectionsQueryVariables,
    GetUserSocialConnectionsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetUserSocialConnectionsQuery,
    GetUserSocialConnectionsQueryVariables,
    GetUserSocialConnectionsProps<TChildProps>
  >(GetUserSocialConnectionsDocument, {
    alias: 'getUserSocialConnections',
    ...operationOptions,
  });
}

/**
 * __useGetUserSocialConnectionsQuery__
 *
 * To run a query within a React component, call `useGetUserSocialConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSocialConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSocialConnectionsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetUserSocialConnectionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetUserSocialConnectionsQuery,
    GetUserSocialConnectionsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetUserSocialConnectionsQuery,
    GetUserSocialConnectionsQueryVariables
  >(GetUserSocialConnectionsDocument, baseOptions);
}
export function useGetUserSocialConnectionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetUserSocialConnectionsQuery,
    GetUserSocialConnectionsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetUserSocialConnectionsQuery,
    GetUserSocialConnectionsQueryVariables
  >(GetUserSocialConnectionsDocument, baseOptions);
}
export type GetUserSocialConnectionsQueryHookResult = ReturnType<
  typeof useGetUserSocialConnectionsQuery
>;
export type GetUserSocialConnectionsLazyQueryHookResult = ReturnType<
  typeof useGetUserSocialConnectionsLazyQuery
>;
export type GetUserSocialConnectionsQueryResult = ApolloReactCommon.QueryResult<
  GetUserSocialConnectionsQuery,
  GetUserSocialConnectionsQueryVariables
>;
export const RecommendContentDocument = gql`
  query RECOMMEND_CONTENT($size: Int!, $results_from: Int!) {
    recommendContent(
      size: $size
      results_from: $results_from
      for_sharing: true
      auto_restrict_groups: true
      auto_exclude_sharing: true
      auto_weight_groups: true
    ) {
      count
      results_from
      results {
        ...ContentShare
      }
    }
  }
  ${ContentShareFragmentDoc}
`;
export type RecommendContentComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    RecommendContentQuery,
    RecommendContentQueryVariables
  >,
  'query'
> &
  ({ variables: RecommendContentQueryVariables; skip?: boolean } | { skip: boolean });

export const RecommendContentComponent = (props: RecommendContentComponentProps) => (
  <ApolloReactComponents.Query<RecommendContentQuery, RecommendContentQueryVariables>
    query={RecommendContentDocument}
    {...props}
  />
);

export type RecommendContentProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  RecommendContentQuery,
  RecommendContentQueryVariables
> &
  TChildProps;
export function withRecommendContent<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    RecommendContentQuery,
    RecommendContentQueryVariables,
    RecommendContentProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    RecommendContentQuery,
    RecommendContentQueryVariables,
    RecommendContentProps<TChildProps>
  >(RecommendContentDocument, {
    alias: 'recommendContent',
    ...operationOptions,
  });
}

/**
 * __useRecommendContentQuery__
 *
 * To run a query within a React component, call `useRecommendContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendContentQuery({
 *   variables: {
 *      size: // value for 'size'
 *      results_from: // value for 'results_from'
 *   },
 * });
 */
export function useRecommendContentQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RecommendContentQuery,
    RecommendContentQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<RecommendContentQuery, RecommendContentQueryVariables>(
    RecommendContentDocument,
    baseOptions,
  );
}
export function useRecommendContentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecommendContentQuery,
    RecommendContentQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<RecommendContentQuery, RecommendContentQueryVariables>(
    RecommendContentDocument,
    baseOptions,
  );
}
export type RecommendContentQueryHookResult = ReturnType<typeof useRecommendContentQuery>;
export type RecommendContentLazyQueryHookResult = ReturnType<typeof useRecommendContentLazyQuery>;
export type RecommendContentQueryResult = ApolloReactCommon.QueryResult<
  RecommendContentQuery,
  RecommendContentQueryVariables
>;
export const SearchDocument = gql`
  query SEARCH($size: Int!, $results_from: Int!, $q: String) {
    search(
      documents: [groups, profiles, content]
      size: $size
      results_from: $results_from
      q: $q
      q_documents_must_match: [groups, profiles, content]
      auto_exclude: true
    ) {
      count
      results {
        ... on Group {
          id
          title
          follower_count
          department_title
          location_title
        }
        ... on PublicUserProfile {
          id
          full_name
          follower_count
          department_title
          location_title
        }
        ... on Content {
          content_id
          publish_at
          groups {
            ...GetFeedGroup
          }
          user {
            full_name
          }
          content_object {
            body
            url
            url_metadata {
              provider_name
              title
              description
            }
            photos {
              bucket
            }
          }
        }
      }
    }
  }
  ${GetFeedGroupFragmentDoc}
`;
export type SearchComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<SearchQuery, SearchQueryVariables>,
  'query'
> &
  ({ variables: SearchQueryVariables; skip?: boolean } | { skip: boolean });

export const SearchComponent = (props: SearchComponentProps) => (
  <ApolloReactComponents.Query<SearchQuery, SearchQueryVariables>
    query={SearchDocument}
    {...props}
  />
);

export type SearchProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  SearchQuery,
  SearchQueryVariables
> &
  TChildProps;
export function withSearch<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    SearchQuery,
    SearchQueryVariables,
    SearchProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    SearchQuery,
    SearchQueryVariables,
    SearchProps<TChildProps>
  >(SearchDocument, {
    alias: 'search',
    ...operationOptions,
  });
}

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      size: // value for 'size'
 *      results_from: // value for 'results_from'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useSearchQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<SearchQuery, SearchQueryVariables>,
) {
  return ApolloReactHooks.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, baseOptions);
}
export function useSearchLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<SearchQuery, SearchQueryVariables>(
    SearchDocument,
    baseOptions,
  );
}
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = ApolloReactCommon.QueryResult<SearchQuery, SearchQueryVariables>;
export const SearchGroupsDocument = gql`
  query SEARCH_GROUPS(
    $size: Int!
    $results_from: Int!
    $q: String
    $auto_exclude: Boolean
    $sort: SearchSortFields
    $sort_direction: SearchSortDirections
    $required_location_id: ID
    $required_department_id: ID
  ) {
    search(
      documents: [groups]
      size: $size
      results_from: $results_from
      q: $q
      q_documents_must_match: [groups]
      auto_exclude: $auto_exclude
      sort: $sort
      sort_direction: $sort_direction
      required_location_id: $required_location_id
      required_department_id: $required_department_id
    ) {
      ...GroupSearchResults
    }
  }
  ${GroupSearchResultsFragmentDoc}
`;
export type SearchGroupsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<SearchGroupsQuery, SearchGroupsQueryVariables>,
  'query'
> &
  ({ variables: SearchGroupsQueryVariables; skip?: boolean } | { skip: boolean });

export const SearchGroupsComponent = (props: SearchGroupsComponentProps) => (
  <ApolloReactComponents.Query<SearchGroupsQuery, SearchGroupsQueryVariables>
    query={SearchGroupsDocument}
    {...props}
  />
);

export type SearchGroupsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  SearchGroupsQuery,
  SearchGroupsQueryVariables
> &
  TChildProps;
export function withSearchGroups<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    SearchGroupsQuery,
    SearchGroupsQueryVariables,
    SearchGroupsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    SearchGroupsQuery,
    SearchGroupsQueryVariables,
    SearchGroupsProps<TChildProps>
  >(SearchGroupsDocument, {
    alias: 'searchGroups',
    ...operationOptions,
  });
}

/**
 * __useSearchGroupsQuery__
 *
 * To run a query within a React component, call `useSearchGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchGroupsQuery({
 *   variables: {
 *      size: // value for 'size'
 *      results_from: // value for 'results_from'
 *      q: // value for 'q'
 *      auto_exclude: // value for 'auto_exclude'
 *      sort: // value for 'sort'
 *      sort_direction: // value for 'sort_direction'
 *      required_location_id: // value for 'required_location_id'
 *      required_department_id: // value for 'required_department_id'
 *   },
 * });
 */
export function useSearchGroupsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<SearchGroupsQuery, SearchGroupsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<SearchGroupsQuery, SearchGroupsQueryVariables>(
    SearchGroupsDocument,
    baseOptions,
  );
}
export function useSearchGroupsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchGroupsQuery,
    SearchGroupsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<SearchGroupsQuery, SearchGroupsQueryVariables>(
    SearchGroupsDocument,
    baseOptions,
  );
}
export type SearchGroupsQueryHookResult = ReturnType<typeof useSearchGroupsQuery>;
export type SearchGroupsLazyQueryHookResult = ReturnType<typeof useSearchGroupsLazyQuery>;
export type SearchGroupsQueryResult = ApolloReactCommon.QueryResult<
  SearchGroupsQuery,
  SearchGroupsQueryVariables
>;
export const SearchPeopleDocument = gql`
  query SEARCH_PEOPLE(
    $size: Int!
    $results_from: Int!
    $q: String
    $auto_exclude: Boolean
    $sort: SearchSortFields
    $sort_direction: SearchSortDirections
    $required_location_id: ID
    $required_department_id: ID
  ) {
    search(
      documents: [profiles]
      size: $size
      results_from: $results_from
      q: $q
      q_documents_must_match: [profiles]
      auto_exclude: $auto_exclude
      sort: $sort
      sort_direction: $sort_direction
      required_location_id: $required_location_id
      required_department_id: $required_department_id
    ) {
      ...ProfileSearchResults
    }
  }
  ${ProfileSearchResultsFragmentDoc}
`;
export type SearchPeopleComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<SearchPeopleQuery, SearchPeopleQueryVariables>,
  'query'
> &
  ({ variables: SearchPeopleQueryVariables; skip?: boolean } | { skip: boolean });

export const SearchPeopleComponent = (props: SearchPeopleComponentProps) => (
  <ApolloReactComponents.Query<SearchPeopleQuery, SearchPeopleQueryVariables>
    query={SearchPeopleDocument}
    {...props}
  />
);

export type SearchPeopleProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  SearchPeopleQuery,
  SearchPeopleQueryVariables
> &
  TChildProps;
export function withSearchPeople<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    SearchPeopleQuery,
    SearchPeopleQueryVariables,
    SearchPeopleProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    SearchPeopleQuery,
    SearchPeopleQueryVariables,
    SearchPeopleProps<TChildProps>
  >(SearchPeopleDocument, {
    alias: 'searchPeople',
    ...operationOptions,
  });
}

/**
 * __useSearchPeopleQuery__
 *
 * To run a query within a React component, call `useSearchPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPeopleQuery({
 *   variables: {
 *      size: // value for 'size'
 *      results_from: // value for 'results_from'
 *      q: // value for 'q'
 *      auto_exclude: // value for 'auto_exclude'
 *      sort: // value for 'sort'
 *      sort_direction: // value for 'sort_direction'
 *      required_location_id: // value for 'required_location_id'
 *      required_department_id: // value for 'required_department_id'
 *   },
 * });
 */
export function useSearchPeopleQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<SearchPeopleQuery, SearchPeopleQueryVariables>,
) {
  return ApolloReactHooks.useQuery<SearchPeopleQuery, SearchPeopleQueryVariables>(
    SearchPeopleDocument,
    baseOptions,
  );
}
export function useSearchPeopleLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchPeopleQuery,
    SearchPeopleQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<SearchPeopleQuery, SearchPeopleQueryVariables>(
    SearchPeopleDocument,
    baseOptions,
  );
}
export type SearchPeopleQueryHookResult = ReturnType<typeof useSearchPeopleQuery>;
export type SearchPeopleLazyQueryHookResult = ReturnType<typeof useSearchPeopleLazyQuery>;
export type SearchPeopleQueryResult = ApolloReactCommon.QueryResult<
  SearchPeopleQuery,
  SearchPeopleQueryVariables
>;
export const SearchAggregatesDocument = gql`
  query SEARCH_AGGREGATES {
    searchAggregates(document: groups) {
      departments {
        id
        title
      }
      locations {
        id
        title
      }
    }
  }
`;
export type SearchAggregatesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    SearchAggregatesQuery,
    SearchAggregatesQueryVariables
  >,
  'query'
>;

export const SearchAggregatesComponent = (props: SearchAggregatesComponentProps) => (
  <ApolloReactComponents.Query<SearchAggregatesQuery, SearchAggregatesQueryVariables>
    query={SearchAggregatesDocument}
    {...props}
  />
);

export type SearchAggregatesProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  SearchAggregatesQuery,
  SearchAggregatesQueryVariables
> &
  TChildProps;
export function withSearchAggregates<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    SearchAggregatesQuery,
    SearchAggregatesQueryVariables,
    SearchAggregatesProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    SearchAggregatesQuery,
    SearchAggregatesQueryVariables,
    SearchAggregatesProps<TChildProps>
  >(SearchAggregatesDocument, {
    alias: 'searchAggregates',
    ...operationOptions,
  });
}

/**
 * __useSearchAggregatesQuery__
 *
 * To run a query within a React component, call `useSearchAggregatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAggregatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAggregatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchAggregatesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SearchAggregatesQuery,
    SearchAggregatesQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<SearchAggregatesQuery, SearchAggregatesQueryVariables>(
    SearchAggregatesDocument,
    baseOptions,
  );
}
export function useSearchAggregatesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchAggregatesQuery,
    SearchAggregatesQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<SearchAggregatesQuery, SearchAggregatesQueryVariables>(
    SearchAggregatesDocument,
    baseOptions,
  );
}
export type SearchAggregatesQueryHookResult = ReturnType<typeof useSearchAggregatesQuery>;
export type SearchAggregatesLazyQueryHookResult = ReturnType<typeof useSearchAggregatesLazyQuery>;
export type SearchAggregatesQueryResult = ApolloReactCommon.QueryResult<
  SearchAggregatesQuery,
  SearchAggregatesQueryVariables
>;
export const SearchSuggestDocument = gql`
  query SEARCH_SUGGEST($prefix: String!) {
    suggest(prefix: $prefix) {
      results {
        ... on GroupSuggestion {
          id
          title
        }
        ... on ProfileSuggestion {
          id
          title
        }
      }
    }
  }
`;
export type SearchSuggestComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<SearchSuggestQuery, SearchSuggestQueryVariables>,
  'query'
> &
  ({ variables: SearchSuggestQueryVariables; skip?: boolean } | { skip: boolean });

export const SearchSuggestComponent = (props: SearchSuggestComponentProps) => (
  <ApolloReactComponents.Query<SearchSuggestQuery, SearchSuggestQueryVariables>
    query={SearchSuggestDocument}
    {...props}
  />
);

export type SearchSuggestProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  SearchSuggestQuery,
  SearchSuggestQueryVariables
> &
  TChildProps;
export function withSearchSuggest<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    SearchSuggestQuery,
    SearchSuggestQueryVariables,
    SearchSuggestProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    SearchSuggestQuery,
    SearchSuggestQueryVariables,
    SearchSuggestProps<TChildProps>
  >(SearchSuggestDocument, {
    alias: 'searchSuggest',
    ...operationOptions,
  });
}

/**
 * __useSearchSuggestQuery__
 *
 * To run a query within a React component, call `useSearchSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuggestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuggestQuery({
 *   variables: {
 *      prefix: // value for 'prefix'
 *   },
 * });
 */
export function useSearchSuggestQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<SearchSuggestQuery, SearchSuggestQueryVariables>,
) {
  return ApolloReactHooks.useQuery<SearchSuggestQuery, SearchSuggestQueryVariables>(
    SearchSuggestDocument,
    baseOptions,
  );
}
export function useSearchSuggestLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchSuggestQuery,
    SearchSuggestQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<SearchSuggestQuery, SearchSuggestQueryVariables>(
    SearchSuggestDocument,
    baseOptions,
  );
}
export type SearchSuggestQueryHookResult = ReturnType<typeof useSearchSuggestQuery>;
export type SearchSuggestLazyQueryHookResult = ReturnType<typeof useSearchSuggestLazyQuery>;
export type SearchSuggestQueryResult = ApolloReactCommon.QueryResult<
  SearchSuggestQuery,
  SearchSuggestQueryVariables
>;
export const GroupSuggestDocument = gql`
  query GROUP_SUGGEST($prefix: String!, $index: SuggestIndex!) {
    suggest(prefix: $prefix, index: $index) {
      results {
        ... on GroupSuggestion {
          id
          title
          color
          icon_color
          icon
          color_map {
            hex
          }
          icon_color_map {
            hex
          }
          icon_map {
            bucket
            file_key
            width
            height
          }
          image {
            bucket
            key
            width
            height
          }
        }
      }
    }
  }
`;
export type GroupSuggestComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GroupSuggestQuery, GroupSuggestQueryVariables>,
  'query'
> &
  ({ variables: GroupSuggestQueryVariables; skip?: boolean } | { skip: boolean });

export const GroupSuggestComponent = (props: GroupSuggestComponentProps) => (
  <ApolloReactComponents.Query<GroupSuggestQuery, GroupSuggestQueryVariables>
    query={GroupSuggestDocument}
    {...props}
  />
);

export type GroupSuggestProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GroupSuggestQuery,
  GroupSuggestQueryVariables
> &
  TChildProps;
export function withGroupSuggest<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GroupSuggestQuery,
    GroupSuggestQueryVariables,
    GroupSuggestProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GroupSuggestQuery,
    GroupSuggestQueryVariables,
    GroupSuggestProps<TChildProps>
  >(GroupSuggestDocument, {
    alias: 'groupSuggest',
    ...operationOptions,
  });
}

/**
 * __useGroupSuggestQuery__
 *
 * To run a query within a React component, call `useGroupSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupSuggestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupSuggestQuery({
 *   variables: {
 *      prefix: // value for 'prefix'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useGroupSuggestQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GroupSuggestQuery, GroupSuggestQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GroupSuggestQuery, GroupSuggestQueryVariables>(
    GroupSuggestDocument,
    baseOptions,
  );
}
export function useGroupSuggestLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GroupSuggestQuery,
    GroupSuggestQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<GroupSuggestQuery, GroupSuggestQueryVariables>(
    GroupSuggestDocument,
    baseOptions,
  );
}
export type GroupSuggestQueryHookResult = ReturnType<typeof useGroupSuggestQuery>;
export type GroupSuggestLazyQueryHookResult = ReturnType<typeof useGroupSuggestLazyQuery>;
export type GroupSuggestQueryResult = ApolloReactCommon.QueryResult<
  GroupSuggestQuery,
  GroupSuggestQueryVariables
>;
export const UserSuggestDocument = gql`
  query USER_SUGGEST($prefix: String!, $index: SuggestIndex!) {
    suggest(prefix: $prefix, index: $index) {
      results {
        ... on ProfileSuggestion {
          id
          title
          image {
            bucket
            key
            width
            height
          }
        }
      }
    }
  }
`;
export type UserSuggestComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<UserSuggestQuery, UserSuggestQueryVariables>,
  'query'
> &
  ({ variables: UserSuggestQueryVariables; skip?: boolean } | { skip: boolean });

export const UserSuggestComponent = (props: UserSuggestComponentProps) => (
  <ApolloReactComponents.Query<UserSuggestQuery, UserSuggestQueryVariables>
    query={UserSuggestDocument}
    {...props}
  />
);

export type UserSuggestProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  UserSuggestQuery,
  UserSuggestQueryVariables
> &
  TChildProps;
export function withUserSuggest<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UserSuggestQuery,
    UserSuggestQueryVariables,
    UserSuggestProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    UserSuggestQuery,
    UserSuggestQueryVariables,
    UserSuggestProps<TChildProps>
  >(UserSuggestDocument, {
    alias: 'userSuggest',
    ...operationOptions,
  });
}

/**
 * __useUserSuggestQuery__
 *
 * To run a query within a React component, call `useUserSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSuggestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSuggestQuery({
 *   variables: {
 *      prefix: // value for 'prefix'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useUserSuggestQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<UserSuggestQuery, UserSuggestQueryVariables>,
) {
  return ApolloReactHooks.useQuery<UserSuggestQuery, UserSuggestQueryVariables>(
    UserSuggestDocument,
    baseOptions,
  );
}
export function useUserSuggestLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserSuggestQuery, UserSuggestQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<UserSuggestQuery, UserSuggestQueryVariables>(
    UserSuggestDocument,
    baseOptions,
  );
}
export type UserSuggestQueryHookResult = ReturnType<typeof useUserSuggestQuery>;
export type UserSuggestLazyQueryHookResult = ReturnType<typeof useUserSuggestLazyQuery>;
export type UserSuggestQueryResult = ApolloReactCommon.QueryResult<
  UserSuggestQuery,
  UserSuggestQueryVariables
>;
export const UserDailyStatsDocument = gql`
  query USER_DAILY_STATS($user_id: ID!, $grouping: StatsGrouping!) {
    userDailyStats(user_id: $user_id, grouping: $grouping) {
      total_posts
      total_shares
      total_clicks
      data {
        clicks
        posts
        shares
        calendar_day
      }
    }
  }
`;
export type UserDailyStatsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<UserDailyStatsQuery, UserDailyStatsQueryVariables>,
  'query'
> &
  ({ variables: UserDailyStatsQueryVariables; skip?: boolean } | { skip: boolean });

export const UserDailyStatsComponent = (props: UserDailyStatsComponentProps) => (
  <ApolloReactComponents.Query<UserDailyStatsQuery, UserDailyStatsQueryVariables>
    query={UserDailyStatsDocument}
    {...props}
  />
);

export type UserDailyStatsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  UserDailyStatsQuery,
  UserDailyStatsQueryVariables
> &
  TChildProps;
export function withUserDailyStats<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UserDailyStatsQuery,
    UserDailyStatsQueryVariables,
    UserDailyStatsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    UserDailyStatsQuery,
    UserDailyStatsQueryVariables,
    UserDailyStatsProps<TChildProps>
  >(UserDailyStatsDocument, {
    alias: 'userDailyStats',
    ...operationOptions,
  });
}

/**
 * __useUserDailyStatsQuery__
 *
 * To run a query within a React component, call `useUserDailyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDailyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDailyStatsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      grouping: // value for 'grouping'
 *   },
 * });
 */
export function useUserDailyStatsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserDailyStatsQuery,
    UserDailyStatsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<UserDailyStatsQuery, UserDailyStatsQueryVariables>(
    UserDailyStatsDocument,
    baseOptions,
  );
}
export function useUserDailyStatsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserDailyStatsQuery,
    UserDailyStatsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<UserDailyStatsQuery, UserDailyStatsQueryVariables>(
    UserDailyStatsDocument,
    baseOptions,
  );
}
export type UserDailyStatsQueryHookResult = ReturnType<typeof useUserDailyStatsQuery>;
export type UserDailyStatsLazyQueryHookResult = ReturnType<typeof useUserDailyStatsLazyQuery>;
export type UserDailyStatsQueryResult = ApolloReactCommon.QueryResult<
  UserDailyStatsQuery,
  UserDailyStatsQueryVariables
>;
export const UserEngagementStatsDocument = gql`
  query USER_ENGAGEMENT_STATS($user_id: ID!, $grouping: StatsGrouping!, $value: Int!) {
    userEngagementStats(user_id: $user_id, grouping: $grouping, value: $value) {
      clicks
      comments
      reactions
      posts
      shares
      engagements
      groups
    }
  }
`;
export type UserEngagementStatsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    UserEngagementStatsQuery,
    UserEngagementStatsQueryVariables
  >,
  'query'
> &
  ({ variables: UserEngagementStatsQueryVariables; skip?: boolean } | { skip: boolean });

export const UserEngagementStatsComponent = (props: UserEngagementStatsComponentProps) => (
  <ApolloReactComponents.Query<UserEngagementStatsQuery, UserEngagementStatsQueryVariables>
    query={UserEngagementStatsDocument}
    {...props}
  />
);

export type UserEngagementStatsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  UserEngagementStatsQuery,
  UserEngagementStatsQueryVariables
> &
  TChildProps;
export function withUserEngagementStats<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UserEngagementStatsQuery,
    UserEngagementStatsQueryVariables,
    UserEngagementStatsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    UserEngagementStatsQuery,
    UserEngagementStatsQueryVariables,
    UserEngagementStatsProps<TChildProps>
  >(UserEngagementStatsDocument, {
    alias: 'userEngagementStats',
    ...operationOptions,
  });
}

/**
 * __useUserEngagementStatsQuery__
 *
 * To run a query within a React component, call `useUserEngagementStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEngagementStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEngagementStatsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      grouping: // value for 'grouping'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUserEngagementStatsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserEngagementStatsQuery,
    UserEngagementStatsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<UserEngagementStatsQuery, UserEngagementStatsQueryVariables>(
    UserEngagementStatsDocument,
    baseOptions,
  );
}
export function useUserEngagementStatsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserEngagementStatsQuery,
    UserEngagementStatsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<UserEngagementStatsQuery, UserEngagementStatsQueryVariables>(
    UserEngagementStatsDocument,
    baseOptions,
  );
}
export type UserEngagementStatsQueryHookResult = ReturnType<typeof useUserEngagementStatsQuery>;
export type UserEngagementStatsLazyQueryHookResult = ReturnType<
  typeof useUserEngagementStatsLazyQuery
>;
export type UserEngagementStatsQueryResult = ApolloReactCommon.QueryResult<
  UserEngagementStatsQuery,
  UserEngagementStatsQueryVariables
>;
export const UserReachStatsDocument = gql`
  query USER_REACH_STATS($user_id: ID!, $grouping: StatsGrouping!, $value: Int!) {
    userReachStats(user_id: $user_id, grouping: $grouping, value: $value) {
      reach
      previous_reach
      provider
      profile_identifier
    }
  }
`;
export type UserReachStatsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<UserReachStatsQuery, UserReachStatsQueryVariables>,
  'query'
> &
  ({ variables: UserReachStatsQueryVariables; skip?: boolean } | { skip: boolean });

export const UserReachStatsComponent = (props: UserReachStatsComponentProps) => (
  <ApolloReactComponents.Query<UserReachStatsQuery, UserReachStatsQueryVariables>
    query={UserReachStatsDocument}
    {...props}
  />
);

export type UserReachStatsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  UserReachStatsQuery,
  UserReachStatsQueryVariables
> &
  TChildProps;
export function withUserReachStats<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UserReachStatsQuery,
    UserReachStatsQueryVariables,
    UserReachStatsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    UserReachStatsQuery,
    UserReachStatsQueryVariables,
    UserReachStatsProps<TChildProps>
  >(UserReachStatsDocument, {
    alias: 'userReachStats',
    ...operationOptions,
  });
}

/**
 * __useUserReachStatsQuery__
 *
 * To run a query within a React component, call `useUserReachStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserReachStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserReachStatsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      grouping: // value for 'grouping'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUserReachStatsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserReachStatsQuery,
    UserReachStatsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<UserReachStatsQuery, UserReachStatsQueryVariables>(
    UserReachStatsDocument,
    baseOptions,
  );
}
export function useUserReachStatsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserReachStatsQuery,
    UserReachStatsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<UserReachStatsQuery, UserReachStatsQueryVariables>(
    UserReachStatsDocument,
    baseOptions,
  );
}
export type UserReachStatsQueryHookResult = ReturnType<typeof useUserReachStatsQuery>;
export type UserReachStatsLazyQueryHookResult = ReturnType<typeof useUserReachStatsLazyQuery>;
export type UserReachStatsQueryResult = ApolloReactCommon.QueryResult<
  UserReachStatsQuery,
  UserReachStatsQueryVariables
>;
export const FollowedDocument = gql`
  subscription FOLLOWED($user_id: ID!) {
    followed(user_id: $user_id) {
      ...UserFeedFollow
    }
  }
  ${UserFeedFollowFragmentDoc}
`;
export type FollowedComponentProps = Omit<
  ApolloReactComponents.SubscriptionComponentOptions<
    FollowedSubscription,
    FollowedSubscriptionVariables
  >,
  'subscription'
>;

export const FollowedComponent = (props: FollowedComponentProps) => (
  <ApolloReactComponents.Subscription<FollowedSubscription, FollowedSubscriptionVariables>
    subscription={FollowedDocument}
    {...props}
  />
);

export type FollowedProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  FollowedSubscription,
  FollowedSubscriptionVariables
> &
  TChildProps;
export function withFollowed<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    FollowedSubscription,
    FollowedSubscriptionVariables,
    FollowedProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withSubscription<
    TProps,
    FollowedSubscription,
    FollowedSubscriptionVariables,
    FollowedProps<TChildProps>
  >(FollowedDocument, {
    alias: 'followed',
    ...operationOptions,
  });
}

/**
 * __useFollowedSubscription__
 *
 * To run a query within a React component, call `useFollowedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFollowedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowedSubscription({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useFollowedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    FollowedSubscription,
    FollowedSubscriptionVariables
  >,
) {
  return ApolloReactHooks.useSubscription<FollowedSubscription, FollowedSubscriptionVariables>(
    FollowedDocument,
    baseOptions,
  );
}
export type FollowedSubscriptionHookResult = ReturnType<typeof useFollowedSubscription>;
export type FollowedSubscriptionResult = ApolloReactCommon.SubscriptionResult<FollowedSubscription>;
export const InboxItemCreatedDocument = gql`
  subscription INBOX_ITEM_CREATED($user_id: ID!) {
    inboxItemCreated(to_user_id: $user_id) {
      ...Inbox
    }
  }
  ${InboxFragmentDoc}
`;
export type InboxItemCreatedComponentProps = Omit<
  ApolloReactComponents.SubscriptionComponentOptions<
    InboxItemCreatedSubscription,
    InboxItemCreatedSubscriptionVariables
  >,
  'subscription'
>;

export const InboxItemCreatedComponent = (props: InboxItemCreatedComponentProps) => (
  <ApolloReactComponents.Subscription<
    InboxItemCreatedSubscription,
    InboxItemCreatedSubscriptionVariables
  >
    subscription={InboxItemCreatedDocument}
    {...props}
  />
);

export type InboxItemCreatedProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  InboxItemCreatedSubscription,
  InboxItemCreatedSubscriptionVariables
> &
  TChildProps;
export function withInboxItemCreated<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    InboxItemCreatedSubscription,
    InboxItemCreatedSubscriptionVariables,
    InboxItemCreatedProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withSubscription<
    TProps,
    InboxItemCreatedSubscription,
    InboxItemCreatedSubscriptionVariables,
    InboxItemCreatedProps<TChildProps>
  >(InboxItemCreatedDocument, {
    alias: 'inboxItemCreated',
    ...operationOptions,
  });
}

/**
 * __useInboxItemCreatedSubscription__
 *
 * To run a query within a React component, call `useInboxItemCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInboxItemCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxItemCreatedSubscription({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useInboxItemCreatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    InboxItemCreatedSubscription,
    InboxItemCreatedSubscriptionVariables
  >,
) {
  return ApolloReactHooks.useSubscription<
    InboxItemCreatedSubscription,
    InboxItemCreatedSubscriptionVariables
  >(InboxItemCreatedDocument, baseOptions);
}
export type InboxItemCreatedSubscriptionHookResult = ReturnType<
  typeof useInboxItemCreatedSubscription
>;
export type InboxItemCreatedSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  InboxItemCreatedSubscription
>;
export const UnfollowedDocument = gql`
  subscription UNFOLLOWED($user_id: ID!) {
    unfollowed(user_id: $user_id) {
      ...UserFeedFollow
    }
  }
  ${UserFeedFollowFragmentDoc}
`;
export type UnfollowedComponentProps = Omit<
  ApolloReactComponents.SubscriptionComponentOptions<
    UnfollowedSubscription,
    UnfollowedSubscriptionVariables
  >,
  'subscription'
>;

export const UnfollowedComponent = (props: UnfollowedComponentProps) => (
  <ApolloReactComponents.Subscription<UnfollowedSubscription, UnfollowedSubscriptionVariables>
    subscription={UnfollowedDocument}
    {...props}
  />
);

export type UnfollowedProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  UnfollowedSubscription,
  UnfollowedSubscriptionVariables
> &
  TChildProps;
export function withUnfollowed<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UnfollowedSubscription,
    UnfollowedSubscriptionVariables,
    UnfollowedProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withSubscription<
    TProps,
    UnfollowedSubscription,
    UnfollowedSubscriptionVariables,
    UnfollowedProps<TChildProps>
  >(UnfollowedDocument, {
    alias: 'unfollowed',
    ...operationOptions,
  });
}

/**
 * __useUnfollowedSubscription__
 *
 * To run a query within a React component, call `useUnfollowedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnfollowedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnfollowedSubscription({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useUnfollowedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    UnfollowedSubscription,
    UnfollowedSubscriptionVariables
  >,
) {
  return ApolloReactHooks.useSubscription<UnfollowedSubscription, UnfollowedSubscriptionVariables>(
    UnfollowedDocument,
    baseOptions,
  );
}
export type UnfollowedSubscriptionHookResult = ReturnType<typeof useUnfollowedSubscription>;
export type UnfollowedSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  UnfollowedSubscription
>;
export const CsUpdateClientDocument = gql`
  mutation CS_UPDATE_CLIENT($data: CSUpdateClientInput!) {
    csUpdateClient(data: $data) {
      ...ClientProtected
    }
  }
  ${ClientProtectedFragmentDoc}
`;
export type CsUpdateClientMutationFn = ApolloReactCommon.MutationFunction<
  CsUpdateClientMutation,
  CsUpdateClientMutationVariables
>;
export type CsUpdateClientComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CsUpdateClientMutation,
    CsUpdateClientMutationVariables
  >,
  'mutation'
>;

export const CsUpdateClientComponent = (props: CsUpdateClientComponentProps) => (
  <ApolloReactComponents.Mutation<CsUpdateClientMutation, CsUpdateClientMutationVariables>
    mutation={CsUpdateClientDocument}
    {...props}
  />
);

export type CsUpdateClientProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CsUpdateClientMutation,
  CsUpdateClientMutationVariables
> &
  TChildProps;
export function withCsUpdateClient<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CsUpdateClientMutation,
    CsUpdateClientMutationVariables,
    CsUpdateClientProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CsUpdateClientMutation,
    CsUpdateClientMutationVariables,
    CsUpdateClientProps<TChildProps>
  >(CsUpdateClientDocument, {
    alias: 'csUpdateClient',
    ...operationOptions,
  });
}

/**
 * __useCsUpdateClientMutation__
 *
 * To run a mutation, you first call `useCsUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csUpdateClientMutation, { data, loading, error }] = useCsUpdateClientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCsUpdateClientMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CsUpdateClientMutation,
    CsUpdateClientMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<CsUpdateClientMutation, CsUpdateClientMutationVariables>(
    CsUpdateClientDocument,
    baseOptions,
  );
}
export type CsUpdateClientMutationHookResult = ReturnType<typeof useCsUpdateClientMutation>;
export type CsUpdateClientMutationResult = ApolloReactCommon.MutationResult<CsUpdateClientMutation>;
export type CsUpdateClientMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CsUpdateClientMutation,
  CsUpdateClientMutationVariables
>;
export const CreateClientDocument = gql`
  mutation CREATE_CLIENT($data: CreateClientInput!) {
    createClient(data: $data) {
      ...ClientProtected
    }
  }
  ${ClientProtectedFragmentDoc}
`;
export type CreateClientMutationFn = ApolloReactCommon.MutationFunction<
  CreateClientMutation,
  CreateClientMutationVariables
>;
export type CreateClientComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateClientMutation,
    CreateClientMutationVariables
  >,
  'mutation'
>;

export const CreateClientComponent = (props: CreateClientComponentProps) => (
  <ApolloReactComponents.Mutation<CreateClientMutation, CreateClientMutationVariables>
    mutation={CreateClientDocument}
    {...props}
  />
);

export type CreateClientProps<TChildProps = {}> = ApolloReactHoc.MutateProps<
  CreateClientMutation,
  CreateClientMutationVariables
> &
  TChildProps;
export function withCreateClient<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateClientMutation,
    CreateClientMutationVariables,
    CreateClientProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateClientMutation,
    CreateClientMutationVariables,
    CreateClientProps<TChildProps>
  >(CreateClientDocument, {
    alias: 'createClient',
    ...operationOptions,
  });
}

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateClientMutation,
    CreateClientMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<CreateClientMutation, CreateClientMutationVariables>(
    CreateClientDocument,
    baseOptions,
  );
}
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = ApolloReactCommon.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateClientMutation,
  CreateClientMutationVariables
>;
export const GetClientDocument = gql`
  query GET_CLIENT($id: ID!) {
    getClient(id: $id) {
      ...ClientProtected
    }
  }
  ${ClientProtectedFragmentDoc}
`;
export type GetClientComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetClientQuery, GetClientQueryVariables>,
  'query'
> &
  ({ variables: GetClientQueryVariables; skip?: boolean } | { skip: boolean });

export const GetClientComponent = (props: GetClientComponentProps) => (
  <ApolloReactComponents.Query<GetClientQuery, GetClientQueryVariables>
    query={GetClientDocument}
    {...props}
  />
);

export type GetClientProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetClientQuery,
  GetClientQueryVariables
> &
  TChildProps;
export function withGetClient<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetClientQuery,
    GetClientQueryVariables,
    GetClientProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetClientQuery,
    GetClientQueryVariables,
    GetClientProps<TChildProps>
  >(GetClientDocument, {
    alias: 'getClient',
    ...operationOptions,
  });
}

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetClientQuery, GetClientQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetClientQuery, GetClientQueryVariables>(
    GetClientDocument,
    baseOptions,
  );
}
export function useGetClientLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetClientQuery, GetClientQueryVariables>(
    GetClientDocument,
    baseOptions,
  );
}
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientQueryResult = ApolloReactCommon.QueryResult<
  GetClientQuery,
  GetClientQueryVariables
>;
export const GetClientsDocument = gql`
  query GET_CLIENTS($client_status: ClientStatus!) {
    getClients(client_status: $client_status) {
      ...ClientProtected
    }
  }
  ${ClientProtectedFragmentDoc}
`;
export type GetClientsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<GetClientsQuery, GetClientsQueryVariables>,
  'query'
> &
  ({ variables: GetClientsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetClientsComponent = (props: GetClientsComponentProps) => (
  <ApolloReactComponents.Query<GetClientsQuery, GetClientsQueryVariables>
    query={GetClientsDocument}
    {...props}
  />
);

export type GetClientsProps<TChildProps = {}> = ApolloReactHoc.DataProps<
  GetClientsQuery,
  GetClientsQueryVariables
> &
  TChildProps;
export function withGetClients<TProps, TChildProps = {}>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    GetClientsQuery,
    GetClientsQueryVariables,
    GetClientsProps<TChildProps>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    GetClientsQuery,
    GetClientsQueryVariables,
    GetClientsProps<TChildProps>
  >(GetClientsDocument, {
    alias: 'getClients',
    ...operationOptions,
  });
}

/**
 * __useGetClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsQuery({
 *   variables: {
 *      client_status: // value for 'client_status'
 *   },
 * });
 */
export function useGetClientsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetClientsQuery, GetClientsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetClientsQuery, GetClientsQueryVariables>(
    GetClientsDocument,
    baseOptions,
  );
}
export function useGetClientsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetClientsQuery, GetClientsQueryVariables>(
    GetClientsDocument,
    baseOptions,
  );
}
export type GetClientsQueryHookResult = ReturnType<typeof useGetClientsQuery>;
export type GetClientsLazyQueryHookResult = ReturnType<typeof useGetClientsLazyQuery>;
export type GetClientsQueryResult = ApolloReactCommon.QueryResult<
  GetClientsQuery,
  GetClientsQueryVariables
>;
